(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("xcomponent", [], factory);
	else if(typeof exports === 'object')
		exports["xcomponent"] = factory();
	else
		root["xcomponent"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 36);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getActualDomain;
/* harmony export (immutable) */ __webpack_exports__["f"] = getDomain;
/* unused harmony export isBlankDomain */
/* harmony export (immutable) */ __webpack_exports__["l"] = isActuallySameDomain;
/* harmony export (immutable) */ __webpack_exports__["p"] = isSameDomain;
/* harmony export (immutable) */ __webpack_exports__["j"] = getParent;
/* harmony export (immutable) */ __webpack_exports__["i"] = getOpener;
/* unused harmony export getParents */
/* unused harmony export isAncestorParent */
/* unused harmony export getFrames */
/* unused harmony export getAllChildFrames */
/* harmony export (immutable) */ __webpack_exports__["k"] = getTop;
/* harmony export (immutable) */ __webpack_exports__["c"] = getAllFramesInWindow;
/* harmony export (immutable) */ __webpack_exports__["r"] = isTop;
/* unused harmony export isFrameWindowClosed */
/* harmony export (immutable) */ __webpack_exports__["t"] = isWindowClosed;
/* harmony export (immutable) */ __webpack_exports__["u"] = linkFrameWindow;
/* unused harmony export getUserAgent */
/* unused harmony export getFrameByName */
/* unused harmony export findChildFrameByName */
/* harmony export (immutable) */ __webpack_exports__["a"] = findFrameByName;
/* unused harmony export isParent */
/* unused harmony export isOpener */
/* harmony export (immutable) */ __webpack_exports__["d"] = getAncestor;
/* unused harmony export getAncestors */
/* harmony export (immutable) */ __webpack_exports__["m"] = isAncestor;
/* harmony export (immutable) */ __webpack_exports__["o"] = isPopup;
/* harmony export (immutable) */ __webpack_exports__["n"] = isIframe;
/* unused harmony export isFullpage */
/* harmony export (immutable) */ __webpack_exports__["e"] = getDistanceFromTop;
/* unused harmony export getNthParent */
/* harmony export (immutable) */ __webpack_exports__["h"] = getNthParentFromTop;
/* harmony export (immutable) */ __webpack_exports__["q"] = isSameTopWindow;
/* harmony export (immutable) */ __webpack_exports__["v"] = matchDomain;
/* harmony export (immutable) */ __webpack_exports__["g"] = getDomainFromUrl;
/* harmony export (immutable) */ __webpack_exports__["w"] = onCloseWindow;
/* harmony export (immutable) */ __webpack_exports__["s"] = isWindow;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(42);


var CONSTANTS = {
    MOCK_PROTOCOL: 'mock:',
    FILE_PROTOCOL: 'file:',
    WILDCARD: '*'
};

var IE_WIN_ACCESS_ERROR = 'Call was rejected by callee.\r\n';

function getActualDomain(win) {

    var location = win.location;

    if (!location) {
        throw new Error('Can not read window location');
    }

    var protocol = location.protocol;

    if (!protocol) {
        throw new Error('Can not read window protocol');
    }

    if (protocol === CONSTANTS.FILE_PROTOCOL) {
        return 'file://';
    }

    var host = location.host;

    if (!host) {
        throw new Error('Can not read window host');
    }

    return protocol + '//' + host;
}

function getDomain(win) {

    win = win || window;

    var domain = getActualDomain(win);

    if (domain && win.mockDomain && win.mockDomain.indexOf(CONSTANTS.MOCK_PROTOCOL) === 0) {
        return win.mockDomain;
    }

    return domain;
}

function isBlankDomain(win) {
    try {
        if (!win.location.href) {
            return true;
        }

        if (win.location.href === 'about:blank') {
            return true;
        }
    } catch (err) {
        // pass
    }

    return false;
}

function isActuallySameDomain(win) {

    try {
        var desc = Object.getOwnPropertyDescriptor(win, 'location');

        if (desc && desc.enumerable === false) {
            return false;
        }
    } catch (err) {
        // pass
    }

    try {
        if (isBlankDomain(win)) {
            return true;
        }

        // $FlowFixMe
        if (getActualDomain(win) === getActualDomain(window)) {
            return true;
        }
    } catch (err) {
        // pass
    }

    return false;
}

function isSameDomain(win) {

    if (!isActuallySameDomain(win)) {
        return false;
    }

    try {

        if (isBlankDomain(win)) {
            return true;
        }

        // $FlowFixMe
        if (getDomain(window) === getDomain(win)) {
            return true;
        }
    } catch (err) {
        // pass
    }

    return false;
}

function getParent(win) {

    if (!win) {
        return;
    }

    try {
        if (win.parent && win.parent !== win) {
            return win.parent;
        }
    } catch (err) {
        return;
    }
}

function getOpener(win) {

    if (!win) {
        return;
    }

    // Make sure we're not actually an iframe which has had window.open() called on us
    if (getParent(win)) {
        return;
    }

    try {
        return win.opener;
    } catch (err) {
        return;
    }
}

function getParents(win) {

    var result = [];

    try {

        while (win.parent !== win) {
            result.push(win.parent);
            win = win.parent;
        }
    } catch (err) {
        // pass
    }

    return result;
}

function isAncestorParent(parent, child) {

    if (!parent || !child) {
        return false;
    }

    var childParent = getParent(child);

    if (childParent) {
        return childParent === parent;
    }

    if (getParents(child).indexOf(parent) !== -1) {
        return true;
    }

    return false;
}

function getFrames(win) {

    var result = [];

    var frames = void 0;

    try {
        frames = win.frames;
    } catch (err) {
        frames = win;
    }

    var len = void 0;

    try {
        len = frames.length;
    } catch (err) {
        // pass
    }

    if (len === 0) {
        return result;
    }

    if (len) {
        for (var i = 0; i < len; i++) {

            var frame = void 0;

            try {
                frame = frames[i];
            } catch (err) {
                continue;
            }

            result.push(frame);
        }

        return result;
    }

    for (var _i = 0; _i < 100; _i++) {
        var _frame = void 0;

        try {
            _frame = frames[_i];
        } catch (err) {
            return result;
        }

        if (!_frame) {
            return result;
        }

        result.push(_frame);
    }

    return result;
}

function getAllChildFrames(win) {

    var result = [];

    for (var _iterator = getFrames(win), _isArray = Array.isArray(_iterator), _i2 = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
        var _ref;

        if (_isArray) {
            if (_i2 >= _iterator.length) break;
            _ref = _iterator[_i2++];
        } else {
            _i2 = _iterator.next();
            if (_i2.done) break;
            _ref = _i2.value;
        }

        var frame = _ref;

        result.push(frame);

        for (var _iterator2 = getAllChildFrames(frame), _isArray2 = Array.isArray(_iterator2), _i3 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
            var _ref2;

            if (_isArray2) {
                if (_i3 >= _iterator2.length) break;
                _ref2 = _iterator2[_i3++];
            } else {
                _i3 = _iterator2.next();
                if (_i3.done) break;
                _ref2 = _i3.value;
            }

            var childFrame = _ref2;

            result.push(childFrame);
        }
    }

    return result;
}

function getTop(win) {

    if (!win) {
        return;
    }

    try {
        if (win.top) {
            return win.top;
        }
    } catch (err) {
        // pass
    }

    if (getParent(win) === win) {
        return win;
    }

    try {
        if (isAncestorParent(window, win) && window.top) {
            return window.top;
        }
    } catch (err) {
        // pass
    }

    try {
        if (isAncestorParent(win, window) && window.top) {
            return window.top;
        }
    } catch (err) {
        // pass
    }

    for (var _iterator3 = getAllChildFrames(win), _isArray3 = Array.isArray(_iterator3), _i4 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
        var _ref3;

        if (_isArray3) {
            if (_i4 >= _iterator3.length) break;
            _ref3 = _iterator3[_i4++];
        } else {
            _i4 = _iterator3.next();
            if (_i4.done) break;
            _ref3 = _i4.value;
        }

        var frame = _ref3;

        try {
            if (frame.top) {
                return frame.top;
            }
        } catch (err) {
            // pass
        }

        if (getParent(frame) === frame) {
            return frame;
        }
    }
}

function getAllFramesInWindow(win) {
    var top = getTop(win);
    // $FlowFixMe
    return getAllChildFrames(top).concat(top);
}

function isTop(win) {
    return win === getTop(win);
}

function isFrameWindowClosed(frame) {

    if (!frame.contentWindow) {
        return true;
    }

    if (!frame.parentNode) {
        return true;
    }

    var doc = frame.ownerDocument;

    if (doc && doc.body && !doc.body.contains(frame)) {
        return true;
    }

    return false;
}

function safeIndexOf(collection, item) {
    for (var i = 0; i < collection.length; i++) {

        try {
            if (collection[i] === item) {
                return i;
            }
        } catch (err) {
            // pass
        }
    }

    return -1;
}

var iframeWindows = [];
var iframeFrames = [];

function isWindowClosed(win) {
    var allowMock = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;


    try {
        if (win === window) {
            return false;
        }
    } catch (err) {
        return true;
    }

    try {
        if (!win) {
            return true;
        }
    } catch (err) {
        return true;
    }

    try {
        if (win.closed) {
            return true;
        }
    } catch (err) {

        // I love you so much IE

        if (err && err.message === IE_WIN_ACCESS_ERROR) {
            return false;
        }

        return true;
    }

    if (allowMock && isSameDomain(win)) {
        try {
            if (win.mockclosed) {
                return true;
            }
        } catch (err) {
            // pass
        }
    }

    // Mobile safari

    try {
        if (!win.parent || !win.top) {
            return true;
        }
    } catch (err) {}
    // pass


    // Yes, this actually happens in IE. win === win errors out when the window
    // is from an iframe, and the iframe was removed from the page.

    try {
        Object(__WEBPACK_IMPORTED_MODULE_0__util__["b" /* noop */])(win === win); // eslint-disable-line no-self-compare
    } catch (err) {
        return true;
    }

    // IE orphaned frame

    var iframeIndex = safeIndexOf(iframeWindows, win);

    if (iframeIndex !== -1) {
        var frame = iframeFrames[iframeIndex];

        if (frame && isFrameWindowClosed(frame)) {
            return true;
        }
    }

    return false;
}

function cleanIframes() {

    for (var i = 0; i < iframeFrames.length; i++) {
        if (isFrameWindowClosed(iframeFrames[i])) {
            iframeFrames.splice(i, 1);
            iframeWindows.splice(i, 1);
        }
    }

    for (var _i5 = 0; _i5 < iframeWindows.length; _i5++) {
        if (isWindowClosed(iframeWindows[_i5])) {
            iframeFrames.splice(_i5, 1);
            iframeWindows.splice(_i5, 1);
        }
    }
}

function linkFrameWindow(frame) {

    cleanIframes();

    if (frame && frame.contentWindow) {
        try {
            iframeWindows.push(frame.contentWindow);
            iframeFrames.push(frame);
        } catch (err) {
            // pass
        }
    }
}

function getUserAgent(win) {
    win = win || window;
    return win.navigator.mockUserAgent || win.navigator.userAgent;
}

function getFrameByName(win, name) {

    var winFrames = getFrames(win);

    for (var _iterator4 = winFrames, _isArray4 = Array.isArray(_iterator4), _i6 = 0, _iterator4 = _isArray4 ? _iterator4 : _iterator4[Symbol.iterator]();;) {
        var _ref4;

        if (_isArray4) {
            if (_i6 >= _iterator4.length) break;
            _ref4 = _iterator4[_i6++];
        } else {
            _i6 = _iterator4.next();
            if (_i6.done) break;
            _ref4 = _i6.value;
        }

        var childFrame = _ref4;

        try {
            if (isSameDomain(childFrame) && childFrame.name === name && winFrames.indexOf(childFrame) !== -1) {
                return childFrame;
            }
        } catch (err) {
            // pass
        }
    }

    try {
        // $FlowFixMe
        if (winFrames.indexOf(win.frames[name]) !== -1) {
            // $FlowFixMe
            return win.frames[name];
        }
    } catch (err) {
        // pass
    }

    try {
        if (winFrames.indexOf(win[name]) !== -1) {
            return win[name];
        }
    } catch (err) {
        // pass
    }
}

function findChildFrameByName(win, name) {

    var frame = getFrameByName(win, name);

    if (frame) {
        return frame;
    }

    for (var _iterator5 = getFrames(win), _isArray5 = Array.isArray(_iterator5), _i7 = 0, _iterator5 = _isArray5 ? _iterator5 : _iterator5[Symbol.iterator]();;) {
        var _ref5;

        if (_isArray5) {
            if (_i7 >= _iterator5.length) break;
            _ref5 = _iterator5[_i7++];
        } else {
            _i7 = _iterator5.next();
            if (_i7.done) break;
            _ref5 = _i7.value;
        }

        var childFrame = _ref5;

        var namedFrame = findChildFrameByName(childFrame, name);

        if (namedFrame) {
            return namedFrame;
        }
    }
}

function findFrameByName(win, name) {

    var frame = void 0;

    frame = getFrameByName(win, name);

    if (frame) {
        return frame;
    }

    var top = getTop(win) || win;

    return findChildFrameByName(top, name);
}

function isParent(win, frame) {

    var frameParent = getParent(frame);

    if (frameParent) {
        return frameParent === win;
    }

    for (var _iterator6 = getFrames(win), _isArray6 = Array.isArray(_iterator6), _i8 = 0, _iterator6 = _isArray6 ? _iterator6 : _iterator6[Symbol.iterator]();;) {
        var _ref6;

        if (_isArray6) {
            if (_i8 >= _iterator6.length) break;
            _ref6 = _iterator6[_i8++];
        } else {
            _i8 = _iterator6.next();
            if (_i8.done) break;
            _ref6 = _i8.value;
        }

        var childFrame = _ref6;

        if (childFrame === frame) {
            return true;
        }
    }

    return false;
}

function isOpener(parent, child) {

    return parent === getOpener(child);
}

function getAncestor(win) {
    win = win || window;

    var opener = getOpener(win);

    if (opener) {
        return opener;
    }

    var parent = getParent(win);

    if (parent) {
        return parent;
    }
}

function getAncestors(win) {

    var results = [];

    var ancestor = win;

    while (ancestor) {
        ancestor = getAncestor(ancestor);
        if (ancestor) {
            results.push(ancestor);
        }
    }

    return results;
}

function isAncestor(parent, child) {

    var actualParent = getAncestor(child);

    if (actualParent) {
        if (actualParent === parent) {
            return true;
        }

        return false;
    }

    if (child === parent) {
        return false;
    }

    if (getTop(child) === child) {
        return false;
    }

    for (var _iterator7 = getFrames(parent), _isArray7 = Array.isArray(_iterator7), _i9 = 0, _iterator7 = _isArray7 ? _iterator7 : _iterator7[Symbol.iterator]();;) {
        var _ref7;

        if (_isArray7) {
            if (_i9 >= _iterator7.length) break;
            _ref7 = _iterator7[_i9++];
        } else {
            _i9 = _iterator7.next();
            if (_i9.done) break;
            _ref7 = _i9.value;
        }

        var frame = _ref7;

        if (frame === child) {
            return true;
        }
    }

    return false;
}

function isPopup() {
    return Boolean(getOpener(window));
}

function isIframe() {
    return Boolean(getParent(window));
}

function isFullpage() {
    return Boolean(!isIframe() && !isPopup());
}

function anyMatch(collection1, collection2) {

    for (var _iterator8 = collection1, _isArray8 = Array.isArray(_iterator8), _i10 = 0, _iterator8 = _isArray8 ? _iterator8 : _iterator8[Symbol.iterator]();;) {
        var _ref8;

        if (_isArray8) {
            if (_i10 >= _iterator8.length) break;
            _ref8 = _iterator8[_i10++];
        } else {
            _i10 = _iterator8.next();
            if (_i10.done) break;
            _ref8 = _i10.value;
        }

        var item1 = _ref8;

        for (var _iterator9 = collection2, _isArray9 = Array.isArray(_iterator9), _i11 = 0, _iterator9 = _isArray9 ? _iterator9 : _iterator9[Symbol.iterator]();;) {
            var _ref9;

            if (_isArray9) {
                if (_i11 >= _iterator9.length) break;
                _ref9 = _iterator9[_i11++];
            } else {
                _i11 = _iterator9.next();
                if (_i11.done) break;
                _ref9 = _i11.value;
            }

            var item2 = _ref9;

            if (item1 === item2) {
                return true;
            }
        }
    }

    return false;
}

function getDistanceFromTop() {
    var win = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window;

    var distance = 0;
    var parent = win;

    while (parent) {
        parent = getParent(parent);
        if (parent) {
            distance += 1;
        }
    }

    return distance;
}

function getNthParent(win) {
    var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

    var parent = win;

    for (var i = 0; i < n; i++) {
        if (!parent) {
            return;
        }

        parent = getParent(parent);
    }

    return parent;
}

function getNthParentFromTop(win) {
    var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

    return getNthParent(win, getDistanceFromTop(win) - n);
}

function isSameTopWindow(win1, win2) {

    var top1 = getTop(win1) || win1;
    var top2 = getTop(win2) || win2;

    try {
        if (top1 && top2) {
            if (top1 === top2) {
                return true;
            }

            return false;
        }
    } catch (err) {
        // pass
    }

    var allFrames1 = getAllFramesInWindow(win1);
    var allFrames2 = getAllFramesInWindow(win2);

    if (anyMatch(allFrames1, allFrames2)) {
        return true;
    }

    var opener1 = getOpener(top1);
    var opener2 = getOpener(top2);

    if (opener1 && anyMatch(getAllFramesInWindow(opener1), allFrames2)) {
        return false;
    }

    if (opener2 && anyMatch(getAllFramesInWindow(opener2), allFrames1)) {
        return false;
    }

    return false;
}

function matchDomain(pattern, origin) {

    if (typeof pattern === 'string') {

        if (typeof origin === 'string') {
            return pattern === CONSTANTS.WILDCARD || origin === pattern;
        }

        if (Object(__WEBPACK_IMPORTED_MODULE_0__util__["a" /* isRegex */])(origin)) {
            return false;
        }

        if (Array.isArray(origin)) {
            return false;
        }
    }

    if (Object(__WEBPACK_IMPORTED_MODULE_0__util__["a" /* isRegex */])(pattern)) {

        if (Object(__WEBPACK_IMPORTED_MODULE_0__util__["a" /* isRegex */])(origin)) {
            return pattern.toString() === origin.toString();
        }

        if (Array.isArray(origin)) {
            return false;
        }

        // $FlowFixMe
        return Boolean(origin.match(pattern));
    }

    if (Array.isArray(pattern)) {

        if (Array.isArray(origin)) {
            return JSON.stringify(pattern) === JSON.stringify(origin);
        }

        if (Object(__WEBPACK_IMPORTED_MODULE_0__util__["a" /* isRegex */])(origin)) {
            return false;
        }

        return pattern.some(function (subpattern) {
            return matchDomain(subpattern, origin);
        });
    }

    return false;
}

function getDomainFromUrl(url) {

    var domain = void 0;

    if (url.match(/^(https?|mock|file):\/\//)) {
        domain = url;
    } else {
        return getDomain();
    }

    domain = domain.split('/').slice(0, 3).join('/');

    return domain;
}

function onCloseWindow(win, callback) {
    var delay = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1000;
    var maxtime = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : Infinity;


    var timeout = void 0;

    var check = function check() {

        if (isWindowClosed(win)) {

            if (timeout) {
                clearTimeout(timeout);
            }

            return callback();
        }

        if (maxtime <= 0) {
            clearTimeout(timeout);
        } else {
            maxtime -= delay;
            timeout = setTimeout(check, delay);
        }
    };

    check();

    return {
        cancel: function cancel() {
            if (timeout) {
                clearTimeout(timeout);
            }
        }
    };
}

function isWindow(obj) {

    try {
        if (obj === window) {
            return true;
        }
    } catch (err) {
        if (err && err.message === IE_WIN_ACCESS_ERROR) {
            return true;
        }
    }

    try {
        if (Object.prototype.toString.call(obj) === '[object Window]') {
            return true;
        }
    } catch (err) {
        if (err && err.message === IE_WIN_ACCESS_ERROR) {
            return true;
        }
    }

    try {
        if (window.Window && obj instanceof window.Window) {
            return true;
        }
    } catch (err) {
        if (err && err.message === IE_WIN_ACCESS_ERROR) {
            return true;
        }
    }

    try {
        if (obj && obj.self === obj) {
            return true;
        }
    } catch (err) {
        if (err && err.message === IE_WIN_ACCESS_ERROR) {
            return true;
        }
    }

    try {
        if (obj && obj.parent === obj) {
            return true;
        }
    } catch (err) {
        if (err && err.message === IE_WIN_ACCESS_ERROR) {
            return true;
        }
    }

    try {
        if (obj && obj.top === obj) {
            return true;
        }
    } catch (err) {
        if (err && err.message === IE_WIN_ACCESS_ERROR) {
            return true;
        }
    }

    try {
        Object(__WEBPACK_IMPORTED_MODULE_0__util__["b" /* noop */])(obj === obj); // eslint-disable-line no-self-compare
    } catch (err) {
        return true;
    }

    try {
        Object(__WEBPACK_IMPORTED_MODULE_0__util__["b" /* noop */])(obj && obj.__cross_domain_utils_window_check__);
    } catch (err) {
        return true;
    }

    return false;
}

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__promise__ = __webpack_require__(37);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__promise__["a"]; });


/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Component; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_post_robot_src__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__base__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__child__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__parent__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__delegate__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__props__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__window__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__validate__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__templates__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__drivers__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__lib__ = __webpack_require__(3);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _desc, _value, _class;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object['ke' + 'ys'](descriptor).forEach(function (key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;

    if ('value' in desc || desc.initializer) {
        desc.writable = true;
    }

    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);

    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }

    if (desc.initializer === void 0) {
        Object['define' + 'Property'](target, property, desc);
        desc = null;
    }

    return desc;
}


















/*  Component
    ---------

    This is the spec for the component. The idea is, when I call xcomponent.create(), it will create a new instance
    of Component with the blueprint needed to set up ParentComponents and ChildComponents.

    This is the one portion of code which is required by -- and shared to -- both the parent and child windows, and
    contains all of the configuration needed for them to set themselves up.
*/

var Component = (_class = function (_BaseComponent) {
    _inherits(Component, _BaseComponent);

    function Component(options) {
        _classCallCheck(this, Component);

        var _this = _possibleConstructorReturn(this, _BaseComponent.call(this));

        Object(__WEBPACK_IMPORTED_MODULE_10__validate__["a" /* validate */])(options);

        // The tag name of the component. Used by some drivers (e.g. angular) to turn the component into an html element,
        // e.g. <my-component>

        _this.addProp(options, 'tag');

        _this.addProp(options, 'defaultLogLevel', 'info');

        _this.addProp(options, 'allowedParentDomains', __WEBPACK_IMPORTED_MODULE_9__constants__["WILDCARD"]);

        // initially set log level to default log level configured when creating component
        Object(__WEBPACK_IMPORTED_MODULE_13__lib__["Q" /* setLogLevel */])(_this.defaultLogLevel);

        if (Component.components[_this.tag]) {
            throw new Error('Can not register multiple components with the same tag');
        }

        // Name of the component, used for logging. Auto-generated from the tag name by default.

        _this.addProp(options, 'name', _this.tag.replace(/-/g, '_'));

        // A json based spec describing what kind of props the component accepts. This is used to validate any props before
        // they are passed down to the child.

        _this.builtinProps = Object(__WEBPACK_IMPORTED_MODULE_7__props__["a" /* getInternalProps */])();
        _this.props = options.props || {};

        if (!options.props) {
            _this.looseProps = true;
        }

        // The dimensions of the component, e.g. { width: '300px', height: '150px' }

        _this.addProp(options, 'dimensions');
        _this.addProp(options, 'scrolling');

        _this.addProp(options, 'version', 'latest');

        // The default environment we should render to if none is specified in the parent

        _this.addProp(options, 'defaultEnv');

        // A mapping of env->url, used to determine which url to load for which env

        _this.addProp(options, 'buildUrl');

        _this.addProp(options, 'url');
        _this.addProp(options, 'domain');

        _this.addProp(options, 'bridgeUrl');
        _this.addProp(options, 'bridgeDomain');

        // A url to use by default to render the component, if not using envs


        // The allowed contexts. For example { iframe: true, popup: false }

        _this.addProp(options, 'contexts', { iframe: true, popup: false });

        // The default context to render to

        _this.addProp(options, 'defaultContext');

        // Auto Resize option

        _this.addProp(options, 'autoResize', false);

        // Templates and styles for the parent page and the initial rendering of the component

        _this.addProp(options, 'containerTemplate', __WEBPACK_IMPORTED_MODULE_11__templates__["a" /* defaultContainerTemplate */]);
        _this.addProp(options, 'prerenderTemplate', __WEBPACK_IMPORTED_MODULE_11__templates__["b" /* defaultPrerenderTemplate */]);

        _this.addProp(options, 'validate');

        // A mapping of tag->component so we can reference components by string tag name

        Component.components[_this.tag] = _this;

        // Register all of the drivers for instantiating components. The model used is -- there's a standard javascript
        // way of rendering a component, then each other technology (e.g. react) needs to hook into that interface.
        // This makes us a little more pluggable and loosely coupled.
        _this.registerDrivers();
        _this.registerChild();
        _this.listenDelegate();
        return _this;
    }

    Component.prototype.getPropNames = function getPropNames() {
        var props = Object.keys(this.props);

        for (var _iterator = Object.keys(this.builtinProps), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
            var _ref;

            if (_isArray) {
                if (_i >= _iterator.length) break;
                _ref = _iterator[_i++];
            } else {
                _i = _iterator.next();
                if (_i.done) break;
                _ref = _i.value;
            }

            var key = _ref;

            if (props.indexOf(key) === -1) {
                props.push(key);
            }
        }

        return props;
    };

    Component.prototype.getProp = function getProp(name) {
        // $FlowFixMe
        return this.props[name] || this.builtinProps[name];
    };

    Component.prototype.registerDrivers = function registerDrivers() {
        this.driverCache = {};

        for (var _iterator2 = Object.keys(__WEBPACK_IMPORTED_MODULE_12__drivers__), _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
            var _ref2;

            if (_isArray2) {
                if (_i2 >= _iterator2.length) break;
                _ref2 = _iterator2[_i2++];
            } else {
                _i2 = _iterator2.next();
                if (_i2.done) break;
                _ref2 = _i2.value;
            }

            var driverName = _ref2;

            if (driverName.indexOf('_') === 0) {
                continue;
            }

            var driver = __WEBPACK_IMPORTED_MODULE_12__drivers__[driverName];
            var glob = driver.global();
            if (glob) {
                this.driver(driverName, glob);
            }
        }
    };

    Component.prototype.driver = function driver(name, dep) {
        if (!__WEBPACK_IMPORTED_MODULE_12__drivers__[name]) {
            throw new Error('Could not find driver for framework: ' + name);
        }

        if (!this.driverCache[name]) {
            this.driverCache[name] = __WEBPACK_IMPORTED_MODULE_12__drivers__[name].register(this, dep);
        }

        return this.driverCache[name];
    };

    Component.prototype.registerChild = function registerChild() {
        if (Object(__WEBPACK_IMPORTED_MODULE_8__window__["f" /* isXComponentWindow */])()) {
            var componentMeta = Object(__WEBPACK_IMPORTED_MODULE_8__window__["b" /* getComponentMeta */])();

            if (componentMeta.tag === this.tag) {
                window.xchild = new __WEBPACK_IMPORTED_MODULE_4__child__["a" /* ChildComponent */](this);
                window.xprops = window.xchild.props;
            }
        }
    };

    Component.prototype.listenDelegate = function listenDelegate() {
        var _this2 = this;

        Object(__WEBPACK_IMPORTED_MODULE_0_post_robot_src__["on"])(__WEBPACK_IMPORTED_MODULE_9__constants__["POST_MESSAGE"].DELEGATE + '_' + this.name, function (_ref3) {
            var source = _ref3.source,
                origin = _ref3.origin,
                data = _ref3.data;


            var domain = _this2.getDomain(null, data.env || _this2.defaultEnv);

            if (!domain) {
                throw new Error('Could not determine domain to allow remote render');
            }

            if (!Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__["v" /* matchDomain */])(domain, origin)) {
                throw new Error('Can not render from ' + origin + ' - expected ' + domain.toString());
            }

            var delegate = _this2.delegate(source, data.options);

            return {
                overrides: delegate.getOverrides(data.context),
                destroy: function destroy() {
                    return delegate.destroy();
                }
            };
        });
    };

    Component.prototype.getValidDomain = function getValidDomain(url) {

        if (!url) {
            return;
        }

        var domain = Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__["g" /* getDomainFromUrl */])(url);

        if (typeof this.domain === 'string' && domain === this.domain) {
            return domain;
        }

        if (this.domain && _typeof(this.domain) === 'object') {
            for (var _iterator3 = Object.keys(this.domain), _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
                var _ref4;

                if (_isArray3) {
                    if (_i3 >= _iterator3.length) break;
                    _ref4 = _iterator3[_i3++];
                } else {
                    _i3 = _iterator3.next();
                    if (_i3.done) break;
                    _ref4 = _i3.value;
                }

                var env = _ref4;


                if (env === 'test') {
                    continue;
                }

                if (domain === this.domain[env]) {
                    return domain;
                }
            }
        }
    };

    Component.prototype.getDomain = function getDomain(url, env) {

        var domain = this.getForEnv(this.domain, env);

        if (domain) {
            return domain;
        }

        domain = this.getValidDomain(url);

        if (domain) {
            return domain;
        }

        // $FlowFixMe
        var envUrl = this.getForEnv(this.url, env);

        if (envUrl) {
            // $FlowFixMe
            return Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__["g" /* getDomainFromUrl */])(envUrl);
        }

        if (url) {
            return Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__["g" /* getDomainFromUrl */])(url);
        }
    };

    Component.prototype.getBridgeUrl = function getBridgeUrl(env) {
        // $FlowFixMe
        return this.getForEnv(this.bridgeUrl, env);
    };

    Component.prototype.getForEnv = function getForEnv(item, env) {

        if (!item) {
            return;
        }

        if (typeof item === 'string' || item instanceof RegExp) {
            return item;
        }

        if (!env) {
            env = this.defaultEnv;
        }

        if (!env) {
            return;
        }

        if (env && (typeof item === 'undefined' ? 'undefined' : _typeof(item)) === 'object' && item[env]) {
            return item[env];
        }
    };

    Component.prototype.getBridgeDomain = function getBridgeDomain(env) {

        // $FlowFixMe
        var bridgeDomain = this.getForEnv(this.bridgeDomain, env);

        if (bridgeDomain) {
            // $FlowFixMe
            return bridgeDomain;
        }

        var bridgeUrl = this.getBridgeUrl(env);

        if (bridgeUrl) {
            return Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__["g" /* getDomainFromUrl */])(bridgeUrl);
        }
    };

    Component.prototype.getUrl = function getUrl(env, props) {

        // $FlowFixMe
        var url = this.getForEnv(this.url, env);

        if (url) {
            return url;
        }

        if (this.buildUrl) {
            return this.buildUrl(props);
        }
    };

    Component.prototype.isXComponent = function isXComponent() {
        return Object(__WEBPACK_IMPORTED_MODULE_8__window__["f" /* isXComponentWindow */])();
    };

    Component.prototype.isChild = function isChild() {
        return Object(__WEBPACK_IMPORTED_MODULE_8__window__["f" /* isXComponentWindow */])() && Object(__WEBPACK_IMPORTED_MODULE_8__window__["b" /* getComponentMeta */])().tag === this.tag;
    };

    Component.prototype.createError = function createError(message, tag) {
        return new Error('[' + (tag || this.tag) + '] ' + message);
    };

    /*  Init
        ----
         Shortcut to instantiate a component on a parent page, with props
    */

    Component.prototype.init = function init(props, context, element) {
        context = this.getRenderContext(element);
        return new __WEBPACK_IMPORTED_MODULE_5__parent__["a" /* ParentComponent */](this, context, { props: props });
    };

    Component.prototype.delegate = function delegate(source, options) {
        return new __WEBPACK_IMPORTED_MODULE_6__delegate__["a" /* DelegateComponent */](this, source, options);
    };

    Component.prototype.validateRenderContext = function validateRenderContext(context) {
        if (!this.contexts[context]) {
            throw new Error('[' + this.tag + '] Can not render to ' + context);
        }
    };

    Component.prototype.getRenderContext = function getRenderContext(element) {

        if (element) {
            this.validateRenderContext(__WEBPACK_IMPORTED_MODULE_9__constants__["CONTEXT_TYPES"].IFRAME);
            return __WEBPACK_IMPORTED_MODULE_9__constants__["CONTEXT_TYPES"].IFRAME;
        } else if (this.defaultContext) {
            return this.defaultContext;
        } else if (this.contexts[__WEBPACK_IMPORTED_MODULE_9__constants__["CONTEXT_TYPES"].IFRAME]) {
            return __WEBPACK_IMPORTED_MODULE_9__constants__["CONTEXT_TYPES"].IFRAME;
        } else if (this.contexts[__WEBPACK_IMPORTED_MODULE_9__constants__["CONTEXT_TYPES"].POPUP]) {
            return __WEBPACK_IMPORTED_MODULE_9__constants__["CONTEXT_TYPES"].POPUP;
        }

        throw new Error('[' + this.tag + '] No context options available for render');
    };

    /*  Render
        ------
         Shortcut to render a parent component
    */

    Component.prototype.render = function render(props, element) {
        var _this3 = this;

        return __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](function () {
            return new __WEBPACK_IMPORTED_MODULE_5__parent__["a" /* ParentComponent */](_this3, _this3.getRenderContext(element), { props: props }).render(element || document.body);
        });
    };

    Component.prototype.renderIframe = function renderIframe(props) {
        var _this4 = this;

        var element = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document.body;

        return __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](function () {
            if (!element) {
                throw new Error('Expected element to be passed');
            }

            _this4.validateRenderContext(__WEBPACK_IMPORTED_MODULE_9__constants__["CONTEXT_TYPES"].IFRAME);
            return new __WEBPACK_IMPORTED_MODULE_5__parent__["a" /* ParentComponent */](_this4, __WEBPACK_IMPORTED_MODULE_9__constants__["CONTEXT_TYPES"].IFRAME, { props: props }).render(element);
        });
    };

    Component.prototype.renderPopup = function renderPopup(props) {
        var _this5 = this;

        return __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](function () {
            _this5.validateRenderContext(__WEBPACK_IMPORTED_MODULE_9__constants__["CONTEXT_TYPES"].POPUP);
            return new __WEBPACK_IMPORTED_MODULE_5__parent__["a" /* ParentComponent */](_this5, __WEBPACK_IMPORTED_MODULE_9__constants__["CONTEXT_TYPES"].POPUP, { props: props }).render();
        });
    };

    Component.prototype.renderTo = function renderTo(win, props, element) {
        var _this6 = this;

        return __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](function () {
            return new __WEBPACK_IMPORTED_MODULE_5__parent__["a" /* ParentComponent */](_this6, _this6.getRenderContext(element), { props: props }).renderTo(win, element);
        });
    };

    Component.prototype.renderIframeTo = function renderIframeTo(win, props, element) {
        var _this7 = this;

        return __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](function () {
            _this7.validateRenderContext(__WEBPACK_IMPORTED_MODULE_9__constants__["CONTEXT_TYPES"].IFRAME);
            return new __WEBPACK_IMPORTED_MODULE_5__parent__["a" /* ParentComponent */](_this7, __WEBPACK_IMPORTED_MODULE_9__constants__["CONTEXT_TYPES"].IFRAME, { props: props }).renderTo(win, element);
        });
    };

    Component.prototype.renderPopupTo = function renderPopupTo(win, props) {
        var _this8 = this;

        return __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](function () {
            _this8.validateRenderContext(__WEBPACK_IMPORTED_MODULE_9__constants__["CONTEXT_TYPES"].POPUP);
            return new __WEBPACK_IMPORTED_MODULE_5__parent__["a" /* ParentComponent */](_this8, __WEBPACK_IMPORTED_MODULE_9__constants__["CONTEXT_TYPES"].POPUP, { props: props }).renderTo(win);
        });
    };

    Component.prototype.prerender = function prerender(props, element) {
        var instance = new __WEBPACK_IMPORTED_MODULE_5__parent__["a" /* ParentComponent */](this, this.getRenderContext(element), { props: props });
        instance.prefetch();

        return {
            render: function render(innerProps, innerElement) {
                if (innerProps) {
                    instance.updateProps(innerProps);
                }

                return instance.render(innerElement);
            },
            renderTo: function renderTo(win, innerProps, innerElement) {
                if (innerProps) {
                    instance.updateProps(innerProps);
                }

                return instance.renderTo(win, innerElement);
            },


            get html() {
                return instance.html;
            },

            set html(value) {
                instance.html = value;
            }
        };
    };

    /*  Log
        ---
         Log an event using the component name
    */

    Component.prototype.log = function log(event) {
        var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        Object(__WEBPACK_IMPORTED_MODULE_13__lib__["C" /* info */])(this.name, event, payload);
    };

    /*  Log Warning
        -----------
         Log a warning
    */

    Component.prototype.logWarning = function logWarning(event, payload) {
        Object(__WEBPACK_IMPORTED_MODULE_13__lib__["_0" /* warn */])(this.name, event, payload);
    };

    /*  Log Error
        ---------
         Log an error
    */

    Component.prototype.logError = function logError(event, payload) {
        Object(__WEBPACK_IMPORTED_MODULE_13__lib__["r" /* error */])(this.name, event, payload);
    };

    Component.getByTag = function getByTag(tag) {
        return Component.components[tag];
    };

    return Component;
}(__WEBPACK_IMPORTED_MODULE_3__base__["a" /* BaseComponent */]), (_applyDecoratedDescriptor(_class.prototype, 'getPropNames', [__WEBPACK_IMPORTED_MODULE_13__lib__["G" /* memoize */]], Object.getOwnPropertyDescriptor(_class.prototype, 'getPropNames'), _class.prototype)), _class);
Component.components = {};

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dom__ = __webpack_require__(56);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__dom__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__dom__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__dom__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__dom__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__dom__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_0__dom__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_0__dom__["g"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_0__dom__["h"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_0__dom__["i"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_0__dom__["j"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_0__dom__["k"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_0__dom__["l"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_0__dom__["m"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_0__dom__["n"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_0__dom__["o"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "B", function() { return __WEBPACK_IMPORTED_MODULE_0__dom__["p"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "F", function() { return __WEBPACK_IMPORTED_MODULE_0__dom__["q"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "J", function() { return __WEBPACK_IMPORTED_MODULE_0__dom__["r"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "L", function() { return __WEBPACK_IMPORTED_MODULE_0__dom__["s"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "N", function() { return __WEBPACK_IMPORTED_MODULE_0__dom__["t"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "R", function() { return __WEBPACK_IMPORTED_MODULE_0__dom__["u"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "S", function() { return __WEBPACK_IMPORTED_MODULE_0__dom__["v"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "T", function() { return __WEBPACK_IMPORTED_MODULE_0__dom__["w"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "X", function() { return __WEBPACK_IMPORTED_MODULE_0__dom__["x"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return __WEBPACK_IMPORTED_MODULE_0__dom__["y"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return __WEBPACK_IMPORTED_MODULE_0__dom__["z"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return __WEBPACK_IMPORTED_MODULE_0__dom__["A"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fn__ = __webpack_require__(31);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_1__fn__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "G", function() { return __WEBPACK_IMPORTED_MODULE_1__fn__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "I", function() { return __WEBPACK_IMPORTED_MODULE_1__fn__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "K", function() { return __WEBPACK_IMPORTED_MODULE_1__fn__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "P", function() { return __WEBPACK_IMPORTED_MODULE_1__fn__["f"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__promise__ = __webpack_require__(57);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_2__promise__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_2__promise__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "M", function() { return __WEBPACK_IMPORTED_MODULE_2__promise__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util__ = __webpack_require__(23);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_3__util__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_3__util__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_3__util__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_3__util__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_3__util__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_3__util__["g"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "O", function() { return __WEBPACK_IMPORTED_MODULE_3__util__["i"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "U", function() { return __WEBPACK_IMPORTED_MODULE_3__util__["k"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "V", function() { return __WEBPACK_IMPORTED_MODULE_3__util__["l"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return __WEBPACK_IMPORTED_MODULE_3__util__["m"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return __WEBPACK_IMPORTED_MODULE_3__util__["o"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__css__ = __webpack_require__(58);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "D", function() { return __WEBPACK_IMPORTED_MODULE_4__css__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "E", function() { return __WEBPACK_IMPORTED_MODULE_4__css__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "W", function() { return __WEBPACK_IMPORTED_MODULE_4__css__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__decorators__ = __webpack_require__(59);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "H", function() { return __WEBPACK_IMPORTED_MODULE_5__decorators__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__logger__ = __webpack_require__(60);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_6__logger__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "C", function() { return __WEBPACK_IMPORTED_MODULE_6__logger__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return __WEBPACK_IMPORTED_MODULE_6__logger__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return __WEBPACK_IMPORTED_MODULE_6__logger__["d"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__global__ = __webpack_require__(63);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_7__global__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_7__global__["b"]; });









/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__(45);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__config__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(28);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__constants__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__constants__["b"]; });



/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "XCOMPONENT", function() { return XCOMPONENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__XCOMPONENT__", function() { return __XCOMPONENT__; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "POST_MESSAGE", function() { return POST_MESSAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PROP_TYPES", function() { return PROP_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "INITIAL_PROPS", function() { return INITIAL_PROPS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WINDOW_REFERENCES", function() { return WINDOW_REFERENCES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PROP_TYPES_LIST", function() { return PROP_TYPES_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CONTEXT_TYPES", function() { return CONTEXT_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLASS_NAMES", function() { return CLASS_NAMES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EVENTS", function() { return EVENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ATTRIBUTES", function() { return ATTRIBUTES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ANIMATION_NAMES", function() { return ANIMATION_NAMES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EVENT_NAMES", function() { return EVENT_NAMES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLOSE_REASONS", function() { return CLOSE_REASONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CONTEXT_TYPES_LIST", function() { return CONTEXT_TYPES_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DELEGATE", function() { return DELEGATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WILDCARD", function() { return WILDCARD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DEFAULT_DIMENSIONS", function() { return DEFAULT_DIMENSIONS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib__ = __webpack_require__(3);


var XCOMPONENT = 'xcomponent';

var __XCOMPONENT__ = '__' + XCOMPONENT + '__';

var POST_MESSAGE = {
    INIT: XCOMPONENT + '_init',
    PROPS: XCOMPONENT + '_props',
    PROP_CALLBACK: XCOMPONENT + '_prop_callback',
    CLOSE: XCOMPONENT + '_close',
    CHECK_CLOSE: XCOMPONENT + '_check_close',
    REDIRECT: XCOMPONENT + '_redirect',
    RESIZE: XCOMPONENT + '_resize',
    ONRESIZE: XCOMPONENT + '_onresize',
    DELEGATE: XCOMPONENT + '_delegate',
    ERROR: XCOMPONENT + '_error',
    HIDE: XCOMPONENT + '_hide',
    SHOW: XCOMPONENT + '_show'
};

var PROP_TYPES = {
    STRING: 'string',
    OBJECT: 'object',
    FUNCTION: 'function',
    BOOLEAN: 'boolean',
    NUMBER: 'number'
};

var INITIAL_PROPS = {
    RAW: 'raw',
    UID: 'uid'
};

var WINDOW_REFERENCES = {
    OPENER: 'opener',
    TOP: 'top',
    PARENT: 'parent',
    GLOBAL: 'global'
};

var PROP_TYPES_LIST = Object(__WEBPACK_IMPORTED_MODULE_0__lib__["Z" /* values */])(PROP_TYPES);

var CONTEXT_TYPES = {
    IFRAME: 'iframe',
    POPUP: 'popup'
};

var CLASS_NAMES = {
    XCOMPONENT: '' + XCOMPONENT,
    OUTLET: XCOMPONENT + '-outlet',
    COMPONENT_FRAME: XCOMPONENT + '-component-frame',
    PRERENDER_FRAME: XCOMPONENT + '-prerender-frame',
    VISIBLE: XCOMPONENT + '-visible',
    INVISIBLE: XCOMPONENT + '-invisible'
};

var EVENTS = {
    CLOSE: XCOMPONENT + '-close'
};

var ATTRIBUTES = {
    IFRAME_PLACEHOLDER: 'data-xcomponent-' + XCOMPONENT + '-placeholder'
};

var ANIMATION_NAMES = {
    SHOW_CONTAINER: XCOMPONENT + '-show-container',
    SHOW_COMPONENT: XCOMPONENT + '-show-component',
    HIDE_CONTAINER: XCOMPONENT + '-hide-container',
    HIDE_COMPONENT: XCOMPONENT + '-hide-component'
};

var EVENT_NAMES = {
    CLICK: 'click'
};

var CLOSE_REASONS = {
    PARENT_CALL: 'parent_call',
    CHILD_CALL: 'child_call',
    CLOSE_DETECTED: 'close_detected',
    USER_CLOSED: 'user_closed',
    PARENT_CLOSE_DETECTED: 'parent_close_detected'
};

var CONTEXT_TYPES_LIST = Object(__WEBPACK_IMPORTED_MODULE_0__lib__["Z" /* values */])(CONTEXT_TYPES);

var DELEGATE = {
    CALL_ORIGINAL: 'call_original',
    CALL_DELEGATE: 'call_delegate'
};

var WILDCARD = '*';

var DEFAULT_DIMENSIONS = {
    WIDTH: 300,
    HEIGHT: 150
};

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interface__ = __webpack_require__(15);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "cleanUpWindow", function() { return __WEBPACK_IMPORTED_MODULE_0__interface__["cleanUpWindow"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "init", function() { return __WEBPACK_IMPORTED_MODULE_0__interface__["init"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "bridge", function() { return __WEBPACK_IMPORTED_MODULE_0__interface__["bridge"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Promise", function() { return __WEBPACK_IMPORTED_MODULE_0__interface__["Promise"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "parent", function() { return __WEBPACK_IMPORTED_MODULE_0__interface__["parent"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "send", function() { return __WEBPACK_IMPORTED_MODULE_0__interface__["send"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "request", function() { return __WEBPACK_IMPORTED_MODULE_0__interface__["request"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "sendToParent", function() { return __WEBPACK_IMPORTED_MODULE_0__interface__["sendToParent"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "client", function() { return __WEBPACK_IMPORTED_MODULE_0__interface__["client"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "on", function() { return __WEBPACK_IMPORTED_MODULE_0__interface__["on"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "listen", function() { return __WEBPACK_IMPORTED_MODULE_0__interface__["listen"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "once", function() { return __WEBPACK_IMPORTED_MODULE_0__interface__["once"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "listener", function() { return __WEBPACK_IMPORTED_MODULE_0__interface__["listener"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "CONFIG", function() { return __WEBPACK_IMPORTED_MODULE_0__interface__["CONFIG"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "CONSTANTS", function() { return __WEBPACK_IMPORTED_MODULE_0__interface__["CONSTANTS"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "disable", function() { return __WEBPACK_IMPORTED_MODULE_0__interface__["disable"]; });


/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__interface__);

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(16);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__util__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__util__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__util__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_0__util__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_0__util__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_0__util__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_0__util__["g"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_0__util__["i"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_0__util__["j"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_0__util__["k"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__log__ = __webpack_require__(22);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_1__log__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__serialize__ = __webpack_require__(46);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__serialize__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_2__serialize__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_2__serialize__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ready__ = __webpack_require__(47);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__ready__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_3__ready__["b"]; });





/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interface__ = __webpack_require__(27);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__interface__["WeakMap"]; });


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__interface__);

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return global; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__conf__ = __webpack_require__(4);


var global = window[__WEBPACK_IMPORTED_MODULE_0__conf__["b" /* CONSTANTS */].WINDOW_PROPS.POSTROBOT] = window[__WEBPACK_IMPORTED_MODULE_0__conf__["b" /* CONSTANTS */].WINDOW_PROPS.POSTROBOT] || {};

// Backwards compatibility

global.registerSelf = function () {
    // pass
};

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ParentComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_post_robot_src__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__base__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__window__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__drivers__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__validate__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__props__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__error__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__component__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__component_props__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__child__ = __webpack_require__(25);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _desc, _value, _class;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object['ke' + 'ys'](descriptor).forEach(function (key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;

    if ('value' in desc || desc.initializer) {
        desc.writable = true;
    }

    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);

    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }

    if (desc.initializer === void 0) {
        Object['define' + 'Property'](target, property, desc);
        desc = null;
    }

    return desc;
}






















__WEBPACK_IMPORTED_MODULE_6__lib__["y" /* global */].props = __WEBPACK_IMPORTED_MODULE_6__lib__["y" /* global */].props || {};
__WEBPACK_IMPORTED_MODULE_6__lib__["y" /* global */].windows = __WEBPACK_IMPORTED_MODULE_6__lib__["y" /* global */].windows || {};

/*  Parent Component
    ----------------

    This manages the state of the component on the parent window side - i.e. the window the component is being rendered into.

    It handles opening the necessary windows/iframes, launching the component's url, and listening for messages back from the component.
*/

var ParentComponent = (_class = function (_BaseComponent) {
    _inherits(ParentComponent, _BaseComponent);

    function ParentComponent(component, context, _ref) {
        var props = _ref.props;

        _classCallCheck(this, ParentComponent);

        var _this = _possibleConstructorReturn(this, _BaseComponent.call(this));

        _this.component = component;

        _this.validateParentDomain();

        _this.context = context;
        _this.setProps(props);

        if (_this.props.logLevel) {
            Object(__WEBPACK_IMPORTED_MODULE_6__lib__["Q" /* setLogLevel */])(_this.props.logLevel);
        }

        _this.childWindowName = _this.buildChildWindowName({ renderTo: window });

        _this.registerActiveComponent();

        // Options passed during renderTo. We would not ordinarily expect a user to pass these, since we depend on
        // them only when we're trying to render from a sibling to a sibling

        _this.component.log('construct_parent');

        _this.watchForUnload();

        _this.onInit = new __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__["a" /* ZalgoPromise */]();

        _this.clean.register(function () {
            _this.onInit = new __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__["a" /* ZalgoPromise */]();
        });

        _this.onInit['catch'](function (err) {
            return _this.error(err);
        });
        return _this;
    }

    ParentComponent.prototype.render = function render(element) {
        var _this2 = this;

        var loadUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

        return this.tryInit(function () {

            _this2.component.log('render_' + _this2.context, { context: _this2.context, element: element, loadUrl: Object(__WEBPACK_IMPORTED_MODULE_6__lib__["U" /* stringify */])(loadUrl) });

            var tasks = {};

            tasks.onRender = _this2.props.onRender();

            tasks.getDomain = _this2.getDomain();

            tasks.elementReady = __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](function () {
                if (element) {
                    return _this2.elementReady(element);
                }
            });

            tasks.openContainer = tasks.elementReady.then(function () {
                return _this2.openContainer(element);
            });

            tasks.showContainer = tasks.openContainer.then(function () {
                return _this2.showContainer();
            });

            tasks.openPrerender = tasks.openContainer.then(function () {
                return _this2.openPrerender();
            });

            tasks.switchPrerender = __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__["a" /* ZalgoPromise */].all([tasks.openPrerender, _this2.onInit]).then(function () {
                return _this2.switchPrerender();
            });

            tasks.open = _this2.driver.openOnClick ? _this2.open() : tasks.openContainer.then(function () {
                return _this2.open();
            });

            tasks.listen = __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__["a" /* ZalgoPromise */].all([tasks.getDomain, tasks.open]).then(function (_ref2) {
                var domain = _ref2[0];

                _this2.listen(_this2.window, domain);
            });

            tasks.watchForClose = tasks.open.then(function () {
                return _this2.watchForClose();
            });

            tasks.linkDomain = __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__["a" /* ZalgoPromise */].all([tasks.getDomain, tasks.open]).then(function (_ref3) {
                var domain = _ref3[0];

                if (__WEBPACK_IMPORTED_MODULE_1_post_robot_src__["bridge"] && typeof domain === 'string') {
                    return __WEBPACK_IMPORTED_MODULE_1_post_robot_src__["bridge"].linkUrl(_this2.window, domain);
                }
            });

            if (!_this2.html) {
                tasks.createPrerenderTemplate = tasks.openPrerender.then(function () {
                    return _this2.createPrerenderTemplate();
                });

                tasks.showComponent = tasks.createPrerenderTemplate.then(function () {
                    return _this2.showComponent();
                });
            }

            tasks.openBridge = tasks.open.then(function () {
                return _this2.openBridge();
            });

            if (_this2.html) {
                tasks.loadHTML = tasks.open.then(function () {
                    return _this2.loadHTML();
                });
            } else if (loadUrl) {
                tasks.buildUrl = _this2.buildUrl();

                tasks.loadUrl = __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__["a" /* ZalgoPromise */].all([tasks.buildUrl, tasks.open, tasks.linkDomain, tasks.listen, tasks.open, tasks.openBridge, tasks.createPrerenderTemplate]).then(function (_ref4) {
                    var url = _ref4[0];

                    return _this2.loadUrl(url);
                });

                tasks.runTimeout = tasks.loadUrl.then(function () {
                    return _this2.runTimeout();
                });
            }

            return __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__["a" /* ZalgoPromise */].hash(tasks);
        }).then(function () {
            return _this2.props.onEnter();
        });
    };

    ParentComponent.prototype.getOutlet = function getOutlet() {
        this.outlet = document.createElement('div');
        Object(__WEBPACK_IMPORTED_MODULE_6__lib__["a" /* addClass */])(this.outlet, __WEBPACK_IMPORTED_MODULE_7__constants__["CLASS_NAMES"].OUTLET);
        return this.outlet;
    };

    ParentComponent.prototype.validateParentDomain = function validateParentDomain() {
        var domain = Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__["f" /* getDomain */])();
        if (!Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__["v" /* matchDomain */])(this.component.allowedParentDomains, domain)) {
            throw new __WEBPACK_IMPORTED_MODULE_11__error__["c" /* RenderError */]('Can not be rendered by domain: ' + domain);
        }
    };

    ParentComponent.prototype.renderTo = function renderTo(win, element) {
        var _this3 = this;

        return this.tryInit(function () {

            if (win === window) {
                return _this3.render(element);
            }

            if (!Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__["q" /* isSameTopWindow */])(window, win)) {
                throw new Error('Can only renderTo an adjacent frame');
            }

            if (element && typeof element !== 'string') {
                throw new Error('Element passed to renderTo must be a string selector, got ' + (typeof element === 'undefined' ? 'undefined' : _typeof(element)) + ' ' + element);
            }

            _this3.checkAllowRenderTo(win);

            _this3.component.log('render_' + _this3.context + '_to_win', { element: Object(__WEBPACK_IMPORTED_MODULE_6__lib__["U" /* stringify */])(element), context: _this3.context });

            _this3.childWindowName = _this3.buildChildWindowName({ renderTo: win });

            _this3.delegate(win);

            return _this3.render(element);
        });
    };

    ParentComponent.prototype.prefetch = function prefetch() {
        var _this4 = this;

        return __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](function () {
            _this4.html = _this4.buildUrl().then(function (url) {
                return Object(__WEBPACK_IMPORTED_MODULE_6__lib__["L" /* prefetchPage */])(url).then(function (html) {

                    var host = '' + url.split('/').slice(0, 3).join('/');
                    var uri = '/' + url.split('/').slice(3).join('/');

                    return '\n                        <base href="' + host + '">\n\n                        ' + html + '\n\n                        <script>\n                            if (window.history && window.history.pushState) {\n                                window.history.pushState({}, \'\', \'' + uri + '\');\n                            }\n                        </script>\n                    ';
                });
            });
        });
    };

    ParentComponent.prototype.loadHTML = function loadHTML() {
        var _this5 = this;

        return __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](function () {
            if (!_this5.html) {
                throw new Error('Html not prefetched');
            }

            return _this5.html.then(function (html) {
                // $FlowFixMe
                return Object(__WEBPACK_IMPORTED_MODULE_6__lib__["_3" /* writeToWindow */])(_this5.window, html);
            });
        });
    };

    ParentComponent.prototype.checkAllowRenderTo = function checkAllowRenderTo(win) {

        if (!win) {
            throw this.component.createError('Must pass window to renderTo');
        }

        if (Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__["p" /* isSameDomain */])(win)) {
            return;
        }

        var origin = Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__["f" /* getDomain */])();
        var domain = this.component.getDomain(null, this.props.env);

        if (!domain) {
            throw new Error('Could not determine domain to allow remote render');
        }

        if (Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__["v" /* matchDomain */])(domain, origin)) {
            return;
        }

        throw new Error('Can not render remotely to ' + domain.toString() + ' - can only render to ' + origin);
    };

    ParentComponent.prototype.registerActiveComponent = function registerActiveComponent() {
        var _this6 = this;

        ParentComponent.activeComponents.push(this);

        this.clean.register(function () {
            ParentComponent.activeComponents.splice(ParentComponent.activeComponents.indexOf(_this6), 1);
        });
    };

    ParentComponent.prototype.getComponentParentRef = function getComponentParentRef() {
        var renderToWindow = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window;


        if (this.context === __WEBPACK_IMPORTED_MODULE_7__constants__["CONTEXT_TYPES"].POPUP) {
            return { ref: __WEBPACK_IMPORTED_MODULE_7__constants__["WINDOW_REFERENCES"].OPENER };
        }

        if (renderToWindow === window) {

            if (Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__["r" /* isTop */])(window)) {
                return { ref: __WEBPACK_IMPORTED_MODULE_7__constants__["WINDOW_REFERENCES"].TOP };
            }

            return { ref: __WEBPACK_IMPORTED_MODULE_7__constants__["WINDOW_REFERENCES"].PARENT, distance: Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__["e" /* getDistanceFromTop */])(window) };
        }

        var uid = Object(__WEBPACK_IMPORTED_MODULE_6__lib__["Y" /* uniqueID */])();
        __WEBPACK_IMPORTED_MODULE_6__lib__["y" /* global */].windows[uid] = window;

        this.clean.register(function () {
            delete __WEBPACK_IMPORTED_MODULE_6__lib__["y" /* global */].windows[uid];
        });

        return { ref: __WEBPACK_IMPORTED_MODULE_7__constants__["WINDOW_REFERENCES"].GLOBAL, uid: uid };
    };

    ParentComponent.prototype.getRenderParentRef = function getRenderParentRef() {
        var renderToWindow = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window;


        if (renderToWindow === window) {
            return this.getComponentParentRef(renderToWindow);
        }

        var uid = Object(__WEBPACK_IMPORTED_MODULE_6__lib__["Y" /* uniqueID */])();
        __WEBPACK_IMPORTED_MODULE_6__lib__["y" /* global */].windows[uid] = renderToWindow;

        this.clean.register(function () {
            delete __WEBPACK_IMPORTED_MODULE_6__lib__["y" /* global */].windows[uid];
        });

        return { ref: __WEBPACK_IMPORTED_MODULE_7__constants__["WINDOW_REFERENCES"].GLOBAL, uid: uid };
    };

    ParentComponent.prototype.buildChildWindowName = function buildChildWindowName() {
        var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref5$renderTo = _ref5.renderTo,
            renderTo = _ref5$renderTo === undefined ? window : _ref5$renderTo;

        var sameDomain = Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__["p" /* isSameDomain */])(renderTo);

        var uid = Object(__WEBPACK_IMPORTED_MODULE_6__lib__["Y" /* uniqueID */])();
        var tag = this.component.tag;
        var sProps = Object(__WEBPACK_IMPORTED_MODULE_6__lib__["P" /* serializeFunctions */])(this.getPropsForChild());

        var componentParent = this.getComponentParentRef(renderTo);
        var renderParent = this.getRenderParentRef(renderTo);

        var secureProps = !sameDomain;

        var props = secureProps ? { type: __WEBPACK_IMPORTED_MODULE_7__constants__["INITIAL_PROPS"].UID, uid: uid } : { type: __WEBPACK_IMPORTED_MODULE_7__constants__["INITIAL_PROPS"].RAW, value: sProps };

        if (props.type === __WEBPACK_IMPORTED_MODULE_7__constants__["INITIAL_PROPS"].UID) {
            __WEBPACK_IMPORTED_MODULE_6__lib__["y" /* global */].props[uid] = sProps;

            this.clean.register(function () {
                delete __WEBPACK_IMPORTED_MODULE_6__lib__["y" /* global */].props[uid];
            });
        }

        return Object(__WEBPACK_IMPORTED_MODULE_5__window__["a" /* buildChildWindowName */])(this.component.name, this.component.version, { uid: uid, tag: tag, componentParent: componentParent, renderParent: renderParent, props: props });
    };

    /*  Send to Parent
        --------------
         Send a post message to our parent window.
    */

    ParentComponent.prototype.sendToParent = function sendToParent(name, data) {
        var parentWindow = Object(__WEBPACK_IMPORTED_MODULE_5__window__["c" /* getParentComponentWindow */])();

        if (!parentWindow) {
            throw new Error('Can not find parent component window to message');
        }

        this.component.log('send_to_parent_' + name);

        return Object(__WEBPACK_IMPORTED_MODULE_1_post_robot_src__["send"])(Object(__WEBPACK_IMPORTED_MODULE_5__window__["c" /* getParentComponentWindow */])(), name, data, { domain: Object(__WEBPACK_IMPORTED_MODULE_5__window__["d" /* getParentDomain */])() });
    };

    /*  Set Props
        ---------
         Normalize props and generate the url we'll use to render the component
    */

    ParentComponent.prototype.setProps = function setProps(props) {
        var required = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;


        Object(__WEBPACK_IMPORTED_MODULE_9__validate__["a" /* validateProps */])(this.component, props, required);
        if (this.component.validate) {
            this.component.validate(this.component, props);
        }

        // $FlowFixMe
        this.props = this.props || {};

        Object(__WEBPACK_IMPORTED_MODULE_6__lib__["t" /* extend */])(this.props, Object(__WEBPACK_IMPORTED_MODULE_10__props__["a" /* normalizeProps */])(this.component, this, props));
    };

    /*  Build Url
        ---------
         We build the props we're passed into the initial url. This means the component server-side can start rendering
        itself based on whatever props the merchant provides.
    */

    ParentComponent.prototype.buildUrl = function buildUrl() {
        var _this7 = this;

        return __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__["a" /* ZalgoPromise */].all([this.props.url, Object(__WEBPACK_IMPORTED_MODULE_10__props__["b" /* propsToQuery */])(_extends({}, this.component.props, this.component.builtinProps), this.props)]).then(function (_ref6) {
            var url = _ref6[0],
                query = _ref6[1];


            // Do not extend the url if it is for a different domain

            if (url && !_this7.component.getValidDomain(url)) {
                return url;
            }

            return __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](function () {

                return url || _this7.component.getUrl(_this7.props.env, _this7.props);
            }).then(function (finalUrl) {

                query[__WEBPACK_IMPORTED_MODULE_7__constants__["XCOMPONENT"]] = '1';
                return Object(__WEBPACK_IMPORTED_MODULE_6__lib__["u" /* extendUrl */])(finalUrl, { query: query });
            });
        });
    };

    ParentComponent.prototype.getDomain = function getDomain() {
        var _this8 = this;

        return __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](function () {
            return _this8.props.url;
        }).then(function (url) {

            var domain = _this8.component.getDomain(url, _this8.props.env);

            if (domain) {
                return domain;
            }

            if (_this8.component.buildUrl) {
                return __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](function () {
                    return _this8.component.buildUrl(_this8.props);
                }).then(function (builtUrl) {
                    return _this8.component.getDomain(builtUrl, _this8.props.env);
                });
            }
        }).then(function (domain) {

            if (!domain) {
                throw new Error('Could not determine domain');
            }

            return domain;
        });
    };

    ParentComponent.prototype.getPropsForChild = function getPropsForChild() {

        var result = {};

        for (var _iterator = Object.keys(this.props), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
            var _ref7;

            if (_isArray) {
                if (_i >= _iterator.length) break;
                _ref7 = _iterator[_i++];
            } else {
                _i = _iterator.next();
                if (_i.done) break;
                _ref7 = _i.value;
            }

            var key = _ref7;

            var prop = this.component.getProp(key);

            if (!prop || prop.sendToChild !== false) {
                result[key] = this.props[key];
            }
        }

        // $FlowFixMe
        return result;
    };

    /*  Update Props
        ------------
         Send new props down to the child
    */

    ParentComponent.prototype.updateProps = function updateProps(props) {
        var _this9 = this;

        this.setProps(props, false);

        return this.onInit.then(function () {
            if (_this9.childExports) {
                return _this9.childExports.updateProps(_this9.getPropsForChild());
            } else {
                throw new Error('Child exports were not available');
            }
        });
    };

    ParentComponent.prototype.openBridge = function openBridge() {
        var _this10 = this;

        return __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](function () {
            if (!__WEBPACK_IMPORTED_MODULE_1_post_robot_src__["bridge"]) {
                return;
            }

            var bridgeUrl = _this10.component.getBridgeUrl(_this10.props.env);

            if (!bridgeUrl) {
                return;
            }

            var bridgeDomain = _this10.component.getBridgeDomain(_this10.props.env);

            if (!bridgeDomain) {
                throw new Error('Can not determine domain for bridge');
            }

            if (__WEBPACK_IMPORTED_MODULE_1_post_robot_src__["bridge"].needsBridge({ win: _this10.window, domain: bridgeDomain })) {
                return __WEBPACK_IMPORTED_MODULE_1_post_robot_src__["bridge"].openBridge(bridgeUrl, bridgeDomain).then(function (result) {
                    if (result) {
                        return result;
                    }
                });
            }
        });
    };

    /*  Open
        ----
         Open a new window in the desired context
    */

    ParentComponent.prototype.open = function open() {
        var _this11 = this;

        return __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](function () {
            _this11.component.log('open_' + _this11.context, { windowName: _this11.childWindowName });
            return _this11.driver.open.call(_this11);
        });
    };

    ParentComponent.prototype.openPrerender = function openPrerender() {
        var _this12 = this;

        return __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](function () {
            if (_this12.component.prerenderTemplate) {
                return _this12.driver.openPrerender.call(_this12);
            }
        });
    };

    ParentComponent.prototype.switchPrerender = function switchPrerender() {
        var _this13 = this;

        return __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](function () {
            if (_this13.prerenderWindow && _this13.driver.switchPrerender) {
                return _this13.driver.switchPrerender.call(_this13);
            }
        });
    };

    ParentComponent.prototype.elementReady = function elementReady(element) {
        return Object(__WEBPACK_IMPORTED_MODULE_6__lib__["p" /* elementReady */])(element).then(__WEBPACK_IMPORTED_MODULE_6__lib__["I" /* noop */]);
    };

    ParentComponent.prototype.delegate = function delegate(win) {
        var _this14 = this;

        this.component.log('delegate_' + this.context);

        var props = {
            uid: this.props.uid,
            dimensions: this.props.dimensions,
            onClose: this.props.onClose,
            onDisplay: this.props.onDisplay
        };

        for (var _iterator2 = this.component.getPropNames(), _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
            var _ref8;

            if (_isArray2) {
                if (_i2 >= _iterator2.length) break;
                _ref8 = _iterator2[_i2++];
            } else {
                _i2 = _iterator2.next();
                if (_i2.done) break;
                _ref8 = _i2.value;
            }

            var propName = _ref8;

            var prop = this.component.getProp(propName);

            if (prop.allowDelegate) {
                props[propName] = this.props[propName];
            }
        }

        var delegate = Object(__WEBPACK_IMPORTED_MODULE_1_post_robot_src__["send"])(win, __WEBPACK_IMPORTED_MODULE_7__constants__["POST_MESSAGE"].DELEGATE + '_' + this.component.name, {

            context: this.context,
            env: this.props.env,

            options: {

                context: this.context,

                childWindowName: this.childWindowName,

                props: props,

                overrides: {
                    focus: function focus() {
                        return _this14.focus();
                    },
                    userClose: function userClose() {
                        return _this14.userClose();
                    },
                    getDomain: function getDomain() {
                        return _this14.getDomain();
                    },

                    error: function error(err) {
                        return _this14.error(err);
                    },
                    on: function on(eventName, handler) {
                        return _this14.on(eventName, handler);
                    }
                }
            }

        }).then(function (_ref9) {
            var data = _ref9.data;


            _this14.clean.register(data.destroy);
            return data;
        })['catch'](function (err) {

            throw new Error('Unable to delegate rendering. Possibly the component is not loaded in the target window.\n\n' + Object(__WEBPACK_IMPORTED_MODULE_6__lib__["V" /* stringifyError */])(err));
        });

        var overrides = this.driver.delegateOverrides;

        var _loop = function _loop() {
            if (_isArray3) {
                if (_i3 >= _iterator3.length) return 'break';
                _ref10 = _iterator3[_i3++];
            } else {
                _i3 = _iterator3.next();
                if (_i3.done) return 'break';
                _ref10 = _i3.value;
            }

            var key = _ref10;

            var val = overrides[key];

            if (val === __WEBPACK_IMPORTED_MODULE_7__constants__["DELEGATE"].CALL_ORIGINAL) {
                return 'continue';
            }

            // $FlowFixMe
            var original = _this14[key];

            // $FlowFixMe
            _this14[key] = function () {
                var _this15 = this,
                    _arguments = arguments;

                return delegate.then(function (data) {

                    var override = data.overrides[key];

                    if (val === __WEBPACK_IMPORTED_MODULE_7__constants__["DELEGATE"].CALL_DELEGATE) {
                        return override.apply(_this15, _arguments);
                    }

                    if (val instanceof Function) {
                        return val(original, override).apply(_this15, _arguments);
                    }

                    throw new Error('Expected delgate to be CALL_ORIGINAL, CALL_DELEGATE, or factory method');
                });
            };
        };

        _loop2: for (var _iterator3 = Object.keys(overrides), _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
            var _ref10;

            var _ret = _loop();

            switch (_ret) {
                case 'break':
                    break _loop2;

                case 'continue':
                    continue;}
        }
    };

    /*  Watch For Close
        ---------------
         Watch for the child window closing, so we can cleanup.
        Also watch for this window changing location, so we can close the component.
    */

    ParentComponent.prototype.watchForClose = function watchForClose() {
        var _this16 = this;

        var closeWindowListener = Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__["w" /* onCloseWindow */])(this.window, function () {
            _this16.component.log('detect_close_child');

            return __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](function () {
                return _this16.props.onClose(__WEBPACK_IMPORTED_MODULE_7__constants__["CLOSE_REASONS"].CLOSE_DETECTED);
            })['finally'](function () {
                return _this16.destroy();
            });
        }, 3000);

        this.clean.register('destroyCloseWindowListener', closeWindowListener.cancel);
    };

    ParentComponent.prototype.watchForUnload = function watchForUnload() {
        var _this17 = this;

        // Our child has no way of knowing if we navigated off the page. So we have to listen for unload
        // and close the child manually if that happens.

        var onunload = Object(__WEBPACK_IMPORTED_MODULE_6__lib__["K" /* once */])(function () {
            _this17.component.log('navigate_away');
            __WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__["c" /* flush */]();
            _this17.destroyComponent();
        });

        var unloadWindowListener = Object(__WEBPACK_IMPORTED_MODULE_6__lib__["b" /* addEventListener */])(window, 'unload', onunload);

        this.clean.register('destroyUnloadWindowListener', unloadWindowListener.cancel);
    };

    /*  Load Url
        --------
         Load url into the child window. This is separated out because it's quite common for us to have situations
        where opening the child window and loading the url happen at different points.
    */

    ParentComponent.prototype.loadUrl = function loadUrl(url) {
        var _this18 = this;

        return __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](function () {
            _this18.component.log('load_url');

            if (window.location.href.split('#')[0] === url.split('#')[0]) {
                var _query;

                url = Object(__WEBPACK_IMPORTED_MODULE_6__lib__["u" /* extendUrl */])(url, {
                    query: (_query = {}, _query[Object(__WEBPACK_IMPORTED_MODULE_6__lib__["Y" /* uniqueID */])()] = '1', _query)
                });
            }

            return _this18.driver.loadUrl.call(_this18, url);
        });
    };

    ParentComponent.prototype.hijack = function hijack(targetElement) {
        targetElement.target = this.childWindowName;
    };

    /*  Run Timeout
        -----------
         Set a timeout on the initial render, and call this.props.onTimeout if we don't get an init call in time.
    */

    ParentComponent.prototype.runTimeout = function runTimeout() {
        var _this19 = this;

        if (this.props.timeout) {
            this.timeout = setTimeout(function () {

                _this19.component.log('timed_out', { timeout: _this19.props.timeout });

                var error = _this19.component.createError('Loading component timed out after ' + _this19.props.timeout + ' milliseconds');

                _this19.onInit.reject(error);
                _this19.props.onTimeout(error);
            }, this.props.timeout);

            this.clean.register(function () {
                clearTimeout(_this19.timeout);
                delete _this19.timeout;
            });
        }
    };

    /*  Listeners
        ---------
         Post-robot listeners to the child component window
    */

    ParentComponent.prototype.listeners = function listeners() {
        var _ref11;

        return _ref11 = {}, _ref11[__WEBPACK_IMPORTED_MODULE_7__constants__["POST_MESSAGE"].INIT] = function (source, data) {

            this.childExports = data.exports;

            this.onInit.resolve(this);

            if (this.timeout) {
                clearTimeout(this.timeout);
            }

            return {
                props: this.getPropsForChild(),
                context: this.context
            };
        }, _ref11[__WEBPACK_IMPORTED_MODULE_7__constants__["POST_MESSAGE"].CLOSE] = function (source, data) {
            this.close(data.reason);
        }, _ref11[__WEBPACK_IMPORTED_MODULE_7__constants__["POST_MESSAGE"].CHECK_CLOSE] = function (source, data) {
            this.checkClose();
        }, _ref11[__WEBPACK_IMPORTED_MODULE_7__constants__["POST_MESSAGE"].RESIZE] = function (source, data) {
            var _this20 = this;

            return __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](function () {
                if (_this20.driver.allowResize) {
                    return _this20.resize(data.width, data.height);
                }
            });
        }, _ref11[__WEBPACK_IMPORTED_MODULE_7__constants__["POST_MESSAGE"].ONRESIZE] = function (source, data) {
            this.event.trigger('resize');
        }, _ref11[__WEBPACK_IMPORTED_MODULE_7__constants__["POST_MESSAGE"].HIDE] = function (source, data) {
            this.hide();
        }, _ref11[__WEBPACK_IMPORTED_MODULE_7__constants__["POST_MESSAGE"].SHOW] = function (source, data) {
            this.show();
        }, _ref11[__WEBPACK_IMPORTED_MODULE_7__constants__["POST_MESSAGE"].ERROR] = function (source, data) {
            this.error(new Error(data.error));
        }, _ref11;
    };

    /*  Resize
        ------
         Resize the child component window
    */

    ParentComponent.prototype.resize = function resize(width, height) {
        var _this21 = this;

        var _ref12 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
            _ref12$waitForTransit = _ref12.waitForTransition,
            waitForTransition = _ref12$waitForTransit === undefined ? true : _ref12$waitForTransit;

        return __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](function () {
            _this21.component.log('resize', { height: Object(__WEBPACK_IMPORTED_MODULE_6__lib__["U" /* stringify */])(height), width: Object(__WEBPACK_IMPORTED_MODULE_6__lib__["U" /* stringify */])(width) });
            _this21.driver.resize.call(_this21, width, height);

            if (!waitForTransition) {
                return;
            }

            if (_this21.element || _this21.iframe) {

                var overflow = void 0;

                if (_this21.element) {
                    overflow = Object(__WEBPACK_IMPORTED_MODULE_6__lib__["R" /* setOverflow */])(_this21.element, 'hidden');
                }

                return Object(__WEBPACK_IMPORTED_MODULE_6__lib__["q" /* elementStoppedMoving */])(_this21.element || _this21.iframe).then(function () {

                    if (overflow) {
                        overflow.reset();
                    }
                });
            }
        });
    };

    /*  Hide
        ----
         Hide the component and any parent template
    */

    ParentComponent.prototype.hide = function hide() {

        if (this.container) {
            Object(__WEBPACK_IMPORTED_MODULE_6__lib__["A" /* hideElement */])(this.container);
        }

        return this.driver.hide.call(this);
    };

    ParentComponent.prototype.show = function show() {

        if (this.container) {
            Object(__WEBPACK_IMPORTED_MODULE_6__lib__["T" /* showElement */])(this.container);
        }

        return this.driver.show.call(this);
    };

    ParentComponent.prototype.checkClose = function checkClose() {
        var _this22 = this;

        var closeWindowListener = Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__["w" /* onCloseWindow */])(this.window, function () {
            _this22.userClose();
        }, 50, 500);

        this.clean.register(closeWindowListener.cancel);
    };

    ParentComponent.prototype.userClose = function userClose() {
        return this.close(__WEBPACK_IMPORTED_MODULE_7__constants__["CLOSE_REASONS"].USER_CLOSED);
    };

    /*  Close
        -----
         Close the child component
    */

    ParentComponent.prototype.close = function close() {
        var _this23 = this;

        var reason = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_7__constants__["CLOSE_REASONS"].PARENT_CALL;

        return __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](function () {

            _this23.component.log('close', { reason: reason });

            _this23.event.triggerOnce(__WEBPACK_IMPORTED_MODULE_7__constants__["EVENTS"].CLOSE);
            return _this23.props.onClose(reason);
        }).then(function () {

            return __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__["a" /* ZalgoPromise */].all([_this23.closeComponent(), _this23.closeContainer()]);
        }).then(function () {

            return _this23.destroy();
        });
    };

    ParentComponent.prototype.closeContainer = function closeContainer() {
        var _this24 = this;

        var reason = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_7__constants__["CLOSE_REASONS"].PARENT_CALL;

        return __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](function () {

            _this24.event.triggerOnce(__WEBPACK_IMPORTED_MODULE_7__constants__["EVENTS"].CLOSE);
            return _this24.props.onClose(reason);
        }).then(function () {

            return __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__["a" /* ZalgoPromise */].all([_this24.closeComponent(reason), _this24.hideContainer()]);
        }).then(function () {

            return _this24.destroyContainer();
        });
    };

    ParentComponent.prototype.destroyContainer = function destroyContainer() {
        var _this25 = this;

        return __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](function () {
            _this25.clean.run('destroyContainerEvents');
            _this25.clean.run('destroyContainerTemplate');
        });
    };

    ParentComponent.prototype.closeComponent = function closeComponent() {
        var _this26 = this;

        var reason = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_7__constants__["CLOSE_REASONS"].PARENT_CALL;


        var win = this.window;

        return __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](function () {

            return _this26.cancelContainerEvents();
        }).then(function () {

            _this26.event.triggerOnce(__WEBPACK_IMPORTED_MODULE_7__constants__["EVENTS"].CLOSE);
            return _this26.props.onClose(reason);
        }).then(function () {

            return _this26.hideComponent();
        }).then(function () {

            return _this26.destroyComponent();
        }).then(function () {

            // IE in metro mode -- child window needs to close itself, or close will hang

            if (_this26.childExports && _this26.context === __WEBPACK_IMPORTED_MODULE_7__constants__["CONTEXT_TYPES"].POPUP && !Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__["t" /* isWindowClosed */])(win)) {
                _this26.childExports.close()['catch'](__WEBPACK_IMPORTED_MODULE_6__lib__["I" /* noop */]);
            }
        });
    };

    ParentComponent.prototype.destroyComponent = function destroyComponent() {
        this.clean.run('destroyUnloadWindowListener');
        this.clean.run('destroyCloseWindowListener');
        this.clean.run('destroyContainerEvents');
        this.clean.run('destroyWindow');
    };

    ParentComponent.prototype.showContainer = function showContainer() {
        var _this27 = this;

        return __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](function () {
            if (_this27.props.onDisplay) {
                return _this27.props.onDisplay();
            }
        }).then(function () {
            if (_this27.container) {
                return Object(__WEBPACK_IMPORTED_MODULE_6__lib__["S" /* showAndAnimate */])(_this27.container, __WEBPACK_IMPORTED_MODULE_7__constants__["ANIMATION_NAMES"].SHOW_CONTAINER, _this27.clean.register);
            }
        });
    };

    ParentComponent.prototype.showComponent = function showComponent() {
        var _this28 = this;

        return __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](function () {
            if (_this28.props.onDisplay) {
                return _this28.props.onDisplay();
            }
        }).then(function () {
            if (_this28.element) {
                return Object(__WEBPACK_IMPORTED_MODULE_6__lib__["S" /* showAndAnimate */])(_this28.element, __WEBPACK_IMPORTED_MODULE_7__constants__["ANIMATION_NAMES"].SHOW_COMPONENT, _this28.clean.register);
            }
        });
    };

    ParentComponent.prototype.hideContainer = function hideContainer() {
        var _this29 = this;

        return __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](function () {
            if (_this29.container) {
                return Object(__WEBPACK_IMPORTED_MODULE_6__lib__["c" /* animateAndHide */])(_this29.container, __WEBPACK_IMPORTED_MODULE_7__constants__["ANIMATION_NAMES"].HIDE_CONTAINER, _this29.clean.register);
            } else {
                return __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__["a" /* ZalgoPromise */].resolve();
            }
        });
    };

    ParentComponent.prototype.hideComponent = function hideComponent() {
        var _this30 = this;

        return __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](function () {
            if (_this30.element) {
                return Object(__WEBPACK_IMPORTED_MODULE_6__lib__["c" /* animateAndHide */])(_this30.element, __WEBPACK_IMPORTED_MODULE_7__constants__["ANIMATION_NAMES"].HIDE_COMPONENT, _this30.clean.register);
            } else {
                return __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__["a" /* ZalgoPromise */].resolve();
            }
        });
    };

    /*  Focus
        -----
         Focus the child component window
    */

    ParentComponent.prototype.focus = function focus() {

        if (this.window) {
            if (this.driver.openOnFocus) {
                try {
                    window.open('', this.childWindowName);
                } catch (err) {
                    // pass
                }
            }

            this.component.log('focus');
            this.window.focus();
        } else {

            throw new Error('No window to focus');
        }
    };

    /*  Create Component Template
        -------------------------
         Creates an initial template and stylesheet which are loaded into the child window, to be displayed before the url is loaded
    */

    ParentComponent.prototype.createPrerenderTemplate = function createPrerenderTemplate() {
        var _this31 = this;

        return __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](function () {
            if (!_this31.component.prerenderTemplate) {
                return __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__["a" /* ZalgoPromise */].resolve();
            }

            return __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](function () {

                if (_this31.prerenderIframe) {
                    return Object(__WEBPACK_IMPORTED_MODULE_6__lib__["e" /* awaitFrameLoad */])(_this31.prerenderIframe).then(function () {
                        return _this31.prerenderWindow;
                    });
                } else {
                    return _this31.prerenderWindow;
                }
            }).then(function (win) {

                var doc = void 0;

                try {
                    doc = win.document;
                } catch (err) {
                    return;
                }

                try {
                    Object(__WEBPACK_IMPORTED_MODULE_6__lib__["_2" /* writeElementToWindow */])(win, _this31.renderTemplate(_this31.component.prerenderTemplate, {
                        jsxDom: __WEBPACK_IMPORTED_MODULE_6__lib__["F" /* jsxDom */].bind(doc),
                        document: doc
                    }));
                } catch (err) {
                    return;
                }
            });
        });
    };

    /*  Create Parent Template
        ----------------------
         Create a template and stylesheet for the parent template behind the element
    */

    ParentComponent.prototype.renderTemplate = function renderTemplate(renderer) {
        var _this32 = this;

        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        var _ref13 = this.component.dimensions || {},
            _ref13$width = _ref13.width,
            width = _ref13$width === undefined ? __WEBPACK_IMPORTED_MODULE_7__constants__["DEFAULT_DIMENSIONS"].WIDTH + 'px' : _ref13$width,
            _ref13$height = _ref13.height,
            height = _ref13$height === undefined ? __WEBPACK_IMPORTED_MODULE_7__constants__["DEFAULT_DIMENSIONS"].HEIGHT + 'px' : _ref13$height;

        return renderer.call(this, _extends({
            id: __WEBPACK_IMPORTED_MODULE_7__constants__["CLASS_NAMES"].XCOMPONENT + '-' + this.component.tag + '-' + this.props.uid,
            props: renderer.__xdomain__ ? null : this.props,
            tag: this.component.tag,
            context: this.context,
            outlet: this.getOutlet(),
            CLASS: __WEBPACK_IMPORTED_MODULE_7__constants__["CLASS_NAMES"],
            ANIMATION: __WEBPACK_IMPORTED_MODULE_7__constants__["ANIMATION_NAMES"],
            CONTEXT: __WEBPACK_IMPORTED_MODULE_7__constants__["CONTEXT_TYPES"],
            EVENT: __WEBPACK_IMPORTED_MODULE_7__constants__["EVENTS"],
            actions: {
                close: function close() {
                    return _this32.userClose();
                },
                focus: function focus() {
                    return _this32.focus();
                }
            },
            on: function on(eventName, handler) {
                return _this32.on(eventName, handler);
            },
            jsxDom: __WEBPACK_IMPORTED_MODULE_6__lib__["F" /* jsxDom */],
            document: document,
            dimensions: { width: width, height: height }
        }, options));
    };

    ParentComponent.prototype.openContainer = function openContainer(element) {
        var _this33 = this;

        return __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](function () {
            var el = void 0;

            if (element) {
                el = Object(__WEBPACK_IMPORTED_MODULE_6__lib__["x" /* getElement */])(element);
            } else {
                el = document.body;
            }

            if (!el) {
                throw new Error('Could not find element to open container into');
            }

            if (!_this33.component.containerTemplate) {
                if (_this33.driver.renderedIntoContainerTemplate) {
                    throw new Error('containerTemplate needed to render ' + _this33.context);
                }

                return;
            }

            var container = _this33.renderTemplate(_this33.component.containerTemplate, {
                container: el
            });

            _this33.container = container;
            Object(__WEBPACK_IMPORTED_MODULE_6__lib__["A" /* hideElement */])(_this33.container);
            Object(__WEBPACK_IMPORTED_MODULE_6__lib__["d" /* appendChild */])(el, _this33.container);

            if (_this33.driver.renderedIntoContainerTemplate) {
                _this33.element = _this33.getOutlet();
                Object(__WEBPACK_IMPORTED_MODULE_6__lib__["A" /* hideElement */])(_this33.element);

                if (!_this33.element) {
                    throw new Error('Could not find element to render component into');
                }

                Object(__WEBPACK_IMPORTED_MODULE_6__lib__["A" /* hideElement */])(_this33.element);
            }

            _this33.clean.register('destroyContainerTemplate', function () {

                if (_this33.container && _this33.container.parentNode) {
                    _this33.container.parentNode.removeChild(_this33.container);
                }

                delete _this33.container;
            });
        });
    };

    ParentComponent.prototype.cancelContainerEvents = function cancelContainerEvents() {
        this.clean.run('destroyContainerEvents');
    };

    /*  Destroy
        -------
         Close the component and clean up any listeners and state
    */

    ParentComponent.prototype.destroy = function destroy() {
        var _this34 = this;

        return __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](function () {
            if (_this34.clean.hasTasks()) {
                _this34.component.log('destroy');
                __WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__["c" /* flush */]();
                return _this34.clean.all();
            }
        });
    };

    ParentComponent.prototype.tryInit = function tryInit(method) {
        var _this35 = this;

        return __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](method)['catch'](function (err) {

            _this35.onInit.reject(err);
            throw err;
        }).then(function () {

            return _this35.onInit;
        });
    };

    /*  Error
        -----
         Handle an error
    */

    ParentComponent.prototype.error = function error(err) {
        var _this36 = this;

        return __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](function () {

            _this36.handledErrors = _this36.handledErrors || [];

            if (_this36.handledErrors.indexOf(err) !== -1) {
                // $FlowFixMe
                return;
            }

            _this36.handledErrors.push(err);

            _this36.onInit.reject(err);

            return _this36.destroy();
        }).then(function () {

            if (_this36.props.onError) {
                return _this36.props.onError(err);
            }
        })['catch'](function (errErr) {

            throw new Error('An error was encountered while handling error:\n\n ' + Object(__WEBPACK_IMPORTED_MODULE_6__lib__["V" /* stringifyError */])(err) + '\n\n' + Object(__WEBPACK_IMPORTED_MODULE_6__lib__["V" /* stringifyError */])(errErr));
        }).then(function () {

            if (!_this36.props.onError) {
                throw err;
            }
        });
    };

    ParentComponent.destroyAll = function destroyAll() {
        var results = [];

        while (ParentComponent.activeComponents.length) {
            results.push(ParentComponent.activeComponents[0].destroy());
        }

        return __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__["a" /* ZalgoPromise */].all(results).then(__WEBPACK_IMPORTED_MODULE_6__lib__["I" /* noop */]);
    };

    _createClass(ParentComponent, [{
        key: 'driver',
        get: function get() {

            if (!this.context) {
                throw new Error('Context not set');
            }

            return __WEBPACK_IMPORTED_MODULE_8__drivers__["a" /* RENDER_DRIVERS */][this.context];
        }
    }]);

    return ParentComponent;
}(__WEBPACK_IMPORTED_MODULE_4__base__["a" /* BaseComponent */]), (_applyDecoratedDescriptor(_class.prototype, 'getOutlet', [__WEBPACK_IMPORTED_MODULE_6__lib__["H" /* memoized */]], Object.getOwnPropertyDescriptor(_class.prototype, 'getOutlet'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'prefetch', [__WEBPACK_IMPORTED_MODULE_6__lib__["H" /* memoized */]], Object.getOwnPropertyDescriptor(_class.prototype, 'prefetch'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'loadHTML', [__WEBPACK_IMPORTED_MODULE_6__lib__["H" /* memoized */]], Object.getOwnPropertyDescriptor(_class.prototype, 'loadHTML'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'buildUrl', [__WEBPACK_IMPORTED_MODULE_6__lib__["H" /* memoized */]], Object.getOwnPropertyDescriptor(_class.prototype, 'buildUrl'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'open', [__WEBPACK_IMPORTED_MODULE_6__lib__["H" /* memoized */]], Object.getOwnPropertyDescriptor(_class.prototype, 'open'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'openPrerender', [__WEBPACK_IMPORTED_MODULE_6__lib__["H" /* memoized */]], Object.getOwnPropertyDescriptor(_class.prototype, 'openPrerender'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'switchPrerender', [__WEBPACK_IMPORTED_MODULE_6__lib__["H" /* memoized */]], Object.getOwnPropertyDescriptor(_class.prototype, 'switchPrerender'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'close', [__WEBPACK_IMPORTED_MODULE_6__lib__["H" /* memoized */]], Object.getOwnPropertyDescriptor(_class.prototype, 'close'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'closeContainer', [__WEBPACK_IMPORTED_MODULE_6__lib__["H" /* memoized */]], Object.getOwnPropertyDescriptor(_class.prototype, 'closeContainer'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'destroyContainer', [__WEBPACK_IMPORTED_MODULE_6__lib__["H" /* memoized */]], Object.getOwnPropertyDescriptor(_class.prototype, 'destroyContainer'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'closeComponent', [__WEBPACK_IMPORTED_MODULE_6__lib__["H" /* memoized */]], Object.getOwnPropertyDescriptor(_class.prototype, 'closeComponent'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'showContainer', [__WEBPACK_IMPORTED_MODULE_6__lib__["H" /* memoized */]], Object.getOwnPropertyDescriptor(_class.prototype, 'showContainer'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'showComponent', [__WEBPACK_IMPORTED_MODULE_6__lib__["H" /* memoized */]], Object.getOwnPropertyDescriptor(_class.prototype, 'showComponent'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'hideContainer', [__WEBPACK_IMPORTED_MODULE_6__lib__["H" /* memoized */]], Object.getOwnPropertyDescriptor(_class.prototype, 'hideContainer'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'hideComponent', [__WEBPACK_IMPORTED_MODULE_6__lib__["H" /* memoized */]], Object.getOwnPropertyDescriptor(_class.prototype, 'hideComponent'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'createPrerenderTemplate', [__WEBPACK_IMPORTED_MODULE_6__lib__["H" /* memoized */]], Object.getOwnPropertyDescriptor(_class.prototype, 'createPrerenderTemplate'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'openContainer', [__WEBPACK_IMPORTED_MODULE_6__lib__["H" /* memoized */]], Object.getOwnPropertyDescriptor(_class.prototype, 'openContainer'), _class.prototype)), _class);
ParentComponent.activeComponents = [];

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__receive__ = __webpack_require__(48);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__receive__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_0__receive__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__send__ = __webpack_require__(29);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_1__send__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__listeners__ = __webpack_require__(30);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__listeners__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__listeners__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__listeners__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_2__listeners__["g"]; });




/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getInternalProps;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib__ = __webpack_require__(3);




/*  Internal Props
    --------------

    We define and use certain props by default, for configuration and events that are used at the framework level.
    These follow the same format as regular props, and are classed as reserved words that may not be overriden by users.
*/

function getInternalProps() {
    return {

        // The desired env in which the component is being rendered. Used to determine the correct url

        env: {
            type: 'string',
            required: false,
            queryParam: true,
            def: function def() {
                return this.defaultEnv;
            }
        },

        uid: {
            type: 'string',
            def: function def() {
                return Object(__WEBPACK_IMPORTED_MODULE_1__lib__["Y" /* uniqueID */])();
            },

            queryParam: true
        },

        logLevel: {
            type: 'string',
            required: false,
            queryParam: true,
            def: function def() {
                return this.defaultLogLevel;
            }
        },

        // A custom url to use to render the component

        url: {
            type: 'string',
            required: false,
            promise: true,
            sendToChild: false
        },

        version: {
            type: 'string',
            required: false,
            queryParam: true
        },

        // A millisecond timeout before onTimeout is called

        timeout: {
            type: 'number',
            required: false,
            sendToChild: false
        },

        onDisplay: {
            type: 'function',
            required: false,
            noop: true,
            promisify: true,
            memoize: true,
            sendToChild: false
        },

        onEnter: {
            type: 'function',
            required: false,
            noop: true,
            promisify: true,
            sendToChild: false
        },

        // When we get an INIT message from the child

        onRender: {
            type: 'function',
            required: false,
            noop: true,
            promisify: true,
            sendToChild: false
        },

        // When the user closes the component.

        onClose: {
            type: 'function',
            required: false,
            noop: true,
            once: true,
            promisify: true,
            sendToChild: false
        },

        // When we time-out before getting an INIT message from the child. Defaults to onError if no handler passed.

        onTimeout: {
            type: 'function',
            required: false,
            memoize: true,
            promisify: true,
            sendToChild: false,
            def: function def() {
                return function (err) {
                    if (this.props.onError) {
                        return this.props.onError(err);
                    }
                    throw err;
                };
            }
        },

        // When the component ePperiences an error

        onError: {
            type: 'function',
            required: false,
            promisify: true,
            sendToChild: true,
            once: true
        }
    };
}

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = PopupOpenError;
/* harmony export (immutable) */ __webpack_exports__["a"] = IntegrationError;
/* harmony export (immutable) */ __webpack_exports__["c"] = RenderError;
function PopupOpenError(message) {
    this.message = message;
}

PopupOpenError.prototype = Object.create(Error.prototype);

function IntegrationError(message) {
    this.message = message;
}

IntegrationError.prototype = Object.create(Error.prototype);

function RenderError(message) {
    this.message = message;
}

RenderError.prototype = Object.create(Error.prototype);

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return config; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return logLevels; });

var config = {

    uri: '',
    prefix: '',

    initial_state_name: 'init',

    flushInterval: 10 * 60 * 1000,
    debounceInterval: 10,

    sizeLimit: 300,

    // Supress `console.log`s when `true`
    // Recommended for production usage
    silent: false,

    heartbeat: true,
    heartbeatConsoleLog: true,
    heartbeatInterval: 5000,
    heartbeatTooBusy: false,
    heartbeatTooBusyThreshold: 10000,

    logLevel: 'warn',

    autoLog: ['warn', 'error'],

    logUnload: true,
    logPerformance: true
};

var logLevels = ['error', 'warn', 'info', 'debug'];

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["init"] = init;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bridge", function() { return bridge; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__drivers__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__clean__ = __webpack_require__(51);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "cleanUpWindow", function() { return __WEBPACK_IMPORTED_MODULE_3__clean__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__public__ = __webpack_require__(52);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "parent", function() { return __WEBPACK_IMPORTED_MODULE_4__public__["i"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "send", function() { return __WEBPACK_IMPORTED_MODULE_4__public__["k"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "request", function() { return __WEBPACK_IMPORTED_MODULE_4__public__["j"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "sendToParent", function() { return __WEBPACK_IMPORTED_MODULE_4__public__["l"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "client", function() { return __WEBPACK_IMPORTED_MODULE_4__public__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "on", function() { return __WEBPACK_IMPORTED_MODULE_4__public__["g"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "listen", function() { return __WEBPACK_IMPORTED_MODULE_4__public__["e"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "once", function() { return __WEBPACK_IMPORTED_MODULE_4__public__["h"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "listener", function() { return __WEBPACK_IMPORTED_MODULE_4__public__["f"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "CONFIG", function() { return __WEBPACK_IMPORTED_MODULE_4__public__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "CONSTANTS", function() { return __WEBPACK_IMPORTED_MODULE_4__public__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "disable", function() { return __WEBPACK_IMPORTED_MODULE_4__public__["d"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_zalgo_promise_src__ = __webpack_require__(1);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Promise", function() { return __WEBPACK_IMPORTED_MODULE_5_zalgo_promise_src__["a"]; });





function init() {

    if (!__WEBPACK_IMPORTED_MODULE_2__global__["a" /* global */].initialized) {
        Object(__WEBPACK_IMPORTED_MODULE_1__drivers__["d" /* listenForMessages */])();

        if (false) {
            require('./bridge').openTunnelToOpener();
        }

        Object(__WEBPACK_IMPORTED_MODULE_0__lib__["d" /* initOnReady */])();
        Object(__WEBPACK_IMPORTED_MODULE_0__lib__["h" /* listenForMethods */])();
    }

    __WEBPACK_IMPORTED_MODULE_2__global__["a" /* global */].initialized = true;
}

init();

///////////////////////////
//////////////////////////////////////////////////
/////////

var bridge =  false ? popupBridge : null;




/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["j"] = stringifyError;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return once; });
/* harmony export (immutable) */ __webpack_exports__["f"] = noop;
/* harmony export (immutable) */ __webpack_exports__["a"] = addEventListener;
/* harmony export (immutable) */ __webpack_exports__["k"] = uniqueID;
/* unused harmony export eachArray */
/* unused harmony export eachObject */
/* unused harmony export each */
/* harmony export (immutable) */ __webpack_exports__["h"] = replaceObject;
/* harmony export (immutable) */ __webpack_exports__["i"] = safeInterval;
/* harmony export (immutable) */ __webpack_exports__["c"] = isRegex;
/* unused harmony export weakMapMemoize */
/* harmony export (immutable) */ __webpack_exports__["b"] = getWindowType;
/* harmony export (immutable) */ __webpack_exports__["e"] = jsonStringify;
/* harmony export (immutable) */ __webpack_exports__["d"] = jsonParse;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_cross_domain_safe_weakmap_src__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_cross_domain_utils_src__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__conf__ = __webpack_require__(4);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };





function stringifyError(err) {
    var level = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;


    if (level >= 3) {
        return 'stringifyError stack overflow';
    }

    try {
        if (!err) {
            return '<unknown error: ' + Object.prototype.toString.call(err) + '>';
        }

        if (typeof err === 'string') {
            return err;
        }

        if (err instanceof Error) {
            var stack = err && err.stack;
            var message = err && err.message;

            if (stack && message) {
                if (stack.indexOf(message) !== -1) {
                    return stack;
                } else {
                    return message + '\n' + stack;
                }
            } else if (stack) {
                return stack;
            } else if (message) {
                return message;
            }
        }

        if (typeof err.toString === 'function') {
            return err.toString();
        }

        return Object.prototype.toString.call(err);
    } catch (newErr) {
        return 'Error while stringifying error: ' + stringifyError(newErr, level + 1);
    }
}

// eslint-disable-next-line flowtype/no-weak-types
var once = function once(method) {
    if (!method) {
        return method;
    }
    var called = false;
    return function onceWrapper() {
        if (!called) {
            called = true;
            return method.apply(this, arguments);
        }
    };
};

function noop() {
    // pass
}

function addEventListener(obj, event, handler) {
    if (obj.addEventListener) {
        obj.addEventListener(event, handler);
    } else {
        obj.attachEvent('on' + event, handler);
    }

    return {
        cancel: function cancel() {
            if (obj.removeEventListener) {
                obj.removeEventListener(event, handler);
            } else {
                obj.detachEvent('on' + event, handler);
            }
        }
    };
}

function uniqueID() {

    var chars = '0123456789abcdef';

    return 'xxxxxxxxxx'.replace(/./g, function () {
        return chars.charAt(Math.floor(Math.random() * chars.length));
    });
}

function eachArray(item, callback) {
    for (var i = 0; i < item.length; i++) {
        callback(item[i], i);
    }
}

function eachObject(item, callback) {
    for (var _key in item) {
        if (item.hasOwnProperty(_key)) {
            callback(item[_key], _key);
        }
    }
}

function each(item, callback) {
    if (Array.isArray(item)) {
        eachArray(item, callback);
    } else if ((typeof item === 'undefined' ? 'undefined' : _typeof(item)) === 'object' && item !== null) {
        eachObject(item, callback);
    }
}

function replaceObject(item, callback) {
    var depth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;


    if (depth >= 100) {
        throw new Error('Self-referential object passed, or object contained too many layers');
    }

    var newobj = void 0;

    if ((typeof item === 'undefined' ? 'undefined' : _typeof(item)) === 'object' && item !== null && !Array.isArray(item)) {
        newobj = {};
    } else if (Array.isArray(item)) {
        newobj = [];
    } else {
        throw new Error('Invalid type: ' + (typeof item === 'undefined' ? 'undefined' : _typeof(item)));
    }

    each(item, function (childItem, key) {

        var result = callback(childItem, key);

        if (typeof result !== 'undefined') {
            // $FlowFixMe
            newobj[key] = result;
        } else if ((typeof childItem === 'undefined' ? 'undefined' : _typeof(childItem)) === 'object' && childItem !== null) {
            // $FlowFixMe
            newobj[key] = replaceObject(childItem, callback, depth + 1);
        } else {
            // $FlowFixMe
            newobj[key] = childItem;
        }
    });

    // $FlowFixMe
    return newobj;
}

function safeInterval(method, time) {
    var timeout = void 0;

    function runInterval() {
        timeout = setTimeout(runInterval, time);
        method.call();
    }

    timeout = setTimeout(runInterval, time);

    return {
        cancel: function cancel() {
            clearTimeout(timeout);
        }
    };
}

function isRegex(item) {
    return Object.prototype.toString.call(item) === '[object RegExp]';
}

// eslint-disable-next-line flowtype/no-weak-types
var weakMapMemoize = function weakMapMemoize(method) {

    var weakmap = new __WEBPACK_IMPORTED_MODULE_0_cross_domain_safe_weakmap_src__["a" /* WeakMap */]();

    // eslint-disable-next-line flowtype/no-weak-types
    return function (arg) {
        var result = weakmap.get(arg);

        if (typeof result !== 'undefined') {
            return result;
        }

        result = method.call(this, arg);

        if (typeof result !== 'undefined') {
            weakmap.set(arg, result);
        }

        return result;
    };
};

function getWindowType() {
    if (Object(__WEBPACK_IMPORTED_MODULE_1_cross_domain_utils_src__["o" /* isPopup */])()) {
        return __WEBPACK_IMPORTED_MODULE_2__conf__["b" /* CONSTANTS */].WINDOW_TYPES.POPUP;
    }
    if (Object(__WEBPACK_IMPORTED_MODULE_1_cross_domain_utils_src__["n" /* isIframe */])()) {
        return __WEBPACK_IMPORTED_MODULE_2__conf__["b" /* CONSTANTS */].WINDOW_TYPES.IFRAME;
    }
    return __WEBPACK_IMPORTED_MODULE_2__conf__["b" /* CONSTANTS */].WINDOW_TYPES.FULLPAGE;
}

function jsonStringify(obj, replacer, indent) {

    var objectToJSON = void 0;
    var arrayToJSON = void 0;

    try {
        if (JSON.stringify({}) !== '{}') {
            // $FlowFixMe
            objectToJSON = Object.prototype.toJSON;
            // $FlowFixMe
            delete Object.prototype.toJSON;
        }

        if (JSON.stringify({}) !== '{}') {
            throw new Error('Can not correctly serialize JSON objects');
        }

        if (JSON.stringify([]) !== '[]') {
            // $FlowFixMe
            arrayToJSON = Array.prototype.toJSON;
            // $FlowFixMe
            delete Array.prototype.toJSON;
        }

        if (JSON.stringify([]) !== '[]') {
            throw new Error('Can not correctly serialize JSON objects');
        }
    } catch (err) {
        throw new Error('Can not repair JSON.stringify: ' + err.message);
    }

    var result = JSON.stringify.call(this, obj, replacer, indent);

    try {
        if (objectToJSON) {
            // $FlowFixMe
            Object.prototype.toJSON = objectToJSON; // eslint-disable-line
        }

        if (arrayToJSON) {
            // $FlowFixMe
            Array.prototype.toJSON = arrayToJSON; // eslint-disable-line
        }
    } catch (err) {
        throw new Error('Can not repair JSON.stringify: ' + err.message);
    }

    return result;
}

function jsonParse(item) {
    return JSON.parse(item);
}

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BaseComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_post_robot_src__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__component__ = __webpack_require__(2);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }







function cleanup(obj) {

    var tasks = [];
    var cleaned = false;

    return {
        set: function set(name, item) {

            if (cleaned) {
                return item;
            }

            obj[name] = item;
            this.register(function () {
                delete obj[name];
            });
            return item;
        },
        register: function register(name, method) {

            if (typeof name === 'function') {
                method = name;
                name = '<anonymous-cleanup-handler>';
            }

            if (typeof method !== 'function') {
                throw new Error('Expected to be passed function to clean.register');
            }

            if (cleaned) {
                method();
                return;
            }

            tasks.push({
                complete: false,

                name: name,

                run: function run() {

                    if (this.complete) {
                        return;
                    }

                    this.complete = true;

                    if (method) {
                        method();
                    }
                }
            });
        },
        hasTasks: function hasTasks() {
            return Boolean(tasks.filter(function (item) {
                return !item.complete;
            }).length);
        },
        all: function all() {
            var results = [];

            cleaned = true;

            while (tasks.length) {
                results.push(tasks.pop().run());
            }

            return __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__["a" /* ZalgoPromise */].all(results).then(function () {/* pass */});
        },
        run: function run(name) {
            var results = [];

            for (var _iterator = tasks, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
                var _ref;

                if (_isArray) {
                    if (_i >= _iterator.length) break;
                    _ref = _iterator[_i++];
                } else {
                    _i = _iterator.next();
                    if (_i.done) break;
                    _ref = _i.value;
                }

                var item = _ref;

                if (item.name === name) {
                    results.push(item.run());
                }
            }

            return __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__["a" /* ZalgoPromise */].all(results).then(function () {
                return;
            });
        }
    };
}

/*  Base Component
    --------------

    Methods that are common between child and parent components, but are not generic or uncoupled enough to live in
    a separate library.
*/

var BaseComponent = function () {
    function BaseComponent() {
        _classCallCheck(this, BaseComponent);

        this.clean = cleanup(this);
        this.event = Object(__WEBPACK_IMPORTED_MODULE_2__lib__["s" /* eventEmitter */])();
    }

    BaseComponent.prototype.addProp = function addProp(options, name, def) {
        Object(__WEBPACK_IMPORTED_MODULE_2__lib__["g" /* copyProp */])(options, this, name, def);
    };

    BaseComponent.prototype.on = function on(eventName, handler) {
        return this.event.on(eventName, handler);
    };

    BaseComponent.prototype.listeners = function listeners() {
        throw new Error('Expected listeners to be implemented');
    };

    BaseComponent.prototype.error = function error(err) {
        throw new Error('Expected error to be implemented - got ' + Object(__WEBPACK_IMPORTED_MODULE_2__lib__["V" /* stringifyError */])(err));
    };

    /*  Listen
        ------
         Listen for any post messages defined in this.listeners(). All (most) of our communication is done via
        post-messages, so this sets up an easy way to create a collection of listeners in one go.
         All post-messaging is done using post-robot.
    */

    BaseComponent.prototype.listen = function listen(win, domain) {
        var _this = this;

        if (!win) {
            throw this.component.createError('window to listen to not set');
        }

        if (!domain) {
            throw new Error('Must pass domain to listen to');
        }

        if (!this.listeners) {
            return;
        }

        var listeners = this.listeners();

        var _loop = function _loop() {
            if (_isArray2) {
                if (_i2 >= _iterator2.length) return 'break';
                _ref2 = _iterator2[_i2++];
            } else {
                _i2 = _iterator2.next();
                if (_i2.done) return 'break';
                _ref2 = _i2.value;
            }

            var listenerName = _ref2;


            var name = listenerName.replace(/^xcomponent_/, '');

            var listener = Object(__WEBPACK_IMPORTED_MODULE_1_post_robot_src__["on"])(listenerName, { window: win, domain: domain, errorHandler: function errorHandler(err) {
                    _this.error(err);
                } }, function (_ref3) {
                var source = _ref3.source,
                    data = _ref3.data;

                _this.component.log('listener_' + name);
                return listeners[listenerName].call(_this, source, data);
            });

            var errorListener = Object(__WEBPACK_IMPORTED_MODULE_1_post_robot_src__["on"])(listenerName, { window: win, errorHandler: function errorHandler(err) {
                    _this.error(err);
                } }, function (_ref4) {
                var origin = _ref4.origin,
                    data = _ref4.data;

                _this.component.logError('unexpected_listener_' + name, { origin: origin, domain: domain.toString() });
                _this.error(new Error('Unexpected ' + name + ' message from domain ' + origin + ' -- expected message from ' + domain.toString()));
            });

            _this.clean.register(function () {
                listener.cancel();
                errorListener.cancel();
            });
        };

        for (var _iterator2 = Object.keys(listeners), _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
            var _ref2;

            var _ret = _loop();

            if (_ret === 'break') break;
        }
    };

    return BaseComponent;
}();

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return _track; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return buffer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return tracking; });
/* harmony export (immutable) */ __webpack_exports__["e"] = getTransport;
/* harmony export (immutable) */ __webpack_exports__["k"] = setTransport;
/* harmony export (immutable) */ __webpack_exports__["j"] = print;
/* harmony export (immutable) */ __webpack_exports__["f"] = immediateFlush;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return _flush; });
/* harmony export (immutable) */ __webpack_exports__["h"] = log;
/* harmony export (immutable) */ __webpack_exports__["i"] = prefix;
/* harmony export (immutable) */ __webpack_exports__["b"] = debug;
/* harmony export (immutable) */ __webpack_exports__["g"] = info;
/* harmony export (immutable) */ __webpack_exports__["n"] = warn;
/* harmony export (immutable) */ __webpack_exports__["c"] = error;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__builders__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(14);


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };





var buffer = [];
var tracking = [];

if (Function.prototype.bind && window.console && _typeof(console.log) === 'object') {
    ['log', 'info', 'warn', 'error'].forEach(function (method) {
        console[method] = this.bind(console[method], console);
    }, Function.prototype.call);
}

var transport = function transport(headers, data, options) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__util__["a" /* ajax */])('post', __WEBPACK_IMPORTED_MODULE_2__config__["a" /* config */].uri, headers, data, options);
};

function getTransport() {
    return transport;
}

function setTransport(newTransport) {
    transport = newTransport;
}

var loaded = false;

setTimeout(function () {
    loaded = true;
}, 1);

function print(level, event, payload) {

    if (!loaded) {
        return setTimeout(function () {
            return print(level, event, payload);
        }, 1);
    }

    if (!window.console || !window.console.log) {
        return;
    }

    var logLevel = window.LOG_LEVEL || __WEBPACK_IMPORTED_MODULE_2__config__["a" /* config */].logLevel;

    if (__WEBPACK_IMPORTED_MODULE_2__config__["b" /* logLevels */].indexOf(level) > __WEBPACK_IMPORTED_MODULE_2__config__["b" /* logLevels */].indexOf(logLevel)) {
        return;
    }

    payload = payload || {};

    var args = [event];

    if (Object(__WEBPACK_IMPORTED_MODULE_0__util__["c" /* isIE */])()) {
        payload = JSON.stringify(payload);
    }

    args.push(payload);

    if (payload.error || payload.warning) {
        args.push('\n\n', payload.error || payload.warning);
    }

    try {
        if (window.console[level] && window.console[level].apply) {
            window.console[level].apply(window.console, args);
        } else if (window.console.log && window.console.log.apply) {
            window.console.log.apply(window.console, args);
        }
    } catch (err) {
        // pass
    }
}

function immediateFlush() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$fireAndForget = _ref.fireAndForget,
        fireAndForget = _ref$fireAndForget === undefined ? false : _ref$fireAndForget;

    if (!__WEBPACK_IMPORTED_MODULE_2__config__["a" /* config */].uri) {
        return;
    }

    var hasBuffer = buffer.length;
    var hasTracking = tracking.length;

    if (!hasBuffer && !hasTracking) {
        return;
    }

    var meta = {};

    for (var _iterator = __WEBPACK_IMPORTED_MODULE_1__builders__["f" /* metaBuilders */], _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
        var _ref2;

        if (_isArray) {
            if (_i >= _iterator.length) break;
            _ref2 = _iterator[_i++];
        } else {
            _i = _iterator.next();
            if (_i.done) break;
            _ref2 = _i.value;
        }

        var builder = _ref2;

        try {
            Object(__WEBPACK_IMPORTED_MODULE_0__util__["b" /* extend */])(meta, builder(), false);
        } catch (err) {
            console.error('Error in custom meta builder:', err.stack || err.toString());
        }
    }

    var headers = {};

    for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1__builders__["e" /* headerBuilders */], _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
        var _ref3;

        if (_isArray2) {
            if (_i2 >= _iterator2.length) break;
            _ref3 = _iterator2[_i2++];
        } else {
            _i2 = _iterator2.next();
            if (_i2.done) break;
            _ref3 = _i2.value;
        }

        var _builder = _ref3;

        try {
            Object(__WEBPACK_IMPORTED_MODULE_0__util__["b" /* extend */])(headers, _builder(), false);
        } catch (err) {
            console.error('Error in custom header builder:', err.stack || err.toString());
        }
    }

    var events = buffer;

    var req = transport(headers, {
        events: events,
        meta: meta,
        tracking: tracking
    }, {
        fireAndForget: fireAndForget
    });

    buffer = [];
    tracking = [];

    return req;
}

var _flush = Object(__WEBPACK_IMPORTED_MODULE_0__util__["d" /* promiseDebounce */])(immediateFlush, __WEBPACK_IMPORTED_MODULE_2__config__["a" /* config */].debounceInterval);


function enqueue(level, event, payload) {

    buffer.push({
        level: level,
        event: event,
        payload: payload
    });

    if (__WEBPACK_IMPORTED_MODULE_2__config__["a" /* config */].autoLog.indexOf(level) > -1) {
        _flush();
    }
}

function log(level, event, payload) {

    if (__WEBPACK_IMPORTED_MODULE_2__config__["a" /* config */].prefix) {
        event = __WEBPACK_IMPORTED_MODULE_2__config__["a" /* config */].prefix + '_' + event;
    }

    payload = payload || {};

    if (typeof payload === 'string') {
        payload = {
            message: payload
        };
    } else if (payload instanceof Error) {
        payload = {
            error: payload.stack || payload.toString()
        };
    }

    try {
        JSON.stringify(payload);
    } catch (err) {
        return;
    }

    payload.timestamp = Date.now();

    for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_1__builders__["g" /* payloadBuilders */], _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
        var _ref4;

        if (_isArray3) {
            if (_i3 >= _iterator3.length) break;
            _ref4 = _iterator3[_i3++];
        } else {
            _i3 = _iterator3.next();
            if (_i3.done) break;
            _ref4 = _i3.value;
        }

        var builder = _ref4;

        try {
            Object(__WEBPACK_IMPORTED_MODULE_0__util__["b" /* extend */])(payload, builder(), false);
        } catch (err) {
            console.error('Error in custom payload builder:', err.stack || err.toString());
        }
    }

    if (!__WEBPACK_IMPORTED_MODULE_2__config__["a" /* config */].silent) {
        print(level, event, payload);
    }

    if (buffer.length === __WEBPACK_IMPORTED_MODULE_2__config__["a" /* config */].sizeLimit) {
        enqueue('info', 'logger_max_buffer_length');
    } else if (buffer.length < __WEBPACK_IMPORTED_MODULE_2__config__["a" /* config */].sizeLimit) {
        enqueue(level, event, payload);
    }
}

function prefix(name) {

    return {
        debug: function debug(event, payload) {
            return log('debug', name + '_' + event, payload);
        },
        info: function info(event, payload) {
            return log('info', name + '_' + event, payload);
        },
        warn: function warn(event, payload) {
            return log('warn', name + '_' + event, payload);
        },
        error: function error(event, payload) {
            return log('error', name + '_' + event, payload);
        },
        track: function track(payload) {
            return _track(payload);
        },
        flush: function flush() {
            return _flush();
        }
    };
}

function debug(event, payload) {
    return log('debug', event, payload);
}

function info(event, payload) {
    return log('info', event, payload);
}

function warn(event, payload) {
    return log('warn', event, payload);
}

function error(event, payload) {
    return log('error', event, payload);
}

function _track(payload) {
    if (payload) {

        try {
            JSON.stringify(payload);
        } catch (err) {
            return;
        }

        for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_1__builders__["h" /* trackingBuilders */], _isArray4 = Array.isArray(_iterator4), _i4 = 0, _iterator4 = _isArray4 ? _iterator4 : _iterator4[Symbol.iterator]();;) {
            var _ref5;

            if (_isArray4) {
                if (_i4 >= _iterator4.length) break;
                _ref5 = _iterator4[_i4++];
            } else {
                _i4 = _iterator4.next();
                if (_i4.done) break;
                _ref5 = _i4.value;
            }

            var builder = _ref5;

            try {
                Object(__WEBPACK_IMPORTED_MODULE_0__util__["b" /* extend */])(payload, builder(), false);
            } catch (err) {
                console.error('Error in custom tracking builder:', err.stack || err.toString());
            }
        }

        print('debug', 'tracking', payload);

        tracking.push(payload);
    }
}

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = extend;
/* unused harmony export isSameProtocol */
/* unused harmony export isSameDomain */
/* harmony export (immutable) */ __webpack_exports__["a"] = ajax;
/* harmony export (immutable) */ __webpack_exports__["d"] = promiseDebounce;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return windowReady; });
/* harmony export (immutable) */ __webpack_exports__["e"] = safeInterval;
/* harmony export (immutable) */ __webpack_exports__["f"] = uniqueID;
/* harmony export (immutable) */ __webpack_exports__["c"] = isIE;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__ = __webpack_require__(1);



function extend(dest, src) {
    var over = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

    dest = dest || {};
    src = src || {};

    for (var i in src) {
        if (src.hasOwnProperty(i)) {
            if (over || !dest.hasOwnProperty(i)) {
                dest[i] = src[i];
            }
        }
    }

    return dest;
}

function isSameProtocol(url) {
    return window.location.protocol === url.split('/')[0];
}

function isSameDomain(url) {
    var match = url.match(/https?:\/\/[^/]+/);

    if (!match) {
        return true;
    }

    return match[0] === window.location.protocol + '//' + window.location.host;
}

function ajax(method, url) {
    var headers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var data = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    var _ref = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {},
        _ref$fireAndForget = _ref.fireAndForget,
        fireAndForget = _ref$fireAndForget === undefined ? false : _ref$fireAndForget;

    return new __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__["a" /* ZalgoPromise */](function (resolve) {
        var XRequest = window.XMLHttpRequest || window.ActiveXObject;

        if (window.XDomainRequest && !isSameDomain(url)) {

            if (!isSameProtocol(url)) {
                return resolve();
            }

            XRequest = window.XDomainRequest;
        }

        var req = new XRequest('MSXML2.XMLHTTP.3.0');
        req.open(method.toUpperCase(), url, true);

        if (typeof req.setRequestHeader === 'function') {
            req.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
            req.setRequestHeader('Content-type', 'application/json');

            for (var headerName in headers) {
                if (headers.hasOwnProperty(headerName)) {
                    req.setRequestHeader(headerName, headers[headerName]);
                }
            }
        }

        if (fireAndForget) {
            resolve();
        } else {
            req.onreadystatechange = function () {
                if (req.readyState > 3) {
                    resolve();
                }
            };
        }

        req.send(JSON.stringify(data).replace(/&/g, '%26'));
    });
}

function promiseDebounce(method, interval) {

    var debounce = {};

    return function () {
        var args = arguments;

        if (debounce.timeout) {
            clearTimeout(debounce.timeout);
            delete debounce.timeout;
        }

        debounce.timeout = setTimeout(function () {

            var resolver = debounce.resolver;
            var rejector = debounce.rejector;

            delete debounce.promise;
            delete debounce.resolver;
            delete debounce.rejector;
            delete debounce.timeout;

            return __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__["a" /* ZalgoPromise */].resolve().then(function () {
                return method.apply(null, args);
            }).then(resolver, rejector);
        }, interval);

        debounce.promise = debounce.promise || new __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__["a" /* ZalgoPromise */](function (resolver, rejector) {
            debounce.resolver = resolver;
            debounce.rejector = rejector;
        });

        return debounce.promise;
    };
}

var windowReady = new __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__["a" /* ZalgoPromise */](function (resolve) {
    // guard document, and window.addEventListener for JSC (react-native)
    if (typeof document !== 'undefined' && document.readyState === 'complete') {
        resolve();
    }

    if (window.addEventListener) {
        window.addEventListener('load', resolve);
    }
});

function safeInterval(method, time) {

    var timeout = void 0;

    function loop() {
        timeout = setTimeout(function () {
            method();
            loop();
        }, time);
    }

    loop();

    return {
        cancel: function cancel() {
            clearTimeout(timeout);
        }
    };
}

function uniqueID() {
    var chars = '0123456789abcdef';

    return 'xxxxxxxxxx'.replace(/./g, function () {
        return chars.charAt(Math.floor(Math.random() * chars.length));
    });
}

function isIE() {
    return Boolean(window.document.documentMode);
}

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return payloadBuilders; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return metaBuilders; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return trackingBuilders; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return headerBuilders; });
/* harmony export (immutable) */ __webpack_exports__["c"] = addPayloadBuilder;
/* harmony export (immutable) */ __webpack_exports__["b"] = addMetaBuilder;
/* harmony export (immutable) */ __webpack_exports__["d"] = addTrackingBuilder;
/* harmony export (immutable) */ __webpack_exports__["a"] = addHeaderBuilder;

var payloadBuilders = [];
var metaBuilders = [];
var trackingBuilders = [];
var headerBuilders = [];

function addPayloadBuilder(builder) {
    payloadBuilders.push(builder);
}

function addMetaBuilder(builder) {
    metaBuilders.push(builder);
}

function addTrackingBuilder(builder) {
    trackingBuilders.push(builder);
}

function addHeaderBuilder(builder) {
    headerBuilders.push(builder);
}

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = buildChildWindowName;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return isXComponentWindow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getComponentMeta; });
/* harmony export (immutable) */ __webpack_exports__["d"] = getParentDomain;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getParentComponentWindow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getParentRenderWindow; });
/* unused harmony export getPosition */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_cross_domain_utils_src__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_hi_base32__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_hi_base32___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_hi_base32__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(5);





function normalize(str) {
    return str.replace(/^[^a-z0-9A-Z]+|[^a-z0-9A-Z]+$/g, '').replace(/[^a-z0-9A-Z]+/g, '_');
}

/*  Build Child Window Name
    -----------------------

    Build a name for our child window. This should identify the following things to the child:

    - That the window was created by, and is owned by xcomponent
    - The name of the child's parent. This is so the child can identify which window created it, even when we do a
      renderTo, in which case the true parent may actually be a sibling frame in the window hierarchy

    We base64 encode the window name so IE doesn't die when it encounters any characters that it doesn't like.
*/

function buildChildWindowName(name, version) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};


    options.id = Object(__WEBPACK_IMPORTED_MODULE_2__lib__["Y" /* uniqueID */])();
    options.domain = Object(__WEBPACK_IMPORTED_MODULE_0_cross_domain_utils_src__["f" /* getDomain */])(window);

    var encodedName = normalize(name);
    var encodedVersion = normalize(version);
    var encodedOptions = __WEBPACK_IMPORTED_MODULE_1_hi_base32___default.a.encode(JSON.stringify(options)).replace(/\=/g, '').toLowerCase();

    if (!encodedName) {
        throw new Error('Invalid name: ' + name + ' - must contain alphanumeric characters');
    }

    if (!encodedVersion) {
        throw new Error('Invalid version: ' + version + ' - must contain alphanumeric characters');
    }

    return [__WEBPACK_IMPORTED_MODULE_3__constants__["XCOMPONENT"], encodedName, encodedVersion, encodedOptions, ''].join('__');
}

var isXComponentWindow = Object(__WEBPACK_IMPORTED_MODULE_2__lib__["G" /* memoize */])(function () {
    if (!window.name) {
        return false;
    }

    var _window$name$split = window.name.split('__'),
        xcomp = _window$name$split[0];

    if (xcomp !== __WEBPACK_IMPORTED_MODULE_3__constants__["XCOMPONENT"]) {
        return false;
    }

    return true;
});

/*  Parse Window Name
    -----------------

    The inverse of buildChildWindowName. Base64 decodes and json parses the window name to get the original props
    passed down, including the parent name. Only accepts window names built by xcomponent
*/

var getComponentMeta = Object(__WEBPACK_IMPORTED_MODULE_2__lib__["G" /* memoize */])(function () {

    if (!window.name) {
        throw new Error('Can not get component meta without window name');
    }

    var _window$name$split2 = window.name.split('__'),
        xcomp = _window$name$split2[0],
        name = _window$name$split2[1],
        version = _window$name$split2[2],
        encodedOptions = _window$name$split2[3];

    if (xcomp !== __WEBPACK_IMPORTED_MODULE_3__constants__["XCOMPONENT"]) {
        throw new Error('Window not rendered by xcomponent - got ' + xcomp);
    }

    var componentMeta = void 0;

    try {
        componentMeta = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_hi_base32___default.a.decode(encodedOptions.toUpperCase()));
    } catch (err) {
        throw new Error('Can not decode component-meta');
    }

    componentMeta.name = name;
    componentMeta.version = version.replace(/_/g, '.');

    return componentMeta;
});

function getParentDomain() {
    return getComponentMeta().domain; // How does this work for renderTo..?
}

function getWindowByRef(_ref) {
    var ref = _ref.ref,
        uid = _ref.uid,
        distance = _ref.distance;


    var result = void 0;

    if (ref === __WEBPACK_IMPORTED_MODULE_3__constants__["WINDOW_REFERENCES"].OPENER) {
        result = Object(__WEBPACK_IMPORTED_MODULE_0_cross_domain_utils_src__["i" /* getOpener */])(window);
    } else if (ref === __WEBPACK_IMPORTED_MODULE_3__constants__["WINDOW_REFERENCES"].TOP) {
        result = Object(__WEBPACK_IMPORTED_MODULE_0_cross_domain_utils_src__["k" /* getTop */])(window);
    } else if (ref === __WEBPACK_IMPORTED_MODULE_3__constants__["WINDOW_REFERENCES"].PARENT) {

        if (distance) {
            result = Object(__WEBPACK_IMPORTED_MODULE_0_cross_domain_utils_src__["h" /* getNthParentFromTop */])(window, distance);
        } else {
            result = Object(__WEBPACK_IMPORTED_MODULE_0_cross_domain_utils_src__["j" /* getParent */])(window);
        }
    }

    if (ref === __WEBPACK_IMPORTED_MODULE_3__constants__["WINDOW_REFERENCES"].GLOBAL) {
        var ancestor = Object(__WEBPACK_IMPORTED_MODULE_0_cross_domain_utils_src__["d" /* getAncestor */])(window);

        if (ancestor) {
            for (var _iterator = Object(__WEBPACK_IMPORTED_MODULE_0_cross_domain_utils_src__["c" /* getAllFramesInWindow */])(ancestor), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
                var _ref2;

                if (_isArray) {
                    if (_i >= _iterator.length) break;
                    _ref2 = _iterator[_i++];
                } else {
                    _i = _iterator.next();
                    if (_i.done) break;
                    _ref2 = _i.value;
                }

                var frame = _ref2;

                var global = Object(__WEBPACK_IMPORTED_MODULE_2__lib__["z" /* globalFor */])(frame);

                if (global && global.windows && global.windows[uid]) {
                    result = global.windows[uid];
                    break;
                }
            }
        }
    }

    if (!result) {
        throw new Error('Unable to find window by ref');
    }

    return result;
}

/*  Get Parent Component Window
    ---------------------------

    Get the parent component window, which may be different from the actual parent window
*/

var getParentComponentWindow = Object(__WEBPACK_IMPORTED_MODULE_2__lib__["G" /* memoize */])(function () {

    var componentMeta = getComponentMeta();

    if (!componentMeta) {
        throw new Error('Can not get parent component window - window not rendered by xcomponent');
    }

    return getWindowByRef(componentMeta.componentParent);
});

var getParentRenderWindow = Object(__WEBPACK_IMPORTED_MODULE_2__lib__["G" /* memoize */])(function () {

    var componentMeta = getComponentMeta();

    if (!componentMeta) {
        throw new Error('Can not get parent component window - window not rendered by xcomponent');
    }

    return getWindowByRef(componentMeta.renderParent);
});

/*  Get Position
    ------------

    Calculate the position for the popup

    This is either
    - Specified by the user
    - The center of the screen

    I'd love to do this with pure css, but alas... popup windows :(
*/

function getPosition(_ref3) {
    var width = _ref3.width,
        height = _ref3.height;


    var x = 0;
    var y = 0;

    if (width) {
        if (window.outerWidth) {
            x = Math.round((window.outerWidth - width) / 2) + window.screenX;
        } else if (window.screen.width) {
            x = Math.round((window.screen.width - width) / 2);
        }
    }

    if (height) {
        if (window.outerHeight) {
            y = Math.round((window.outerHeight - height) / 2) + window.screenY;
        } else if (window.screen.height) {
            y = Math.round((window.screen.height - height) / 2);
        }
    }

    return { x: x, y: y };
}

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return log; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__conf__ = __webpack_require__(4);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };




var LOG_LEVELS = ['debug', 'info', 'warn', 'error'];

if (Function.prototype.bind && window.console && _typeof(console.log) === 'object') {
    ['log', 'info', 'warn', 'error'].forEach(function (method) {
        // $FlowFixMe
        console[method] = this.bind(console[method], console);
    }, Function.prototype.call);
}

var log = {
    clearLogs: function clearLogs() {

        if (window.console && window.console.clear) {
            window.console.clear();
        }

        if (__WEBPACK_IMPORTED_MODULE_1__conf__["a" /* CONFIG */].LOG_TO_PAGE) {
            var container = document.getElementById('postRobotLogs');

            if (container && container.parentNode) {
                container.parentNode.removeChild(container);
            }
        }
    },
    writeToPage: function writeToPage(level, args) {
        setTimeout(function () {
            var container = document.getElementById('postRobotLogs');

            if (!container) {
                container = document.createElement('div');
                container.id = 'postRobotLogs';
                container.style.cssText = 'width: 800px; font-family: monospace; white-space: pre-wrap;';
                if (document.body) {
                    document.body.appendChild(container);
                }
            }

            var el = document.createElement('div');

            var date = new Date().toString().split(' ')[4];

            var payload = Array.prototype.slice.call(args).map(function (item) {
                if (typeof item === 'string') {
                    return item;
                }
                if (!item) {
                    return Object.prototype.toString.call(item);
                }
                var json = void 0;
                try {
                    json = Object(__WEBPACK_IMPORTED_MODULE_0__util__["e" /* jsonStringify */])(item, null, 2);
                } catch (e) {
                    json = '[object]';
                }

                return '\n\n' + json + '\n\n';
            }).join(' ');

            var msg = date + ' ' + level + ' ' + payload;
            el.innerHTML = msg;

            var color = {
                log: '#ddd',
                warn: 'orange',
                error: 'red',
                info: 'blue',
                debug: '#aaa'
            }[level];

            el.style.cssText = 'margin-top: 10px; color: ' + color + ';';

            if (!container.childNodes.length) {
                container.appendChild(el);
            } else {
                container.insertBefore(el, container.childNodes[0]);
            }
        });
    },
    logLevel: function logLevel(level, args) {
        setTimeout(function () {
            try {
                var logLevel = window.LOG_LEVEL || __WEBPACK_IMPORTED_MODULE_1__conf__["a" /* CONFIG */].LOG_LEVEL;

                if (LOG_LEVELS.indexOf(level) < LOG_LEVELS.indexOf(logLevel)) {
                    return;
                }

                args = Array.prototype.slice.call(args);

                args.unshift('' + window.location.host + window.location.pathname);
                args.unshift('::');
                args.unshift('' + Object(__WEBPACK_IMPORTED_MODULE_0__util__["b" /* getWindowType */])().toLowerCase());
                args.unshift('[post-robot]');

                if (__WEBPACK_IMPORTED_MODULE_1__conf__["a" /* CONFIG */].LOG_TO_PAGE) {
                    log.writeToPage(level, args);
                }

                if (!window.console) {
                    return;
                }

                if (!window.console[level]) {
                    level = 'log';
                }

                if (!window.console[level]) {
                    return;
                }

                window.console[level].apply(window.console, args);
            } catch (err) {
                // pass
            }
        }, 1);
    },
    debug: function debug() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        log.logLevel('debug', args);
    },
    info: function info() {
        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
        }

        log.logLevel('info', args);
    },
    warn: function warn() {
        for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
            args[_key3] = arguments[_key3];
        }

        log.logLevel('warn', args);
    },
    error: function error() {
        for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
            args[_key4] = arguments[_key4];
        }

        log.logLevel('error', args);
    }
};

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["n"] = urlEncode;
/* unused harmony export camelToDasherize */
/* harmony export (immutable) */ __webpack_exports__["c"] = dasherizeToCamel;
/* harmony export (immutable) */ __webpack_exports__["f"] = extend;
/* harmony export (immutable) */ __webpack_exports__["o"] = values;
/* harmony export (immutable) */ __webpack_exports__["m"] = uniqueID;
/* unused harmony export stringifyWithFunctions */
/* unused harmony export safeGet */
/* harmony export (immutable) */ __webpack_exports__["a"] = capitalizeFirstLetter;
/* harmony export (immutable) */ __webpack_exports__["g"] = get;
/* harmony export (immutable) */ __webpack_exports__["j"] = safeInterval;
/* unused harmony export safeTimeout */
/* unused harmony export each */
/* harmony export (immutable) */ __webpack_exports__["i"] = replaceObject;
/* harmony export (immutable) */ __webpack_exports__["b"] = copyProp;
/* harmony export (immutable) */ __webpack_exports__["d"] = dotify;
/* harmony export (immutable) */ __webpack_exports__["h"] = getObjectID;
/* unused harmony export regex */
/* unused harmony export regexAll */
/* unused harmony export count */
/* harmony export (immutable) */ __webpack_exports__["k"] = stringify;
/* harmony export (immutable) */ __webpack_exports__["l"] = stringifyError;
/* harmony export (immutable) */ __webpack_exports__["e"] = eventEmitter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_cross_domain_safe_weakmap_src__ = __webpack_require__(8);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };



/*  Url Encode
    ----------

    Replace ? and & with encoded values. Allows other values (to create more readable urls than encodeUriComponent)
*/

function urlEncode(str) {
    return str.replace(/\?/g, '%3F').replace(/\&/g, '%26').replace(/#/g, '%23').replace(/\+/g, '%2B');
}

/*  Camel To Dasherize
    ------------------

    Convert camelCaseText to dasherized-text
*/

function camelToDasherize(string) {
    return string.replace(/([A-Z])/g, function (g) {
        return '-' + g.toLowerCase();
    });
}

/*  Dasherize to Camel
    ------------------

    Convert dasherized-text to camelCaseText
*/

function dasherizeToCamel(string) {
    return string.replace(/-([a-z])/g, function (g) {
        return g[1].toUpperCase();
    });
}

/*  Extend
    ------

    Extend one object with another
*/

function extend(obj, source) {
    if (!source) {
        return obj;
    }

    for (var key in source) {
        if (source.hasOwnProperty(key)) {
            obj[key] = source[key];
        }
    }

    return obj;
}

/*  Values
    ------

    Get all of the values from an object as an array
*/

function values(obj) {
    var results = [];

    for (var key in obj) {
        if (obj.hasOwnProperty(key)) {
            results.push(obj[key]);
        }
    }

    return results;
}

/*  Unique ID
    ---------

    Generate a unique, random hex id
*/

function uniqueID() {

    var chars = '0123456789abcdef';

    return 'xxxxxxxxxx'.replace(/./g, function () {
        return chars.charAt(Math.floor(Math.random() * chars.length));
    });
}

/*  Stringify with Functions
    ------------------------

    JSON Stringify with added support for functions
*/

function stringifyWithFunctions(obj) {
    return JSON.stringify(obj, function (key, val) {
        if (typeof val === 'function') {
            return val.toString();
        }
        return val;
    });
}

/*  Safe Get
    --------

    Get a property without throwing error
*/

function safeGet(obj, prop) {

    var result = void 0;

    try {
        result = obj[prop];
    } catch (err) {
        // pass
    }

    return result;
}

/* Capitalize First Letter
   -----------------------
*/

function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
}

/*  Get
    ---

    Recursively gets a deep path from an object, returning a default value if any level is not found
*/

function get(item, path, def) {

    if (!path) {
        return def;
    }

    var pathParts = path.split('.');

    // Loop through each section of our key path

    for (var i = 0; i < pathParts.length; i++) {

        // If we have an object, we can get the key

        if ((typeof item === 'undefined' ? 'undefined' : _typeof(item)) === 'object' && item !== null) {
            item = item[pathParts[i]];

            // Otherwise, we should return the default (undefined if not provided)
        } else {
            return def;
        }
    }

    // If our final result is undefined, we should return the default

    return item === undefined ? def : item;
}

/*  Safe Interval
    -------------

    Implement setInterval using setTimeout, to avoid stacking up calls from setInterval
*/

function safeInterval(method, time) {

    var timeout = void 0;

    function runInterval() {
        timeout = setTimeout(runInterval, time);
        method.call();
    }

    timeout = setTimeout(runInterval, time);

    return {
        cancel: function cancel() {
            clearTimeout(timeout);
        }
    };
}

/*  Safe Interval
    -------------

    Run timeouts at 100ms intervals so we can account for busy browsers
*/

function safeTimeout(method, time) {

    var interval = safeInterval(function () {
        time -= 100;
        if (time <= 0) {
            interval.cancel();
            method();
        }
    }, 100);
}

function each(item, callback) {

    if (!item) {
        return;
    }

    if (item instanceof Array) {
        var len = item.length;
        for (var i = 0; i < len; i++) {
            callback(item[i], i);
        }
    } else if ((typeof item === 'undefined' ? 'undefined' : _typeof(item)) === 'object') {
        var keys = Object.keys(item);
        var _len = keys.length;
        for (var _i = 0; _i < _len; _i++) {
            var key = keys[_i];
            callback(item[key], key);
        }
    }
}

function replaceObject(obj, callback) {
    var parentKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';


    var newobj = obj instanceof Array ? [] : {};

    each(obj, function (item, key) {

        var fullKey = parentKey ? parentKey + '.' + key : key;

        var result = callback(item, key, fullKey);

        if (result !== undefined) {
            newobj[key] = result;
        } else if ((typeof item === 'undefined' ? 'undefined' : _typeof(item)) === 'object' && item !== null) {
            newobj[key] = replaceObject(item, callback, fullKey);
        } else {
            newobj[key] = item;
        }
    });

    // $FlowFixMe
    return newobj;
}

function copyProp(source, target, name, def) {
    if (source.hasOwnProperty(name)) {
        var descriptor = Object.getOwnPropertyDescriptor(source, name);
        Object.defineProperty(target, name, descriptor);
    } else {
        target[name] = def;
    }
}

function dotify(obj) {
    var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var newobj = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    prefix = prefix ? prefix + '.' : prefix;
    for (var key in obj) {
        if (obj[key] === undefined || obj[key] === null || typeof obj[key] === 'function') {
            continue;
        } else if (obj[key] && Array.isArray(obj[key]) && obj[key].length && obj[key].every(function (val) {
            return (typeof val === 'undefined' ? 'undefined' : _typeof(val)) !== 'object';
        })) {
            newobj['' + prefix + key] = obj[key].join(',');
        } else if (obj[key] && _typeof(obj[key]) === 'object') {
            newobj = dotify(obj[key], '' + prefix + key, newobj);
        } else {
            newobj['' + prefix + key] = obj[key].toString();
        }
    }
    return newobj;
}

var objectIDs = new __WEBPACK_IMPORTED_MODULE_0_cross_domain_safe_weakmap_src__["a" /* WeakMap */]();

function getObjectID(obj) {

    if (obj === null || obj === undefined || (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) !== 'object' && typeof obj !== 'function') {
        throw new Error('Invalid object');
    }

    var uid = objectIDs.get(obj);

    if (!uid) {
        uid = (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) + ':' + uniqueID();
        objectIDs.set(obj, uid);
    }

    return uid;
}

function regex(pattern, string) {
    var start = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;


    if (typeof pattern === 'string') {
        pattern = new RegExp(pattern);
    }

    var result = string.slice(start).match(pattern);

    if (!result) {
        return;
    }

    // $FlowFixMe
    var index = result.index;
    var match = result[0];

    return {
        text: match,
        groups: result.slice(1),
        start: start + index,
        end: start + index + match.length,
        length: match.length,

        replace: function replace(text) {

            if (!match) {
                return '';
            }

            return '' + match.slice(0, start + index) + text + match.slice(index + match.length);
        }
    };
}

function regexAll(pattern, string) {

    var matches = [];
    var start = 0;

    while (true) {
        var match = regex(pattern, string, start);

        if (!match) {
            break;
        }

        matches.push(match);
        start = match.end;
    }

    return matches;
}

function count(str, substr) {

    var startIndex = 0;
    var itemCount = 0;

    while (true) {
        var index = str.indexOf(substr, startIndex);

        if (index === -1) {
            break;
        }

        startIndex = index;
        itemCount += 1;
    }

    return itemCount;
}

function stringify(item) {
    if (typeof item === 'string') {
        return item;
    }

    if (item && typeof item.toString === 'function') {
        return item.toString();
    }

    return Object.prototype.toString.call(item);
}

function stringifyError(err) {
    if (err) {
        // $FlowFixMe
        var stack = err.stack,
            message = err.message;


        if (typeof stack === 'string') {
            return stack;
        }

        if (typeof message === 'string') {
            return message;
        }
    }

    return stringify(err);
}

function eventEmitter() {

    var triggered = {};
    var handlers = {};

    return {
        on: function on(eventName, handler) {

            var handlerList = handlers[eventName] = handlers[eventName] || [];

            handlerList.push(handler);

            var cancelled = false;

            return {
                cancel: function cancel() {
                    if (!cancelled) {
                        cancelled = true;
                        handlerList.splice(handlerList.indexOf(handler), 1);
                    }
                }
            };
        },
        once: function once(eventName, handler) {

            var listener = this.on(eventName, function () {
                listener.cancel();
                handler();
            });

            return listener;
        },
        trigger: function trigger(eventName) {

            var handlerList = handlers[eventName];

            if (handlerList) {
                for (var _iterator = handlerList, _isArray = Array.isArray(_iterator), _i2 = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
                    var _ref;

                    if (_isArray) {
                        if (_i2 >= _iterator.length) break;
                        _ref = _iterator[_i2++];
                    } else {
                        _i2 = _iterator.next();
                        if (_i2.done) break;
                        _ref = _i2.value;
                    }

                    var _handler = _ref;

                    _handler();
                }
            }
        },
        triggerOnce: function triggerOnce(eventName) {

            if (triggered[eventName]) {
                return;
            }

            triggered[eventName] = true;
            this.trigger(eventName);
        }
    };
}

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interface__ = __webpack_require__(32);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__interface__["config"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__interface__["error"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__interface__["flush"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__interface__["info"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__interface__["logLevels"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_0__interface__["warn"]; });



/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__interface__);

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ChildComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_cross_domain_utils_src__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_post_robot_src__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__base__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__window__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__props__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__error__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__component__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__component_props__ = __webpack_require__(12);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

















/*  Child Component
    ---------------

    This is the portion of code which runs inside the frame or popup window containing the component's implementation.

    When the component author calls myComponent.attach(), it creates a new instance of ChildComponent, which is then
    responsible for managing the state and messaging back up to the parent, and providing props for the component to
    utilize.
*/

var ChildComponent = function (_BaseComponent) {
    _inherits(ChildComponent, _BaseComponent);

    function ChildComponent(component) {
        _classCallCheck(this, ChildComponent);

        var _this = _possibleConstructorReturn(this, _BaseComponent.call(this));

        _this.component = component;

        if (!_this.hasValidParentDomain()) {
            _this.error(new __WEBPACK_IMPORTED_MODULE_9__error__["c" /* RenderError */]('Can not be rendered by domain: ' + _this.getParentDomain()));
            return _possibleConstructorReturn(_this);
        }

        _this.sendLogsToOpener();

        _this.component.log('construct_child');

        // The child can specify some default props if none are passed from the parent. This often makes integrations
        // a little more seamless, as applicaiton code can call props.foo() without worrying about whether the parent
        // has provided them or not, and fall-back to some default behavior.

        _this.onPropHandlers = [];

        _this.setProps(_this.getInitialProps(), Object(__WEBPACK_IMPORTED_MODULE_5__window__["d" /* getParentDomain */])());

        // update logLevel with prop.logLevel to override defaultLogLevel configured when creating component

        if (_this.props.logLevel) {
            Object(__WEBPACK_IMPORTED_MODULE_6__lib__["Q" /* setLogLevel */])(_this.props.logLevel);
        }

        _this.component.log('init_child');

        _this.setWindows();

        _this.listenForResize();

        // Send an init message to our parent. This gives us an initial set of data to use that we can use to function.
        //
        // For example:
        //
        // - What context are we
        // - What props has the parent specified

        _this.onInit = _this.sendToParent(__WEBPACK_IMPORTED_MODULE_7__constants__["POST_MESSAGE"].INIT, {

            exports: _this.exports()

        }).then(function (_ref) {
            var origin = _ref.origin,
                data = _ref.data;


            _this.context = data.context;
            _this.setProps(data.props, origin);

            _this.watchForResize();

            return _this;
        })['catch'](function (err) {

            _this.error(err);
            throw err;
        });
        return _this;
    }

    ChildComponent.prototype.listenForResize = function listenForResize() {
        var _this2 = this;

        window.addEventListener('resize', function () {
            _this2.sendToParent(__WEBPACK_IMPORTED_MODULE_7__constants__["POST_MESSAGE"].ONRESIZE, {}, { fireAndForget: true });
        });
    };

    ChildComponent.prototype.hasValidParentDomain = function hasValidParentDomain() {
        return Object(__WEBPACK_IMPORTED_MODULE_1_cross_domain_utils_src__["v" /* matchDomain */])(this.component.allowedParentDomains, this.getParentDomain());
    };

    ChildComponent.prototype.init = function init() {
        return this.onInit;
    };

    ChildComponent.prototype.getParentDomain = function getParentDomain() {
        return Object(__WEBPACK_IMPORTED_MODULE_5__window__["d" /* getParentDomain */])();
    };

    ChildComponent.prototype.onProps = function onProps(handler) {
        this.onPropHandlers.push(handler);
    };

    ChildComponent.prototype.getParentComponentWindow = function getParentComponentWindow() {
        return Object(__WEBPACK_IMPORTED_MODULE_5__window__["c" /* getParentComponentWindow */])();
    };

    ChildComponent.prototype.getParentRenderWindow = function getParentRenderWindow() {
        return Object(__WEBPACK_IMPORTED_MODULE_5__window__["e" /* getParentRenderWindow */])();
    };

    ChildComponent.prototype.getInitialProps = function getInitialProps() {
        var _this3 = this;

        var componentMeta = Object(__WEBPACK_IMPORTED_MODULE_5__window__["b" /* getComponentMeta */])();

        var props = componentMeta.props;

        if (props.type === __WEBPACK_IMPORTED_MODULE_7__constants__["INITIAL_PROPS"].RAW) {
            props = props.value;
        } else if (props.type === __WEBPACK_IMPORTED_MODULE_7__constants__["INITIAL_PROPS"].UID) {

            var parentComponentWindow = Object(__WEBPACK_IMPORTED_MODULE_5__window__["c" /* getParentComponentWindow */])();

            if (!Object(__WEBPACK_IMPORTED_MODULE_1_cross_domain_utils_src__["p" /* isSameDomain */])(parentComponentWindow)) {

                if (window.location.protocol === 'file:') {
                    throw new Error('Can not get props from file:// domain');
                }

                throw new Error('Parent component window is on a different domain - expected ' + Object(__WEBPACK_IMPORTED_MODULE_1_cross_domain_utils_src__["f" /* getDomain */])() + ' - can not retrieve props');
            }

            var global = Object(__WEBPACK_IMPORTED_MODULE_6__lib__["z" /* globalFor */])(parentComponentWindow);

            if (!global) {
                throw new Error('Can not find global for parent component - can not retrieve props');
            }

            props = global.props[componentMeta.uid];
        } else {
            throw new Error('Unrecognized props type: ' + props.type);
        }

        if (!props) {
            throw new Error('Initial props not found');
        }

        return Object(__WEBPACK_IMPORTED_MODULE_6__lib__["k" /* deserializeFunctions */])(props, function (_ref2) {
            var fullKey = _ref2.fullKey,
                self = _ref2.self,
                args = _ref2.args;

            return _this3.onInit.then(function () {
                var func = Object(__WEBPACK_IMPORTED_MODULE_6__lib__["v" /* get */])(_this3.props, fullKey);

                if (typeof func !== 'function') {
                    throw new Error('Expected ' + (typeof func === 'undefined' ? 'undefined' : _typeof(func)) + ' to be function');
                }

                return func.apply(self, args);
            });
        });
    };

    ChildComponent.prototype.setProps = function setProps(props, origin) {
        var required = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

        // $FlowFixMe
        this.props = this.props || {};
        var normalizedProps = Object(__WEBPACK_IMPORTED_MODULE_8__props__["a" /* normalizeChildProps */])(this.component, props, origin, required);
        Object(__WEBPACK_IMPORTED_MODULE_6__lib__["t" /* extend */])(this.props, normalizedProps);
        window.xprops = this.props;
        for (var _iterator = this.onPropHandlers, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
            var _ref3;

            if (_isArray) {
                if (_i >= _iterator.length) break;
                _ref3 = _iterator[_i++];
            } else {
                _i = _iterator.next();
                if (_i.done) break;
                _ref3 = _i.value;
            }

            var handler = _ref3;

            handler.call(this, this.props);
        }
    };

    /*  Send to Parent
        --------------
         Send a post message to our parent window.
    */

    ChildComponent.prototype.sendToParent = function sendToParent(name) {
        var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

        var parentWindow = Object(__WEBPACK_IMPORTED_MODULE_5__window__["c" /* getParentComponentWindow */])();

        if (!parentWindow) {
            throw new Error('Can not find parent component window to message');
        }

        this.component.log('send_to_parent_' + name);

        return Object(__WEBPACK_IMPORTED_MODULE_2_post_robot_src__["send"])(parentWindow, name, data, _extends({ domain: Object(__WEBPACK_IMPORTED_MODULE_5__window__["d" /* getParentDomain */])() }, options));
    };

    /*  Set Windows
        -----------
         Determine the parent window, and the parent component window. Note -- these may be different, if we were
        rendered using renderTo.
    */

    ChildComponent.prototype.setWindows = function setWindows() {

        // Ensure we do not try to .attach() multiple times for the same component on the same page

        if (window.__activeXComponent__) {
            throw this.component.createError('Can not attach multiple components to the same window');
        }

        window.__activeXComponent__ = this;

        // Get the direct parent window

        if (!Object(__WEBPACK_IMPORTED_MODULE_5__window__["c" /* getParentComponentWindow */])()) {
            throw this.component.createError('Can not find parent window');
        }

        var componentMeta = Object(__WEBPACK_IMPORTED_MODULE_5__window__["b" /* getComponentMeta */])();

        if (componentMeta.tag !== this.component.tag) {
            throw this.component.createError('Parent is ' + componentMeta.tag + ' - can not attach ' + this.component.tag);
        }

        // Note -- getting references to other windows is probably one of the hardest things to do. There's basically
        // only a few ways of doing it:
        //
        // - The window is a direct parent, in which case you can use window.parent or window.opener
        // - The window is an iframe owned by you or one of your parents, in which case you can use window.frames
        // - The window sent you a post-message, in which case you can use event.source
        //
        // If we didn't rely on winProps.parent here from the window name, we'd have to relay all of our messages through
        // our actual parent. Which is no fun at all, and pretty error prone even with the help of post-robot. So this
        // is the lesser of two evils until browsers give us something like getWindowByName(...)

        // If the parent window closes, we need to close ourselves. There's no point continuing to run our component
        // if there's no parent to message to.

        this.watchForClose();
    };

    ChildComponent.prototype.sendLogsToOpener = function sendLogsToOpener() {
        if (false) {
            try {
                var opener = getOpener(window);

                if (!opener || !window.console) {
                    return;
                }

                // $FlowFixMe

                var _loop = function _loop() {
                    if (_isArray2) {
                        if (_i2 >= _iterator2.length) return 'break';
                        _ref4 = _iterator2[_i2++];
                    } else {
                        _i2 = _iterator2.next();
                        if (_i2.done) return 'break';
                        _ref4 = _i2.value;
                    }

                    var frame = _ref4;


                    if (!isSameDomain(frame) || !frame.console || frame === window) {
                        return 'continue';
                    }

                    var _arr = ['log', 'debug', 'info', 'warn', 'error'];

                    var _loop3 = function _loop3() {
                        var level = _arr[_i3];
                        var original = window.console[level];

                        if (!original) {
                            return 'continue';
                        }

                        try {

                            window.console[level] = function () {

                                try {
                                    if (frame) {
                                        // $FlowFixMe
                                        return frame.console[level].apply(frame.console, arguments);
                                    }
                                } catch (err3) {
                                    // pass
                                }

                                return original.apply(this, arguments);
                            };
                        } catch (err2) {
                            // pass
                        }
                    };

                    for (var _i3 = 0; _i3 < _arr.length; _i3++) {
                        var _ret2 = _loop3();

                        if (_ret2 === 'continue') continue;
                    }

                    return {
                        v: void 0
                    };
                };

                _loop2: for (var _iterator2 = getAllFramesInWindow(opener), _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
                    var _ref4;

                    var _ret = _loop();

                    switch (_ret) {
                        case 'break':
                            break _loop2;

                        case 'continue':
                            continue;

                        default:
                            if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
                    }
                }
            } catch (err) {
                // pass
            }
        }
    };

    ChildComponent.prototype.watchForClose = function watchForClose() {
        var _this4 = this;

        window.addEventListener('unload', function () {
            return _this4.checkClose();
        });
    };

    ChildComponent.prototype.enableAutoResize = function enableAutoResize() {
        var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref5$width = _ref5.width,
            width = _ref5$width === undefined ? true : _ref5$width,
            _ref5$height = _ref5.height,
            height = _ref5$height === undefined ? true : _ref5$height;

        this.autoResize = { width: width, height: height };
        this.watchForResize();
    };

    ChildComponent.prototype.getAutoResize = function getAutoResize() {

        var width = false;
        var height = false;

        var autoResize = this.autoResize || this.component.autoResize;

        if ((typeof autoResize === 'undefined' ? 'undefined' : _typeof(autoResize)) === 'object') {
            width = Boolean(autoResize.width);
            height = Boolean(autoResize.height);
        } else if (autoResize) {
            width = true;
            height = true;
        }

        var element = void 0;

        if (autoResize.element) {
            element = Object(__WEBPACK_IMPORTED_MODULE_6__lib__["x" /* getElement */])(autoResize.element);
        } else if (window.navigator.userAgent.match(/MSIE (9|10)\./)) {
            element = document.body;
        } else {
            element = document.documentElement;
        }

        // $FlowFixMe
        return { width: width, height: height, element: element };
    };

    ChildComponent.prototype.watchForResize = function watchForResize() {
        var _this5 = this;

        var _getAutoResize = this.getAutoResize(),
            width = _getAutoResize.width,
            height = _getAutoResize.height,
            element = _getAutoResize.element;

        if (!width && !height) {
            return;
        }

        if (this.context === __WEBPACK_IMPORTED_MODULE_7__constants__["CONTEXT_TYPES"].POPUP) {
            return;
        }

        if (this.watchingForResize) {
            return;
        }

        this.watchingForResize = true;

        return __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](function () {

            return __WEBPACK_IMPORTED_MODULE_6__lib__["n" /* documentReady */];
        }).then(function () {

            // $FlowFixMe
            if (!Object(__WEBPACK_IMPORTED_MODULE_6__lib__["m" /* dimensionsMatchViewport */])(element, { width: width, height: height })) {
                // $FlowFixMe
                return _this5.resizeToElement(element, { width: width, height: height });
            }
        }).then(function () {

            return Object(__WEBPACK_IMPORTED_MODULE_6__lib__["h" /* cycle */])(function () {
                return Object(__WEBPACK_IMPORTED_MODULE_6__lib__["J" /* onDimensionsChange */])(element, { width: width, height: height }).then(function (dimensions) {
                    // $FlowFixMe
                    return _this5.resizeToElement(element, { width: width, height: height });
                });
            });
        });
    };

    ChildComponent.prototype.exports = function exports() {

        var self = this;

        return {
            updateProps: function updateProps(props) {
                var _this6 = this;

                return __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](function () {
                    return self.setProps(props, _this6.origin, false);
                });
            },
            close: function close() {
                return __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](function () {
                    return self.destroy();
                });
            }
        };
    };

    /*  Resize
        ------
         Resize the child window. Must be done on a user action like a click if we're in a popup
    */

    ChildComponent.prototype.resize = function resize(width, height) {
        var _this7 = this;

        return __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__["a" /* ZalgoPromise */].resolve().then(function () {

            _this7.component.log('resize', { width: Object(__WEBPACK_IMPORTED_MODULE_6__lib__["U" /* stringify */])(width), height: Object(__WEBPACK_IMPORTED_MODULE_6__lib__["U" /* stringify */])(height) });

            if (_this7.context === __WEBPACK_IMPORTED_MODULE_7__constants__["CONTEXT_TYPES"].POPUP) {
                return;
            }

            return _this7.sendToParent(__WEBPACK_IMPORTED_MODULE_7__constants__["POST_MESSAGE"].RESIZE, { width: width, height: height }).then(__WEBPACK_IMPORTED_MODULE_6__lib__["I" /* noop */]);
        });
    };

    ChildComponent.prototype.resizeToElement = function resizeToElement(el, _ref6) {
        var _this8 = this;

        var width = _ref6.width,
            height = _ref6.height;


        var history = [];

        var resize = function resize() {
            return __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](function () {

                // $FlowFixMe
                var tracker = Object(__WEBPACK_IMPORTED_MODULE_6__lib__["X" /* trackDimensions */])(el, { width: width, height: height });

                var _tracker$check = tracker.check(),
                    dimensions = _tracker$check.dimensions;

                for (var _iterator3 = history, _isArray3 = Array.isArray(_iterator3), _i4 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
                    var _ref7;

                    if (_isArray3) {
                        if (_i4 >= _iterator3.length) break;
                        _ref7 = _iterator3[_i4++];
                    } else {
                        _i4 = _iterator3.next();
                        if (_i4.done) break;
                        _ref7 = _i4.value;
                    }

                    var size = _ref7;


                    var widthMatch = !width || size.width === dimensions.width;
                    var heightMatch = !height || size.height === dimensions.height;

                    if (widthMatch && heightMatch) {
                        return;
                    }
                }

                history.push({ width: dimensions.width, height: dimensions.height });

                return _this8.resize(width ? dimensions.width : null, height ? dimensions.height : null).then(function () {

                    if (tracker.check().changed) {
                        return resize();
                    }
                });
            });
        };

        return resize();
    };

    /*  Hide
        ----
         Hide the window and any parent template
    */

    ChildComponent.prototype.hide = function hide() {
        return this.sendToParent(__WEBPACK_IMPORTED_MODULE_7__constants__["POST_MESSAGE"].HIDE).then(__WEBPACK_IMPORTED_MODULE_6__lib__["I" /* noop */]);
    };

    ChildComponent.prototype.show = function show() {
        return this.sendToParent(__WEBPACK_IMPORTED_MODULE_7__constants__["POST_MESSAGE"].SHOW).then(__WEBPACK_IMPORTED_MODULE_6__lib__["I" /* noop */]);
    };

    ChildComponent.prototype.userClose = function userClose() {
        return this.close(__WEBPACK_IMPORTED_MODULE_7__constants__["CLOSE_REASONS"].USER_CLOSED);
    };

    /*  Close
        -----
         Close the child window
    */

    ChildComponent.prototype.close = function close() {
        var reason = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_7__constants__["CLOSE_REASONS"].CHILD_CALL;


        this.component.log('close_child');

        // Ask our parent window to close us

        this.sendToParent(__WEBPACK_IMPORTED_MODULE_7__constants__["POST_MESSAGE"].CLOSE, { reason: reason });
    };

    ChildComponent.prototype.checkClose = function checkClose() {
        this.sendToParent(__WEBPACK_IMPORTED_MODULE_7__constants__["POST_MESSAGE"].CHECK_CLOSE, {}, { fireAndForget: true });
    };

    ChildComponent.prototype.destroy = function destroy() {
        __WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__["c" /* flush */]().then(function () {
            window.close();
        });
    };

    /*  Focus
        -----
         Focus the child window. Must be done on a user action like a click
    */

    ChildComponent.prototype.focus = function focus() {
        this.component.log('focus');

        window.focus();
    };

    /*  Error
        -----
         Send an error back to the parent
    */

    ChildComponent.prototype.error = function error(err) {

        var stringifiedError = Object(__WEBPACK_IMPORTED_MODULE_6__lib__["V" /* stringifyError */])(err);

        this.component.logError('error', { error: stringifiedError });

        return this.sendToParent(__WEBPACK_IMPORTED_MODULE_7__constants__["POST_MESSAGE"].ERROR, {
            error: stringifiedError
        }).then(__WEBPACK_IMPORTED_MODULE_6__lib__["I" /* noop */]);
    };

    return ChildComponent;
}(__WEBPACK_IMPORTED_MODULE_4__base__["a" /* BaseComponent */]);

if (false) {

    if (isXComponentWindow() && window.console) {
        (function () {
            var logLevels = $logger.logLevels;

            var _loop4 = function _loop4() {
                if (_isArray4) {
                    if (_i5 >= _iterator4.length) return 'break';
                    _ref8 = _iterator4[_i5++];
                } else {
                    _i5 = _iterator4.next();
                    if (_i5.done) return 'break';
                    _ref8 = _i5.value;
                }

                var level = _ref8;


                try {

                    var _original = window.console[level];

                    if (!_original || !_original.apply) {
                        return 'continue';
                    }

                    window.console[level] = function () {
                        try {
                            var logLevel = window.LOG_LEVEL;

                            if (!logLevel || logLevels.indexOf(logLevel) === -1) {
                                return _original.apply(this, arguments);
                            }

                            if (logLevels.indexOf(level) > logLevels.indexOf(logLevel)) {
                                return;
                            }

                            return _original.apply(this, arguments);
                        } catch (err2) {
                            // pass
                        }
                    };

                    if (level === 'info') {
                        window.console.log = window.console[level];
                    }
                } catch (err) {
                    // pass
                }
            };

            _loop5: for (var _iterator4 = logLevels, _isArray4 = Array.isArray(_iterator4), _i5 = 0, _iterator4 = _isArray4 ? _iterator4 : _iterator4[Symbol.iterator]();;) {
                var _ref8;

                var _ret4 = _loop4();

                switch (_ret4) {
                    case 'break':
                        break _loop5;

                    case 'continue':
                        continue;}
            }
        })();
    }
}

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["create"] = create;
/* harmony export (immutable) */ __webpack_exports__["getByTag"] = getByTag;
/* harmony export (immutable) */ __webpack_exports__["destroyAll"] = destroyAll;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "postRobot", function() { return postRobot; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CONSTANTS", function() { return CONSTANTS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__component__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__component_parent__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib__ = __webpack_require__(3);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getCurrentScriptDir", function() { return __WEBPACK_IMPORTED_MODULE_3__lib__["w"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_post_robot_src__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__error__ = __webpack_require__(13);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "PopupOpenError", function() { return __WEBPACK_IMPORTED_MODULE_5__error__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "IntegrationError", function() { return __WEBPACK_IMPORTED_MODULE_5__error__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "RenderError", function() { return __WEBPACK_IMPORTED_MODULE_5__error__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(5);





function create(options) {
    return new __WEBPACK_IMPORTED_MODULE_1__component__["a" /* Component */](options);
}

function getByTag(tag) {
    return __WEBPACK_IMPORTED_MODULE_1__component__["a" /* Component */].getByTag(tag);
}



function destroyAll() {
    return __WEBPACK_IMPORTED_MODULE_2__component_parent__["a" /* ParentComponent */].destroyAll();
}


var postRobot = __WEBPACK_IMPORTED_MODULE_4_post_robot_src__;





var CONSTANTS = __WEBPACK_IMPORTED_MODULE_6__constants__;

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__weakmap__ = __webpack_require__(41);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "WeakMap", function() { return __WEBPACK_IMPORTED_MODULE_0__weakmap__["a"]; });


/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CONSTANTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return POST_MESSAGE_NAMES_LIST; });
var CONSTANTS = {

    POST_MESSAGE_TYPE: {
        REQUEST: 'postrobot_message_request',
        RESPONSE: 'postrobot_message_response',
        ACK: 'postrobot_message_ack'
    },

    POST_MESSAGE_ACK: {
        SUCCESS: 'success',
        ERROR: 'error'
    },

    POST_MESSAGE_NAMES: {
        METHOD: 'postrobot_method',
        READY: 'postrobot_ready',
        OPEN_TUNNEL: 'postrobot_open_tunnel'
    },

    WINDOW_TYPES: {
        FULLPAGE: 'fullpage',
        POPUP: 'popup',
        IFRAME: 'iframe'
    },

    WINDOW_PROPS: {
        POSTROBOT: '__postRobot__'
    },

    SERIALIZATION_TYPES: {
        METHOD: 'postrobot_method',
        ERROR: 'postrobot_error',
        PROMISE: 'postrobot_promise',
        ZALGO_PROMISE: 'postrobot_zalgo_promise',
        REGEX: 'regex'
    },

    SEND_STRATEGIES: {
        POST_MESSAGE: 'postrobot_post_message',
        BRIDGE: 'postrobot_bridge',
        GLOBAL: 'postrobot_global'
    },

    MOCK_PROTOCOL: 'mock:',
    FILE_PROTOCOL: 'file:',

    BRIDGE_NAME_PREFIX: '__postrobot_bridge__',
    POSTROBOT_PROXY: '__postrobot_proxy__',

    WILDCARD: '*'
};

var POST_MESSAGE_NAMES_LIST = Object.keys(CONSTANTS.POST_MESSAGE_NAMES).map(function (key) {
    return CONSTANTS.POST_MESSAGE_NAMES[key];
});

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = sendMessage;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_cross_domain_utils_src__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__conf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__strategies__ = __webpack_require__(50);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };









function buildMessage(win, message) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};


    var id = Object(__WEBPACK_IMPORTED_MODULE_3__lib__["p" /* uniqueID */])();
    var type = Object(__WEBPACK_IMPORTED_MODULE_3__lib__["c" /* getWindowType */])();
    var sourceDomain = Object(__WEBPACK_IMPORTED_MODULE_0_cross_domain_utils_src__["f" /* getDomain */])(window);

    return _extends({}, message, options, {
        sourceDomain: sourceDomain,
        id: message.id || id,
        windowType: type
    });
}

function sendMessage(win, message, domain) {
    return __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](function () {
        var _jsonStringify;

        message = buildMessage(win, message, {
            data: Object(__WEBPACK_IMPORTED_MODULE_3__lib__["n" /* serializeMethods */])(win, domain, message.data),
            domain: domain
        });

        var level = void 0;

        if (__WEBPACK_IMPORTED_MODULE_2__conf__["c" /* POST_MESSAGE_NAMES_LIST */].indexOf(message.name) !== -1 || message.type === __WEBPACK_IMPORTED_MODULE_2__conf__["b" /* CONSTANTS */].POST_MESSAGE_TYPE.ACK) {
            level = 'debug';
        } else if (message.ack === 'error') {
            level = 'error';
        } else {
            level = 'info';
        }

        __WEBPACK_IMPORTED_MODULE_3__lib__["i" /* log */].logLevel(level, ['\n\n\t', '#send', message.type.replace(/^postrobot_message_/, ''), '::', message.name, '::', domain || __WEBPACK_IMPORTED_MODULE_2__conf__["b" /* CONSTANTS */].WILDCARD, '\n\n', message]);

        if (win === window) {
            throw new Error('Attemping to send message to self');
        }

        if (Object(__WEBPACK_IMPORTED_MODULE_0_cross_domain_utils_src__["t" /* isWindowClosed */])(win)) {
            throw new Error('Window is closed');
        }

        __WEBPACK_IMPORTED_MODULE_3__lib__["i" /* log */].debug('Running send message strategies', message);

        var messages = [];

        var serializedMessage = Object(__WEBPACK_IMPORTED_MODULE_3__lib__["g" /* jsonStringify */])((_jsonStringify = {}, _jsonStringify[__WEBPACK_IMPORTED_MODULE_2__conf__["b" /* CONSTANTS */].WINDOW_PROPS.POSTROBOT] = message, _jsonStringify), null, 2);

        return __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__["a" /* ZalgoPromise */].map(Object.keys(__WEBPACK_IMPORTED_MODULE_4__strategies__["a" /* SEND_MESSAGE_STRATEGIES */]), function (strategyName) {

            return __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](function () {

                if (!__WEBPACK_IMPORTED_MODULE_2__conf__["a" /* CONFIG */].ALLOWED_POST_MESSAGE_METHODS[strategyName]) {
                    throw new Error('Strategy disallowed: ' + strategyName);
                }

                return __WEBPACK_IMPORTED_MODULE_4__strategies__["a" /* SEND_MESSAGE_STRATEGIES */][strategyName](win, serializedMessage, domain);
            }).then(function () {
                messages.push(strategyName + ': success');
                return true;
            }, function (err) {
                messages.push(strategyName + ': ' + Object(__WEBPACK_IMPORTED_MODULE_3__lib__["o" /* stringifyError */])(err) + '\n');
                return false;
            });
        }).then(function (results) {

            var success = results.some(Boolean);
            var status = message.type + ' ' + message.name + ' ' + (success ? 'success' : 'error') + ':\n  - ' + messages.join('\n  - ') + '\n';

            __WEBPACK_IMPORTED_MODULE_3__lib__["i" /* log */].debug(status);

            if (!success) {
                throw new Error(status);
            }
        });
    });
}

/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export resetListeners */
/* harmony export (immutable) */ __webpack_exports__["b"] = addResponseListener;
/* harmony export (immutable) */ __webpack_exports__["e"] = getResponseListener;
/* harmony export (immutable) */ __webpack_exports__["c"] = deleteResponseListener;
/* harmony export (immutable) */ __webpack_exports__["g"] = markResponseListenerErrored;
/* harmony export (immutable) */ __webpack_exports__["f"] = isResponseListenerErrored;
/* harmony export (immutable) */ __webpack_exports__["d"] = getRequestListener;
/* harmony export (immutable) */ __webpack_exports__["a"] = addRequestListener;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_cross_domain_safe_weakmap_src__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__conf__ = __webpack_require__(4);








function resetListeners() {
    __WEBPACK_IMPORTED_MODULE_3__global__["a" /* global */].responseListeners = {};
    __WEBPACK_IMPORTED_MODULE_3__global__["a" /* global */].requestListeners = {};
}

__WEBPACK_IMPORTED_MODULE_3__global__["a" /* global */].responseListeners = __WEBPACK_IMPORTED_MODULE_3__global__["a" /* global */].responseListeners || {};
__WEBPACK_IMPORTED_MODULE_3__global__["a" /* global */].requestListeners = __WEBPACK_IMPORTED_MODULE_3__global__["a" /* global */].requestListeners || {};
__WEBPACK_IMPORTED_MODULE_3__global__["a" /* global */].WINDOW_WILDCARD = __WEBPACK_IMPORTED_MODULE_3__global__["a" /* global */].WINDOW_WILDCARD || new function WindowWildcard() {/* pass */}();

__WEBPACK_IMPORTED_MODULE_3__global__["a" /* global */].erroredResponseListeners = __WEBPACK_IMPORTED_MODULE_3__global__["a" /* global */].erroredResponseListeners || {};

var __DOMAIN_REGEX__ = '__domain_regex__';

function addResponseListener(hash, listener) {
    __WEBPACK_IMPORTED_MODULE_3__global__["a" /* global */].responseListeners[hash] = listener;
}

function getResponseListener(hash) {
    return __WEBPACK_IMPORTED_MODULE_3__global__["a" /* global */].responseListeners[hash];
}

function deleteResponseListener(hash) {
    delete __WEBPACK_IMPORTED_MODULE_3__global__["a" /* global */].responseListeners[hash];
}

function markResponseListenerErrored(hash) {
    __WEBPACK_IMPORTED_MODULE_3__global__["a" /* global */].erroredResponseListeners[hash] = true;
}

function isResponseListenerErrored(hash) {
    return Boolean(__WEBPACK_IMPORTED_MODULE_3__global__["a" /* global */].erroredResponseListeners[hash]);
}

function getRequestListener(_ref) {
    var name = _ref.name,
        win = _ref.win,
        domain = _ref.domain;


    if (win === __WEBPACK_IMPORTED_MODULE_5__conf__["b" /* CONSTANTS */].WILDCARD) {
        win = null;
    }

    if (domain === __WEBPACK_IMPORTED_MODULE_5__conf__["b" /* CONSTANTS */].WILDCARD) {
        domain = null;
    }

    if (!name) {
        throw new Error('Name required to get request listener');
    }

    var nameListeners = __WEBPACK_IMPORTED_MODULE_3__global__["a" /* global */].requestListeners[name];

    if (!nameListeners) {
        return;
    }

    var _arr = [win, __WEBPACK_IMPORTED_MODULE_3__global__["a" /* global */].WINDOW_WILDCARD];
    for (var _i = 0; _i < _arr.length; _i++) {
        var winQualifier = _arr[_i];

        var winListeners = winQualifier && nameListeners.get(winQualifier);

        if (!winListeners) {
            continue;
        }

        if (domain && typeof domain === 'string') {
            if (winListeners[domain]) {
                return winListeners[domain];
            }

            if (winListeners[__DOMAIN_REGEX__]) {
                for (var _iterator = winListeners[__DOMAIN_REGEX__], _isArray = Array.isArray(_iterator), _i2 = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
                    var _ref3;

                    if (_isArray) {
                        if (_i2 >= _iterator.length) break;
                        _ref3 = _iterator[_i2++];
                    } else {
                        _i2 = _iterator.next();
                        if (_i2.done) break;
                        _ref3 = _i2.value;
                    }

                    var _ref4 = _ref3;
                    var regex = _ref4.regex,
                        listener = _ref4.listener;

                    if (Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__["v" /* matchDomain */])(regex, domain)) {
                        return listener;
                    }
                }
            }
        }

        if (winListeners[__WEBPACK_IMPORTED_MODULE_5__conf__["b" /* CONSTANTS */].WILDCARD]) {
            return winListeners[__WEBPACK_IMPORTED_MODULE_5__conf__["b" /* CONSTANTS */].WILDCARD];
        }
    }
}

function addRequestListener(_ref5, listener) {
    var name = _ref5.name,
        win = _ref5.win,
        domain = _ref5.domain;


    if (!name || typeof name !== 'string') {
        throw new Error('Name required to add request listener');
    }

    if (Array.isArray(win)) {
        var listenersCollection = [];

        for (var _iterator2 = win, _isArray2 = Array.isArray(_iterator2), _i3 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
            var _ref6;

            if (_isArray2) {
                if (_i3 >= _iterator2.length) break;
                _ref6 = _iterator2[_i3++];
            } else {
                _i3 = _iterator2.next();
                if (_i3.done) break;
                _ref6 = _i3.value;
            }

            var item = _ref6;

            listenersCollection.push(addRequestListener({ name: name, domain: domain, win: item }, listener));
        }

        return {
            cancel: function cancel() {
                for (var _iterator3 = listenersCollection, _isArray3 = Array.isArray(_iterator3), _i4 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
                    var _ref7;

                    if (_isArray3) {
                        if (_i4 >= _iterator3.length) break;
                        _ref7 = _iterator3[_i4++];
                    } else {
                        _i4 = _iterator3.next();
                        if (_i4.done) break;
                        _ref7 = _i4.value;
                    }

                    var cancelListener = _ref7;

                    cancelListener.cancel();
                }
            }
        };
    }

    if (Array.isArray(domain)) {
        var _listenersCollection = [];

        for (var _iterator4 = domain, _isArray4 = Array.isArray(_iterator4), _i5 = 0, _iterator4 = _isArray4 ? _iterator4 : _iterator4[Symbol.iterator]();;) {
            var _ref8;

            if (_isArray4) {
                if (_i5 >= _iterator4.length) break;
                _ref8 = _iterator4[_i5++];
            } else {
                _i5 = _iterator4.next();
                if (_i5.done) break;
                _ref8 = _i5.value;
            }

            var _item = _ref8;

            _listenersCollection.push(addRequestListener({ name: name, win: win, domain: _item }, listener));
        }

        return {
            cancel: function cancel() {
                for (var _iterator5 = _listenersCollection, _isArray5 = Array.isArray(_iterator5), _i6 = 0, _iterator5 = _isArray5 ? _iterator5 : _iterator5[Symbol.iterator]();;) {
                    var _ref9;

                    if (_isArray5) {
                        if (_i6 >= _iterator5.length) break;
                        _ref9 = _iterator5[_i6++];
                    } else {
                        _i6 = _iterator5.next();
                        if (_i6.done) break;
                        _ref9 = _i6.value;
                    }

                    var cancelListener = _ref9;

                    cancelListener.cancel();
                }
            }
        };
    }

    var existingListener = getRequestListener({ name: name, win: win, domain: domain });

    if (!win || win === __WEBPACK_IMPORTED_MODULE_5__conf__["b" /* CONSTANTS */].WILDCARD) {
        win = __WEBPACK_IMPORTED_MODULE_3__global__["a" /* global */].WINDOW_WILDCARD;
    }

    domain = domain || __WEBPACK_IMPORTED_MODULE_5__conf__["b" /* CONSTANTS */].WILDCARD;

    if (existingListener) {
        if (win && domain) {
            throw new Error('Request listener already exists for ' + name + ' on domain ' + domain.toString() + ' for specified window');
        } else if (win) {
            throw new Error('Request listener already exists for ' + name + ' for specified window');
        } else if (domain) {
            throw new Error('Request listener already exists for ' + name + ' on domain ' + domain.toString());
        } else {
            throw new Error('Request listener already exists for ' + name);
        }
    }

    var requestListeners = __WEBPACK_IMPORTED_MODULE_3__global__["a" /* global */].requestListeners;

    var nameListeners = requestListeners[name];

    if (!nameListeners) {
        nameListeners = new __WEBPACK_IMPORTED_MODULE_1_cross_domain_safe_weakmap_src__["a" /* WeakMap */]();
        requestListeners[name] = nameListeners;
    }

    var winListeners = nameListeners.get(win);

    if (!winListeners) {
        winListeners = {};
        nameListeners.set(win, winListeners);
    }

    var strDomain = domain.toString();

    var regexListeners = winListeners[__DOMAIN_REGEX__];
    var regexListener = void 0;

    if (Object(__WEBPACK_IMPORTED_MODULE_4__lib__["e" /* isRegex */])(domain)) {

        if (!regexListeners) {
            regexListeners = [];
            winListeners[__DOMAIN_REGEX__] = regexListeners;
        }

        regexListener = { regex: domain, listener: listener };

        regexListeners.push(regexListener);
    } else {
        winListeners[strDomain] = listener;
    }

    return {
        cancel: function cancel() {
            if (!winListeners) {
                return;
            }

            delete winListeners[strDomain];

            if (win && Object.keys(winListeners).length === 0) {
                nameListeners['delete'](win);
            }

            if (regexListener) {
                regexListeners.splice(regexListeners.indexOf(regexListener, 1));
            }
        }
    };
}

/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = noop;
/* harmony export (immutable) */ __webpack_exports__["e"] = once;
/* harmony export (immutable) */ __webpack_exports__["c"] = memoize;
/* harmony export (immutable) */ __webpack_exports__["a"] = debounce;
/* harmony export (immutable) */ __webpack_exports__["f"] = serializeFunctions;
/* harmony export (immutable) */ __webpack_exports__["b"] = deserializeFunctions;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(23);


/*  Noop
    ----

    Do nothing, zilch, nada, zip
*/

function noop() {}
// pass


/*  Once
    ----

    Create a wrapper function which only allows the inner function to run once, otherwise is a noop
*/

function once(method) {

    var called = false;
    var result = void 0;

    return function () {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        if (called) {
            return result;
        }

        called = true;
        result = method.apply(this, arguments);
        return result;
    };
}

/*  Memoize
    -------

    Create a wrapper function which caches the result of the first call, then for subsequent calls returns the cached value
*/

function memoize(method) {

    var results = {};

    return function () {
        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
        }

        var cacheKey = void 0;

        try {
            cacheKey = JSON.stringify(Array.prototype.slice.call(arguments), function (key, val) {

                if (typeof val === 'function') {
                    return 'xcomponent:memoize[' + Object(__WEBPACK_IMPORTED_MODULE_0__util__["h" /* getObjectID */])(val) + ']';
                }

                return val;
            });
        } catch (err) {
            throw new Error('Arguments not serializable -- can not be used to memoize');
        }

        if (!results.hasOwnProperty(cacheKey)) {
            results[cacheKey] = method.apply(this, arguments);
        }

        return results[cacheKey];
    };
}

function debounce(method) {
    var time = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;


    var timeout = void 0;

    return function () {
        var _this = this,
            _arguments = arguments;

        clearTimeout(timeout);

        timeout = setTimeout(function () {
            return method.apply(_this, _arguments);
        }, time);
    };
}

function serializeFunctions(obj) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__util__["i" /* replaceObject */])(obj, function (value, key, fullKey) {
        if (value instanceof Function) {
            return {
                __type__: '__function__'
            };
        }
    });
}

function deserializeFunctions(obj, handler) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__util__["i" /* replaceObject */])(obj, function (value, key, fullKey) {
        if (value && value.__type__ === '__function__') {
            return function () {
                return handler({ key: key, fullKey: fullKey, self: this, args: arguments });
            };
        }
    });
}

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__logger__ = __webpack_require__(18);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "track", function() { return __WEBPACK_IMPORTED_MODULE_0__logger__["l"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "buffer", function() { return __WEBPACK_IMPORTED_MODULE_0__logger__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "tracking", function() { return __WEBPACK_IMPORTED_MODULE_0__logger__["m"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getTransport", function() { return __WEBPACK_IMPORTED_MODULE_0__logger__["e"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "setTransport", function() { return __WEBPACK_IMPORTED_MODULE_0__logger__["k"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "print", function() { return __WEBPACK_IMPORTED_MODULE_0__logger__["j"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "immediateFlush", function() { return __WEBPACK_IMPORTED_MODULE_0__logger__["f"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "flush", function() { return __WEBPACK_IMPORTED_MODULE_0__logger__["d"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "log", function() { return __WEBPACK_IMPORTED_MODULE_0__logger__["h"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "prefix", function() { return __WEBPACK_IMPORTED_MODULE_0__logger__["i"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "debug", function() { return __WEBPACK_IMPORTED_MODULE_0__logger__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "info", function() { return __WEBPACK_IMPORTED_MODULE_0__logger__["g"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "warn", function() { return __WEBPACK_IMPORTED_MODULE_0__logger__["n"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "error", function() { return __WEBPACK_IMPORTED_MODULE_0__logger__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__init__ = __webpack_require__(61);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "init", function() { return __WEBPACK_IMPORTED_MODULE_1__init__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__transitions__ = __webpack_require__(62);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "startTransition", function() { return __WEBPACK_IMPORTED_MODULE_2__transitions__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "endTransition", function() { return __WEBPACK_IMPORTED_MODULE_2__transitions__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "transition", function() { return __WEBPACK_IMPORTED_MODULE_2__transitions__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__builders__ = __webpack_require__(20);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "payloadBuilders", function() { return __WEBPACK_IMPORTED_MODULE_3__builders__["g"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "metaBuilders", function() { return __WEBPACK_IMPORTED_MODULE_3__builders__["f"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "trackingBuilders", function() { return __WEBPACK_IMPORTED_MODULE_3__builders__["h"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "headerBuilders", function() { return __WEBPACK_IMPORTED_MODULE_3__builders__["e"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "addPayloadBuilder", function() { return __WEBPACK_IMPORTED_MODULE_3__builders__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "addMetaBuilder", function() { return __WEBPACK_IMPORTED_MODULE_3__builders__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "addTrackingBuilder", function() { return __WEBPACK_IMPORTED_MODULE_3__builders__["d"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "addHeaderBuilder", function() { return __WEBPACK_IMPORTED_MODULE_3__builders__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__(14);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "config", function() { return __WEBPACK_IMPORTED_MODULE_4__config__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "logLevels", function() { return __WEBPACK_IMPORTED_MODULE_4__config__["b"]; });







/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = now;
/* harmony export (immutable) */ __webpack_exports__["d"] = reqStartElapsed;
/* unused harmony export clientTimer */
/* unused harmony export reqTimer */
/* harmony export (immutable) */ __webpack_exports__["a"] = initHeartBeat;
/* harmony export (immutable) */ __webpack_exports__["b"] = initPerformance;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__logger__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__builders__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util__ = __webpack_require__(19);






var enablePerformance = window && window.performance && performance.now && performance.timing && performance.timing.connectEnd && performance.timing.navigationStart && Math.abs(performance.now() - Date.now()) > 1000 && performance.now() - (performance.timing.connectEnd - performance.timing.navigationStart) > 0;

function now() {
    if (enablePerformance) {
        return performance.now();
    } else {
        return Date.now();
    }
}

function timer(startTime) {
    startTime = startTime !== undefined ? startTime : now();

    return {
        startTime: startTime,

        elapsed: function elapsed() {
            return parseInt(now() - startTime, 10);
        },
        reset: function reset() {
            startTime = now();
        }
    };
}

function reqStartElapsed() {
    if (enablePerformance) {
        var timing = window.performance.timing;
        return parseInt(timing.connectEnd - timing.navigationStart, 10);
    }
}

var clientTimer = timer();
var reqTimer = timer(reqStartElapsed());

function initHeartBeat() {

    var heartBeatTimer = timer();
    var heartbeatCount = 0;

    Object(__WEBPACK_IMPORTED_MODULE_3__util__["e" /* safeInterval */])(function () {

        if (__WEBPACK_IMPORTED_MODULE_0__config__["a" /* config */].heartbeatMaxThreshold && heartbeatCount > __WEBPACK_IMPORTED_MODULE_0__config__["a" /* config */].heartbeatMaxThreshold) {
            return;
        }

        heartbeatCount += 1;

        var elapsed = heartBeatTimer.elapsed();
        var lag = elapsed - __WEBPACK_IMPORTED_MODULE_0__config__["a" /* config */].heartbeatInterval;

        var heartbeatPayload = {
            count: heartbeatCount,
            elapsed: elapsed
        };

        if (__WEBPACK_IMPORTED_MODULE_0__config__["a" /* config */].heartbeatTooBusy) {
            heartbeatPayload.lag = lag;

            if (lag >= __WEBPACK_IMPORTED_MODULE_0__config__["a" /* config */].heartbeatTooBusyThreshold) {
                Object(__WEBPACK_IMPORTED_MODULE_1__logger__["g" /* info */])('toobusy', heartbeatPayload, {
                    noConsole: !__WEBPACK_IMPORTED_MODULE_0__config__["a" /* config */].heartbeatConsoleLog
                });
            }
        }

        Object(__WEBPACK_IMPORTED_MODULE_1__logger__["g" /* info */])('heartbeat', heartbeatPayload, {
            noConsole: !__WEBPACK_IMPORTED_MODULE_0__config__["a" /* config */].heartbeatConsoleLog
        });
    }, __WEBPACK_IMPORTED_MODULE_0__config__["a" /* config */].heartbeatInterval);
}

function initPerformance() {

    if (!enablePerformance) {
        return Object(__WEBPACK_IMPORTED_MODULE_1__logger__["g" /* info */])('no_performance_data');
    }

    Object(__WEBPACK_IMPORTED_MODULE_2__builders__["c" /* addPayloadBuilder */])(function () {

        var payload = {};

        payload.client_elapsed = clientTimer.elapsed();

        if (enablePerformance) {
            payload.req_elapsed = reqTimer.elapsed();
        }

        return payload;
    });

    __WEBPACK_IMPORTED_MODULE_3__util__["g" /* windowReady */].then(function () {

        var keys = ['connectEnd', 'connectStart', 'domComplete', 'domContentLoadedEventEnd', 'domContentLoadedEventStart', 'domInteractive', 'domLoading', 'domainLookupEnd', 'domainLookupStart', 'fetchStart', 'loadEventEnd', 'loadEventStart', 'navigationStart', 'redirectEnd', 'redirectStart', 'requestStart', 'responseEnd', 'responseStart', 'secureConnectionStart', 'unloadEventEnd', 'unloadEventStart'];

        var timing = {};

        keys.forEach(function (key) {
            timing[key] = parseInt(window.performance.timing[key], 10) || 0;
        });

        var offset = timing.connectEnd - timing.navigationStart;

        if (timing.connectEnd) {
            Object.keys(timing).forEach(function (name) {
                var time = timing[name];
                if (time) {
                    Object(__WEBPACK_IMPORTED_MODULE_1__logger__["g" /* info */])('timing_' + name, {
                        client_elapsed: parseInt(time - timing.connectEnd - (clientTimer.startTime - offset), 10),
                        req_elapsed: parseInt(time - timing.connectEnd, 10)
                    });
                }
            });
        }

        Object(__WEBPACK_IMPORTED_MODULE_1__logger__["g" /* info */])('timing', timing);
        Object(__WEBPACK_IMPORTED_MODULE_1__logger__["g" /* info */])('memory', window.performance.memory);
        Object(__WEBPACK_IMPORTED_MODULE_1__logger__["g" /* info */])('navigation', window.performance.navigation);

        if (window.performance.getEntries) {
            window.performance.getEntries().forEach(function (resource) {
                if (['link', 'script', 'img', 'css'].indexOf(resource.initiatorType) > -1) {
                    Object(__WEBPACK_IMPORTED_MODULE_1__logger__["g" /* info */])(resource.initiatorType, resource);
                }
            });
        }
    });
}

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RENDER_DRIVERS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_post_robot_src__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__window__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__error__ = __webpack_require__(13);









/*  Render Drivers
    --------------

    There are various differences in how we treat:

    - Opening frames and windows
    - Rendering up to the parent
    - Resizing
    - etc.

    based on the context we're rendering to.

    These render drivers split this functionality out in a driver pattern, so our component code doesn't bunch up into a
    series of if-popup-then-else-if-iframe code.
*/

var RENDER_DRIVERS = {};

// Iframe context is rendered inline on the page, without any kind of parent template. It's the one context that is designed
// to feel like a native element on the page.

RENDER_DRIVERS[__WEBPACK_IMPORTED_MODULE_4__constants__["CONTEXT_TYPES"].IFRAME] = {

    focusable: false,
    renderedIntoContainerTemplate: true,
    allowResize: true,
    openOnClick: false,
    openOnFocus: false,

    open: function open(url) {
        var _this = this;

        this.iframe = Object(__WEBPACK_IMPORTED_MODULE_3__lib__["B" /* iframe */])({
            url: url,
            attributes: {
                name: this.childWindowName,
                scrolling: this.component.scrolling ? 'yes' : 'no'
            },
            'class': [__WEBPACK_IMPORTED_MODULE_4__constants__["CLASS_NAMES"].COMPONENT_FRAME, __WEBPACK_IMPORTED_MODULE_4__constants__["CLASS_NAMES"].INVISIBLE]
        }, this.element);

        return Object(__WEBPACK_IMPORTED_MODULE_3__lib__["f" /* awaitFrameWindow */])(this.iframe).then(function (frameWindow) {

            _this.window = frameWindow;

            var detectClose = function detectClose() {
                __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](function () {
                    return _this.props.onClose(__WEBPACK_IMPORTED_MODULE_4__constants__["CLOSE_REASONS"].CLOSE_DETECTED);
                })['finally'](function () {
                    return _this.destroy();
                });
            };

            var iframeWatcher = Object(__WEBPACK_IMPORTED_MODULE_3__lib__["_1" /* watchElementForClose */])(_this.iframe, detectClose);
            var elementWatcher = Object(__WEBPACK_IMPORTED_MODULE_3__lib__["_1" /* watchElementForClose */])(_this.element, detectClose);

            _this.clean.register('destroyWindow', function () {

                iframeWatcher.cancel();
                elementWatcher.cancel();

                Object(__WEBPACK_IMPORTED_MODULE_1_post_robot_src__["cleanUpWindow"])(_this.window);

                delete _this.window;

                if (_this.iframe) {
                    Object(__WEBPACK_IMPORTED_MODULE_3__lib__["l" /* destroyElement */])(_this.iframe);
                    delete _this.iframe;
                }
            });
        });
    },
    openPrerender: function openPrerender() {
        var _this2 = this;

        this.prerenderIframe = Object(__WEBPACK_IMPORTED_MODULE_3__lib__["B" /* iframe */])({
            attributes: {
                name: '__prerender__' + this.childWindowName,
                scrolling: this.component.scrolling ? 'yes' : 'no'
            },
            'class': [__WEBPACK_IMPORTED_MODULE_4__constants__["CLASS_NAMES"].PRERENDER_FRAME, __WEBPACK_IMPORTED_MODULE_4__constants__["CLASS_NAMES"].VISIBLE]
        }, this.element);

        return Object(__WEBPACK_IMPORTED_MODULE_3__lib__["f" /* awaitFrameWindow */])(this.prerenderIframe).then(function (prerenderFrameWindow) {

            _this2.prerenderWindow = prerenderFrameWindow;

            _this2.clean.register('destroyPrerender', function () {

                if (_this2.prerenderIframe) {
                    Object(__WEBPACK_IMPORTED_MODULE_3__lib__["l" /* destroyElement */])(_this2.prerenderIframe);
                    delete _this2.prerenderIframe;
                }
            });
        });
    },
    switchPrerender: function switchPrerender() {
        var _this3 = this;

        Object(__WEBPACK_IMPORTED_MODULE_3__lib__["a" /* addClass */])(this.prerenderIframe, __WEBPACK_IMPORTED_MODULE_4__constants__["CLASS_NAMES"].INVISIBLE);
        Object(__WEBPACK_IMPORTED_MODULE_3__lib__["N" /* removeClass */])(this.prerenderIframe, __WEBPACK_IMPORTED_MODULE_4__constants__["CLASS_NAMES"].VISIBLE);

        Object(__WEBPACK_IMPORTED_MODULE_3__lib__["a" /* addClass */])(this.iframe, __WEBPACK_IMPORTED_MODULE_4__constants__["CLASS_NAMES"].VISIBLE);
        Object(__WEBPACK_IMPORTED_MODULE_3__lib__["N" /* removeClass */])(this.iframe, __WEBPACK_IMPORTED_MODULE_4__constants__["CLASS_NAMES"].INVISIBLE);

        setTimeout(function () {
            if (_this3.prerenderIframe) {
                Object(__WEBPACK_IMPORTED_MODULE_3__lib__["l" /* destroyElement */])(_this3.prerenderIframe);
            }
        }, 1000);
    },


    delegateOverrides: {

        openContainer: __WEBPACK_IMPORTED_MODULE_4__constants__["DELEGATE"].CALL_DELEGATE,
        destroyComponent: __WEBPACK_IMPORTED_MODULE_4__constants__["DELEGATE"].CALL_DELEGATE,
        destroyContainer: __WEBPACK_IMPORTED_MODULE_4__constants__["DELEGATE"].CALL_DELEGATE,
        cancelContainerEvents: __WEBPACK_IMPORTED_MODULE_4__constants__["DELEGATE"].CALL_DELEGATE,
        createPrerenderTemplate: __WEBPACK_IMPORTED_MODULE_4__constants__["DELEGATE"].CALL_DELEGATE,
        elementReady: __WEBPACK_IMPORTED_MODULE_4__constants__["DELEGATE"].CALL_DELEGATE,
        showContainer: __WEBPACK_IMPORTED_MODULE_4__constants__["DELEGATE"].CALL_DELEGATE,
        showComponent: __WEBPACK_IMPORTED_MODULE_4__constants__["DELEGATE"].CALL_DELEGATE,
        hideContainer: __WEBPACK_IMPORTED_MODULE_4__constants__["DELEGATE"].CALL_DELEGATE,
        hideComponent: __WEBPACK_IMPORTED_MODULE_4__constants__["DELEGATE"].CALL_DELEGATE,
        hide: __WEBPACK_IMPORTED_MODULE_4__constants__["DELEGATE"].CALL_DELEGATE,
        show: __WEBPACK_IMPORTED_MODULE_4__constants__["DELEGATE"].CALL_DELEGATE,
        resize: __WEBPACK_IMPORTED_MODULE_4__constants__["DELEGATE"].CALL_DELEGATE,
        loadUrl: __WEBPACK_IMPORTED_MODULE_4__constants__["DELEGATE"].CALL_DELEGATE,
        hijackSubmit: __WEBPACK_IMPORTED_MODULE_4__constants__["DELEGATE"].CALL_DELEGATE,
        openPrerender: __WEBPACK_IMPORTED_MODULE_4__constants__["DELEGATE"].CALL_DELEGATE,
        switchPrerender: __WEBPACK_IMPORTED_MODULE_4__constants__["DELEGATE"].CALL_DELEGATE,

        renderTemplate: __WEBPACK_IMPORTED_MODULE_4__constants__["DELEGATE"].CALL_ORIGINAL,
        openContainerFrame: __WEBPACK_IMPORTED_MODULE_4__constants__["DELEGATE"].CALL_ORIGINAL,
        getOutlet: __WEBPACK_IMPORTED_MODULE_4__constants__["DELEGATE"].CALL_ORIGINAL,

        open: function open(original, override) {
            return function () {
                var _this4 = this;

                return override.apply(this, arguments).then(function () {
                    _this4.clean.set('window', Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__["a" /* findFrameByName */])(Object(__WEBPACK_IMPORTED_MODULE_5__window__["c" /* getParentComponentWindow */])(), _this4.childWindowName));

                    if (!_this4.window) {
                        throw new Error('Unable to find parent component iframe window');
                    }
                });
            };
        }
    },

    resize: function resize(width, height) {

        if (width) {
            this.element.style.width = Object(__WEBPACK_IMPORTED_MODULE_3__lib__["W" /* toCSS */])(width);
        }

        if (height) {
            this.element.style.height = Object(__WEBPACK_IMPORTED_MODULE_3__lib__["W" /* toCSS */])(height);
        }
    },
    show: function show() {
        Object(__WEBPACK_IMPORTED_MODULE_3__lib__["T" /* showElement */])(this.element);
    },
    hide: function hide() {
        Object(__WEBPACK_IMPORTED_MODULE_3__lib__["A" /* hideElement */])(this.element);
    },
    loadUrl: function loadUrl(url) {
        this.iframe.setAttribute('src', url);
    }
};

if (false) {

    // Popup context opens up a centered popup window on the page.

    RENDER_DRIVERS[CONTEXT_TYPES.POPUP] = {

        focusable: true,
        renderedIntoContainerTemplate: false,
        allowResize: false,
        openOnClick: true,
        openOnFocus: true,

        open: function open() {
            var _this5 = this;

            var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

            return ZalgoPromise['try'](function () {
                var _ref = _this5.component.dimensions || {},
                    _ref$width = _ref.width,
                    width = _ref$width === undefined ? DEFAULT_DIMENSIONS.WIDTH : _ref$width,
                    _ref$height = _ref.height,
                    height = _ref$height === undefined ? DEFAULT_DIMENSIONS.HEIGHT : _ref$height;

                width = normalizeDimension(width, window.outerWidth);
                height = normalizeDimension(height, window.outerWidth);

                var _getPosition = getPosition({ width: width, height: height }),
                    x = _getPosition.x,
                    y = _getPosition.y;

                try {
                    _this5.window = popup(url || '', {
                        name: _this5.childWindowName,
                        width: width,
                        height: height,
                        top: y,
                        left: x,
                        status: 1,
                        toolbar: 0,
                        menubar: 0,
                        resizable: 1,
                        scrollbars: 1
                    });
                } catch (err) {

                    if (err instanceof PopupOpenError) {
                        _this5.component.logError('popup_open_error');
                    }

                    throw err;
                }

                _this5.prerenderWindow = _this5.window;

                _this5.clean.register('destroyWindow', function () {
                    if (_this5.window) {
                        _this5.window.close();
                        cleanUpWindow(_this5.window);
                        delete _this5.window;
                        delete _this5.prerenderWindow;
                    }
                });

                _this5.resize(width, height);
            });
        },
        openPrerender: function openPrerender() {
            return ZalgoPromise['try'](function () {});
        },
        resize: function resize(width, height) {},
        hide: function hide() {
            throw new Error('Can not hide popup');
        },
        show: function show() {
            throw new Error('Can not show popup');
        },


        delegateOverrides: {

            openContainer: DELEGATE.CALL_DELEGATE,
            destroyContainer: DELEGATE.CALL_DELEGATE,

            elementReady: DELEGATE.CALL_DELEGATE,

            showContainer: DELEGATE.CALL_DELEGATE,
            showComponent: DELEGATE.CALL_DELEGATE,
            hideContainer: DELEGATE.CALL_DELEGATE,
            hideComponent: DELEGATE.CALL_DELEGATE,

            hide: DELEGATE.CALL_DELEGATE,
            show: DELEGATE.CALL_DELEGATE,

            cancelContainerEvents: DELEGATE.CALL_DELEGATE,

            open: DELEGATE.CALL_ORIGINAL,
            loadUrl: DELEGATE.CALL_ORIGINAL,
            createPrerenderTemplate: DELEGATE.CALL_ORIGINAL,
            destroyComponent: DELEGATE.CALL_ORIGINAL,
            resize: DELEGATE.CALL_ORIGINAL,
            renderTemplate: DELEGATE.CALL_ORIGINAL,
            openContainerFrame: DELEGATE.CALL_ORIGINAL,
            getOutlet: DELEGATE.CALL_ORIGINAL
        },

        loadUrl: function loadUrl(url) {
            this.window.location = url;
        }
    };
}

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export normalizeProp */
/* harmony export (immutable) */ __webpack_exports__["a"] = normalizeProps;
/* harmony export (immutable) */ __webpack_exports__["b"] = propsToQuery;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__component__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__component_props__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__index__ = __webpack_require__(10);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };










function isDefined(value) {
    return value !== null && value !== undefined && value !== '';
}

/*  Normalize Prop
    --------------

    Turn prop into normalized value, using defaults, function options, etc.
*/

function normalizeProp(component, instance, props, key, value) {

    var prop = component.getProp(key);

    var resultValue = void 0;

    if (prop.value) {
        resultValue = prop.value;
    } else if (prop.def && (!props.hasOwnProperty(key) || !isDefined(value))) {
        resultValue = prop.def.call(component, props);
    } else {
        resultValue = value;
    }

    if (!resultValue && prop.alias && props[prop.alias]) {
        resultValue = props[prop.alias];
    }

    var decorated = false;

    if (prop.decorate && resultValue !== null && resultValue !== undefined) {
        resultValue = prop.decorate(resultValue, props);
        decorated = true;
    }

    if (prop.type === 'boolean') {
        // $FlowFixMe
        resultValue = Boolean(resultValue);
    } else if (prop.type === 'function') {

        if (!resultValue && prop.noop) {
            // $FlowFixMe
            resultValue = __WEBPACK_IMPORTED_MODULE_1__lib__["I" /* noop */];

            if (!decorated && prop.decorate) {
                resultValue = prop.decorate(resultValue, props);
            }
        }

        if (resultValue && typeof resultValue === 'function') {

            resultValue = resultValue.bind(instance);

            // If prop.denodeify is set, denodeify the function (accepts callback -> returns promise)

            if (prop.denodeify) {
                // $FlowFixMe
                resultValue = Object(__WEBPACK_IMPORTED_MODULE_1__lib__["j" /* denodeify */])(resultValue);
            }

            if (prop.promisify) {
                // $FlowFixMe
                resultValue = Object(__WEBPACK_IMPORTED_MODULE_1__lib__["M" /* promisify */])(resultValue);
            }

            // Wrap the function in order to log when it is called

            var original = resultValue;
            // $FlowFixMe
            resultValue = function resultValue() {
                component.log('call_prop_' + key);
                return original.apply(this, arguments);
            };

            // If prop.once is set, ensure the function can only be called once

            if (prop.once) {
                // $FlowFixMe
                resultValue = Object(__WEBPACK_IMPORTED_MODULE_1__lib__["K" /* once */])(resultValue);
            }

            // If prop.memoize is set, ensure the function is memoized (first return resultValue is cached and returned for any future calls)

            if (prop.memoize) {
                // $FlowFixMe
                resultValue = Object(__WEBPACK_IMPORTED_MODULE_1__lib__["G" /* memoize */])(resultValue);
            }
        }
    } else if (prop.type === 'string') {
        // pass

    } else if (prop.type === 'object') {
        // pass

    } else if (prop.type === 'number') {
        if (resultValue !== undefined) {
            // $FlowFixMe
            resultValue = parseInt(resultValue, 10);
        }
    }

    // $FlowFixMe
    return resultValue;
}

/*  Normalize Props
    ---------------

    Turn props into normalized values, using defaults, function options, etc.
*/

function normalizeProps(component, instance, props) {
    var required = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;


    var result = {};

    // $FlowFixMe
    props = props || {};

    result.version = component.version;

    for (var _iterator = Object.keys(props), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
        var _ref;

        if (_isArray) {
            if (_i >= _iterator.length) break;
            _ref = _iterator[_i++];
        } else {
            _i = _iterator.next();
            if (_i.done) break;
            _ref = _i.value;
        }

        var key = _ref;

        if (component.getPropNames().indexOf(key) !== -1) {
            // $FlowFixMe
            result[key] = normalizeProp(component, instance, props, key, props[key]);
        } else {
            result[key] = props[key];
        }
    }

    for (var _iterator2 = component.getPropNames(), _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
        var _ref2;

        if (_isArray2) {
            if (_i2 >= _iterator2.length) break;
            _ref2 = _iterator2[_i2++];
        } else {
            _i2 = _iterator2.next();
            if (_i2.done) break;
            _ref2 = _i2.value;
        }

        var _key = _ref2;

        if (!props.hasOwnProperty(_key)) {

            // $FlowFixMe
            var normalizedProp = normalizeProp(component, instance, props, _key, props[_key]);

            if (normalizedProp !== undefined) {
                result[_key] = normalizedProp;
            }
        }
    }

    // $FlowFixMe
    return result;
}

/*  Props to Query
    --------------

    Turn props into an initial query string to open the component with

    string -> string
    bool   -> 1
    object -> json
    number -> string
*/

function getQueryParam(prop, key, value) {
    return __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](function () {
        if (typeof prop.queryParam === 'function') {
            return prop.queryParam(value);
        } else if (typeof prop.queryParam === 'string') {
            return prop.queryParam;
        } else {
            return key;
        }
    });
}

function getQueryValue(prop, key, value) {
    return __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](function () {
        if (typeof prop.queryValue === 'function') {
            return prop.queryValue(value);
        } else {
            return value;
        }
    });
}

function propsToQuery(propsDef, props) {

    var params = {};

    return __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__["a" /* ZalgoPromise */].all(Object.keys(props).map(function (key) {

        var prop = propsDef[key];

        if (!prop) {
            return;
        }

        return __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__["a" /* ZalgoPromise */].resolve().then(function () {

            var value = props[key];

            if (!value) {
                return;
            }

            if (!prop.queryParam) {
                return;
            }

            return value;
        }).then(function (value) {

            if (!value) {
                return;
            }

            __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__["a" /* ZalgoPromise */].all([getQueryParam(prop, key, value), getQueryValue(prop, key, value)]).then(function (_ref3) {
                var queryParam = _ref3[0],
                    queryValue = _ref3[1];


                var result = void 0;

                if (typeof queryValue === 'boolean') {
                    result = '1';
                } else if (typeof queryValue === 'string') {
                    result = queryValue.toString();
                } else if (typeof queryValue === 'function') {
                    return;
                } else if ((typeof queryValue === 'undefined' ? 'undefined' : _typeof(queryValue)) === 'object' && queryValue !== null) {

                    if (prop.serialization === 'json') {
                        result = JSON.stringify(queryValue);
                    } else {
                        result = Object(__WEBPACK_IMPORTED_MODULE_1__lib__["o" /* dotify */])(queryValue, key);

                        for (var dotkey in result) {
                            params[dotkey] = result[dotkey];
                        }

                        return;
                    }
                } else if (typeof queryValue === 'number') {
                    result = queryValue.toString();
                }

                params[queryParam] = result;
            });
        });
    })).then(function () {
        return params;
    });
}

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interface__ = __webpack_require__(26);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "create", function() { return __WEBPACK_IMPORTED_MODULE_0__interface__["create"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getByTag", function() { return __WEBPACK_IMPORTED_MODULE_0__interface__["getByTag"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getCurrentScriptDir", function() { return __WEBPACK_IMPORTED_MODULE_0__interface__["getCurrentScriptDir"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "destroyAll", function() { return __WEBPACK_IMPORTED_MODULE_0__interface__["destroyAll"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "postRobot", function() { return __WEBPACK_IMPORTED_MODULE_0__interface__["postRobot"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "CONSTANTS", function() { return __WEBPACK_IMPORTED_MODULE_0__interface__["CONSTANTS"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "PopupOpenError", function() { return __WEBPACK_IMPORTED_MODULE_0__interface__["PopupOpenError"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "IntegrationError", function() { return __WEBPACK_IMPORTED_MODULE_0__interface__["IntegrationError"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "RenderError", function() { return __WEBPACK_IMPORTED_MODULE_0__interface__["RenderError"]; });


/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__interface__);

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ZalgoPromise; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__exceptions__ = __webpack_require__(39);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var global = window.__zalgopromise__ = window.__zalgopromise__ || {
    flushPromises: [],
    activeCount: 0
};

var ZalgoPromise = function () {
    function ZalgoPromise(handler) {
        var _this = this;

        _classCallCheck(this, ZalgoPromise);

        this.resolved = false;
        this.rejected = false;
        this.errorHandled = false;

        this.handlers = [];

        if (handler) {

            var _result = void 0;
            var _error = void 0;
            var resolved = false;
            var rejected = false;
            var isAsync = false;

            try {
                handler(function (res) {
                    if (isAsync) {
                        _this.resolve(res);
                    } else {
                        resolved = true;
                        _result = res;
                    }
                }, function (err) {
                    if (isAsync) {
                        _this.reject(err);
                    } else {
                        rejected = true;
                        _error = err;
                    }
                });
            } catch (err) {
                this.reject(err);
                return;
            }

            isAsync = true;

            if (resolved) {
                // $FlowFixMe
                this.resolve(_result);
            } else if (rejected) {
                this.reject(_error);
            }
        }
    }

    ZalgoPromise.prototype.resolve = function resolve(result) {
        if (this.resolved || this.rejected) {
            return this;
        }

        if (Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* isPromise */])(result)) {
            throw new Error('Can not resolve promise with another promise');
        }

        this.resolved = true;
        this.value = result;
        this.dispatch();

        return this;
    };

    ZalgoPromise.prototype.reject = function reject(error) {
        var _this2 = this;

        if (this.resolved || this.rejected) {
            return this;
        }

        if (Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* isPromise */])(error)) {
            throw new Error('Can not reject promise with another promise');
        }

        if (!error) {
            var _err = error && typeof error.toString === 'function' ? error.toString() : Object.prototype.toString.call(error);
            error = new Error('Expected reject to be called with Error, got ' + _err);
        }

        this.rejected = true;
        this.error = error;

        if (!this.errorHandled) {
            setTimeout(function () {
                if (!_this2.errorHandled) {
                    Object(__WEBPACK_IMPORTED_MODULE_1__exceptions__["a" /* dispatchPossiblyUnhandledError */])(error);
                }
            }, 1);
        }

        this.dispatch();

        return this;
    };

    ZalgoPromise.prototype.asyncReject = function asyncReject(error) {
        this.errorHandled = true;
        this.reject(error);
    };

    ZalgoPromise.prototype.dispatch = function dispatch() {
        var _this3 = this;

        var dispatching = this.dispatching,
            resolved = this.resolved,
            rejected = this.rejected,
            handlers = this.handlers;


        if (dispatching) {
            return;
        }

        if (!resolved && !rejected) {
            return;
        }

        this.dispatching = true;
        global.activeCount += 1;

        var _loop = function _loop(i) {
            var _handlers$i = handlers[i],
                onSuccess = _handlers$i.onSuccess,
                onError = _handlers$i.onError,
                promise = _handlers$i.promise;


            var result = void 0;

            if (resolved) {

                try {
                    result = onSuccess ? onSuccess(_this3.value) : _this3.value;
                } catch (err) {
                    promise.reject(err);
                    return 'continue';
                }
            } else if (rejected) {

                if (!onError) {
                    promise.reject(_this3.error);
                    return 'continue';
                }

                try {
                    result = onError(_this3.error);
                } catch (err) {
                    promise.reject(err);
                    return 'continue';
                }
            }

            if (result instanceof ZalgoPromise && (result.resolved || result.rejected)) {

                if (result.resolved) {
                    promise.resolve(result.value);
                } else {
                    promise.reject(result.error);
                }

                result.errorHandled = true;
            } else if (Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* isPromise */])(result)) {

                if (result instanceof ZalgoPromise && (result.resolved || result.rejected)) {
                    if (result.resolved) {
                        promise.resolve(result.value);
                    } else {
                        promise.reject(result.error);
                    }
                } else {
                    // $FlowFixMe
                    result.then(function (res) {
                        promise.resolve(res);
                    }, function (err) {
                        promise.reject(err);
                    });
                }
            } else {

                promise.resolve(result);
            }
        };

        for (var i = 0; i < handlers.length; i++) {
            var _ret = _loop(i);

            if (_ret === 'continue') continue;
        }

        handlers.length = 0;
        this.dispatching = false;
        global.activeCount -= 1;

        if (global.activeCount === 0) {
            ZalgoPromise.flushQueue();
        }
    };

    ZalgoPromise.prototype.then = function then(onSuccess, onError) {

        if (onSuccess && typeof onSuccess !== 'function' && !onSuccess.call) {
            throw new Error('Promise.then expected a function for success handler');
        }

        if (onError && typeof onError !== 'function' && !onError.call) {
            throw new Error('Promise.then expected a function for error handler');
        }

        var promise = new ZalgoPromise();

        this.handlers.push({
            promise: promise,
            onSuccess: onSuccess,
            onError: onError
        });

        this.errorHandled = true;

        this.dispatch();

        return promise;
    };

    ZalgoPromise.prototype['catch'] = function _catch(onError) {
        return this.then(undefined, onError);
    };

    ZalgoPromise.prototype['finally'] = function _finally(handler) {
        return this.then(function (result) {
            return ZalgoPromise['try'](handler).then(function () {
                return result;
            });
        }, function (err) {
            return ZalgoPromise['try'](handler).then(function () {
                throw err;
            });
        });
    };

    ZalgoPromise.prototype.timeout = function timeout(time, err) {
        var _this4 = this;

        if (this.resolved || this.rejected) {
            return this;
        }

        var timeout = setTimeout(function () {

            if (_this4.resolved || _this4.rejected) {
                return;
            }

            _this4.reject(err || new Error('Promise timed out after ' + time + 'ms'));
        }, time);

        return this.then(function (result) {
            clearTimeout(timeout);
            return result;
        });
    };

    ZalgoPromise.prototype.toPromise = function toPromise() {
        if (!window.Promise) {
            throw new Error('Could not find window.Promise');
        }
        return window.Promise.resolve(this);
    };

    ZalgoPromise.resolve = function resolve(value) {

        if (value instanceof ZalgoPromise) {
            return value;
        }

        if (Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* isPromise */])(value)) {
            // $FlowFixMe
            return new ZalgoPromise(function (resolve, reject) {
                return value.then(resolve, reject);
            });
        }

        return new ZalgoPromise().resolve(value);
    };

    ZalgoPromise.reject = function reject(error) {
        return new ZalgoPromise().reject(error);
    };

    ZalgoPromise.all = function all(promises) {

        var promise = new ZalgoPromise();
        var count = promises.length;
        var results = [];

        if (!count) {
            promise.resolve(results);
            return promise;
        }

        var _loop2 = function _loop2(i) {
            var prom = promises[i];

            if (prom instanceof ZalgoPromise) {
                if (prom.resolved) {
                    results[i] = prom.value;
                    count -= 1;
                    return 'continue';
                }
            } else if (!Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* isPromise */])(prom)) {
                results[i] = prom;
                count -= 1;
                return 'continue';
            }

            ZalgoPromise.resolve(prom).then(function (result) {
                results[i] = result;
                count -= 1;
                if (count === 0) {
                    promise.resolve(results);
                }
            }, function (err) {
                promise.reject(err);
            });
        };

        for (var i = 0; i < promises.length; i++) {
            var _ret2 = _loop2(i);

            if (_ret2 === 'continue') continue;
        }

        if (count === 0) {
            promise.resolve(results);
        }

        return promise;
    };

    ZalgoPromise.hash = function hash(promises) {
        var result = {};

        return ZalgoPromise.all(Object.keys(promises).map(function (key) {
            return ZalgoPromise.resolve(promises[key]).then(function (value) {
                result[key] = value;
            });
        })).then(function () {
            return result;
        });
    };

    ZalgoPromise.map = function map(items, method) {
        // $FlowFixMe
        return ZalgoPromise.all(items.map(method));
    };

    ZalgoPromise.onPossiblyUnhandledException = function onPossiblyUnhandledException(handler) {
        return Object(__WEBPACK_IMPORTED_MODULE_1__exceptions__["b" /* onPossiblyUnhandledException */])(handler);
    };

    ZalgoPromise['try'] = function _try(method, context, args) {

        var result = void 0;

        try {
            // $FlowFixMe
            result = method.apply(context, args || []);
        } catch (err) {
            return ZalgoPromise.reject(err);
        }

        return ZalgoPromise.resolve(result);
    };

    ZalgoPromise.delay = function delay(_delay) {
        return new ZalgoPromise(function (resolve) {
            setTimeout(resolve, _delay);
        });
    };

    ZalgoPromise.isPromise = function isPromise(value) {

        if (value && value instanceof ZalgoPromise) {
            return true;
        }

        return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* isPromise */])(value);
    };

    ZalgoPromise.flush = function flush() {
        var promise = new ZalgoPromise();
        global.flushPromises.push(promise);

        if (global.activeCount === 0) {
            ZalgoPromise.flushQueue();
        }

        return promise;
    };

    ZalgoPromise.flushQueue = function flushQueue() {
        var promisesToFlush = global.flushPromises;
        global.flushPromises = [];

        for (var _iterator = promisesToFlush, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
            var _ref;

            if (_isArray) {
                if (_i >= _iterator.length) break;
                _ref = _iterator[_i++];
            } else {
                _i = _iterator.next();
                if (_i.done) break;
                _ref = _i.value;
            }

            var _promise = _ref;

            _promise.resolve();
        }
    };

    return ZalgoPromise;
}();



/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isPromise;

var toString = {}.toString;

function isPromise(item) {
    try {
        if (!item) {
            return false;
        }

        if (window.Promise && item instanceof window.Promise) {
            return true;
        }

        if (window.Window && item instanceof window.Window) {
            return false;
        }

        if (window.constructor && item instanceof window.constructor) {
            return false;
        }

        if (toString) {
            var name = toString.call(item);

            if (name === '[object Window]' || name === '[object global]' || name === '[object DOMWindow]') {
                return false;
            }
        }

        if (typeof item.then === 'function') {
            return true;
        }
    } catch (err) {
        return false;
    }

    return false;
}

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = dispatchPossiblyUnhandledError;
/* harmony export (immutable) */ __webpack_exports__["b"] = onPossiblyUnhandledException;

var possiblyUnhandledPromiseHandlers = [];
var dispatchedErrors = [];

function dispatchPossiblyUnhandledError(err) {

    if (dispatchedErrors.indexOf(err) !== -1) {
        return;
    }

    dispatchedErrors.push(err);

    setTimeout(function () {
        throw err;
    }, 1);

    for (var j = 0; j < possiblyUnhandledPromiseHandlers.length; j++) {
        possiblyUnhandledPromiseHandlers[j](err);
    }
}

function onPossiblyUnhandledException(handler) {
    possiblyUnhandledPromiseHandlers.push(handler);

    return {
        cancel: function cancel() {
            possiblyUnhandledPromiseHandlers.splice(possiblyUnhandledPromiseHandlers.indexOf(handler), 1);
        }
    };
}

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__component__ = __webpack_require__(2);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__component__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__parent__ = __webpack_require__(10);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__child__ = __webpack_require__(25);
/* unused harmony namespace reexport */




/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CrossDomainSafeWeakMap; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_cross_domain_utils_src__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__native__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util__ = __webpack_require__(44);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }






var defineProperty = Object.defineProperty;
var counter = Date.now() % 1e9;

var CrossDomainSafeWeakMap = function () {
    function CrossDomainSafeWeakMap() {
        _classCallCheck(this, CrossDomainSafeWeakMap);

        counter += 1;
        this.name = '__weakmap_' + (Math.random() * 1e9 >>> 0) + '__' + counter; // eslint-disable-line

        if (Object(__WEBPACK_IMPORTED_MODULE_1__native__["a" /* hasNativeWeakMap */])()) {
            try {
                this.weakmap = new window.WeakMap();
            } catch (err) {
                // pass
            }
        }

        this.keys = [];
        this.values = [];
    }

    CrossDomainSafeWeakMap.prototype._cleanupClosedWindows = function _cleanupClosedWindows() {

        var weakmap = this.weakmap;
        var keys = this.keys;

        for (var i = 0; i < keys.length; i++) {
            var value = keys[i];

            if (Object(__WEBPACK_IMPORTED_MODULE_0_cross_domain_utils_src__["s" /* isWindow */])(value) && Object(__WEBPACK_IMPORTED_MODULE_0_cross_domain_utils_src__["t" /* isWindowClosed */])(value)) {

                if (weakmap) {
                    try {
                        weakmap['delete'](value);
                    } catch (err) {
                        // pass
                    }
                }

                keys.splice(i, 1);
                this.values.splice(i, 1);

                i -= 1;
            }
        }
    };

    CrossDomainSafeWeakMap.prototype.isSafeToReadWrite = function isSafeToReadWrite(key) {

        if (Object(__WEBPACK_IMPORTED_MODULE_0_cross_domain_utils_src__["s" /* isWindow */])(key)) {
            return false;
        }

        try {
            Object(__WEBPACK_IMPORTED_MODULE_2__util__["a" /* noop */])(key && key.self);
            Object(__WEBPACK_IMPORTED_MODULE_2__util__["a" /* noop */])(key && key[this.name]);
        } catch (err) {
            return false;
        }

        return true;
    };

    CrossDomainSafeWeakMap.prototype.set = function set(key, value) {

        if (!key) {
            throw new Error('WeakMap expected key');
        }

        var weakmap = this.weakmap;

        if (weakmap) {
            try {
                weakmap.set(key, value);
            } catch (err) {
                delete this.weakmap;
            }
        }

        if (!this.isSafeToReadWrite(key)) {

            this._cleanupClosedWindows();

            var keys = this.keys;
            var values = this.values;
            var index = Object(__WEBPACK_IMPORTED_MODULE_2__util__["b" /* safeIndexOf */])(keys, key);

            if (index === -1) {
                keys.push(key);
                values.push(value);
            } else {
                values[index] = value;
            }
        } else {

            var name = this.name;
            var entry = key[name];

            if (entry && entry[0] === key) {
                entry[1] = value;
            } else {
                defineProperty(key, name, {
                    value: [key, value],
                    writable: true
                });
            }
        }
    };

    CrossDomainSafeWeakMap.prototype.get = function get(key) {

        if (!key) {
            throw new Error('WeakMap expected key');
        }

        var weakmap = this.weakmap;

        if (weakmap) {
            try {
                if (weakmap.has(key)) {
                    return weakmap.get(key);
                }
            } catch (err) {
                delete this.weakmap;
            }
        }

        if (!this.isSafeToReadWrite(key)) {

            this._cleanupClosedWindows();

            var keys = this.keys;
            var index = Object(__WEBPACK_IMPORTED_MODULE_2__util__["b" /* safeIndexOf */])(keys, key);

            if (index === -1) {
                return;
            }

            return this.values[index];
        } else {

            var entry = key[this.name];

            if (entry && entry[0] === key) {
                return entry[1];
            }
        }
    };

    CrossDomainSafeWeakMap.prototype['delete'] = function _delete(key) {

        if (!key) {
            throw new Error('WeakMap expected key');
        }

        var weakmap = this.weakmap;

        if (weakmap) {
            try {
                weakmap['delete'](key);
            } catch (err) {
                delete this.weakmap;
            }
        }

        if (!this.isSafeToReadWrite(key)) {

            this._cleanupClosedWindows();

            var keys = this.keys;
            var index = Object(__WEBPACK_IMPORTED_MODULE_2__util__["b" /* safeIndexOf */])(keys, key);

            if (index !== -1) {
                keys.splice(index, 1);
                this.values.splice(index, 1);
            }
        } else {

            var entry = key[this.name];

            if (entry && entry[0] === key) {
                entry[0] = entry[1] = undefined;
            }
        }
    };

    CrossDomainSafeWeakMap.prototype.has = function has(key) {

        if (!key) {
            throw new Error('WeakMap expected key');
        }

        var weakmap = this.weakmap;

        if (weakmap) {
            try {
                return weakmap.has(key);
            } catch (err) {
                delete this.weakmap;
            }
        }

        if (!this.isSafeToReadWrite(key)) {

            this._cleanupClosedWindows();

            var index = Object(__WEBPACK_IMPORTED_MODULE_2__util__["b" /* safeIndexOf */])(this.keys, key);
            return index !== -1;
        } else {

            var entry = key[this.name];

            if (entry && entry[0] === key) {
                return true;
            }

            return false;
        }
    };

    return CrossDomainSafeWeakMap;
}();

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isRegex;
/* harmony export (immutable) */ __webpack_exports__["b"] = noop;
function isRegex(item) {
    return Object.prototype.toString.call(item) === '[object RegExp]';
}

function noop() {
    // pass
}

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = hasNativeWeakMap;
function hasNativeWeakMap() {

    if (!window.WeakMap) {
        return false;
    }

    if (!window.Object.freeze) {
        return false;
    }

    try {

        var testWeakMap = new window.WeakMap();
        var testKey = {};
        var testValue = '__testvalue__';

        window.Object.freeze(testKey);

        testWeakMap.set(testKey, testValue);

        if (testWeakMap.get(testKey) === testValue) {
            return true;
        }

        return false;
    } catch (err) {

        return false;
    }
}

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = safeIndexOf;
/* harmony export (immutable) */ __webpack_exports__["a"] = noop;
function safeIndexOf(collection, item) {
    for (var i = 0; i < collection.length; i++) {

        try {
            if (collection[i] === item) {
                return i;
            }
        } catch (err) {
            // pass
        }
    }

    return -1;
}

function noop() {
    // pass
}

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CONFIG; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(28);
var _ALLOWED_POST_MESSAGE;



var CONFIG = {

    ALLOW_POSTMESSAGE_POPUP:  false ? false : true,

    LOG_LEVEL: 'info',

    BRIDGE_TIMEOUT: 5000,

    ACK_TIMEOUT: window.navigator.userAgent.match(/MSIE/i) !== -1 && !false ? 2000 : 1000,
    RES_TIMEOUT:  false ? 2000 : Infinity,

    LOG_TO_PAGE: false,

    ALLOWED_POST_MESSAGE_METHODS: (_ALLOWED_POST_MESSAGE = {}, _ALLOWED_POST_MESSAGE[__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* CONSTANTS */].SEND_STRATEGIES.POST_MESSAGE] = true, _ALLOWED_POST_MESSAGE[__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* CONSTANTS */].SEND_STRATEGIES.BRIDGE] = true, _ALLOWED_POST_MESSAGE[__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* CONSTANTS */].SEND_STRATEGIES.GLOBAL] = true, _ALLOWED_POST_MESSAGE)
};

if (window.location.href.indexOf(__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* CONSTANTS */].FILE_PROTOCOL) === 0) {
    CONFIG.ALLOW_POSTMESSAGE_POPUP = true;
}

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return listenForMethods; });
/* unused harmony export serializeMethod */
/* harmony export (immutable) */ __webpack_exports__["c"] = serializeMethods;
/* unused harmony export deserializeMethod */
/* unused harmony export deserializeError */
/* unused harmony export deserializeZalgoPromise */
/* unused harmony export deserializePromise */
/* unused harmony export deserializeRegex */
/* harmony export (immutable) */ __webpack_exports__["a"] = deserializeMethods;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_cross_domain_safe_weakmap_src__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_cross_domain_utils_src__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_zalgo_promise_src__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__conf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__interface__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__log__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__global__ = __webpack_require__(9);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };











__WEBPACK_IMPORTED_MODULE_7__global__["a" /* global */].methods = __WEBPACK_IMPORTED_MODULE_7__global__["a" /* global */].methods || new __WEBPACK_IMPORTED_MODULE_0_cross_domain_safe_weakmap_src__["a" /* WeakMap */]();

var listenForMethods = Object(__WEBPACK_IMPORTED_MODULE_4__util__["g" /* once */])(function () {
    Object(__WEBPACK_IMPORTED_MODULE_5__interface__["on"])(__WEBPACK_IMPORTED_MODULE_3__conf__["b" /* CONSTANTS */].POST_MESSAGE_NAMES.METHOD, { origin: __WEBPACK_IMPORTED_MODULE_3__conf__["b" /* CONSTANTS */].WILDCARD }, function (_ref) {
        var source = _ref.source,
            origin = _ref.origin,
            data = _ref.data;


        var methods = __WEBPACK_IMPORTED_MODULE_7__global__["a" /* global */].methods.get(source);

        if (!methods) {
            throw new Error('Could not find any methods this window has privileges to call');
        }

        var meth = methods[data.id];

        if (!meth) {
            throw new Error('Could not find method with id: ' + data.id);
        }

        if (!Object(__WEBPACK_IMPORTED_MODULE_1_cross_domain_utils_src__["v" /* matchDomain */])(meth.domain, origin)) {
            throw new Error('Method domain ' + meth.domain + ' does not match origin ' + origin);
        }

        __WEBPACK_IMPORTED_MODULE_6__log__["a" /* log */].debug('Call local method', data.name, data.args);

        return __WEBPACK_IMPORTED_MODULE_2_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](function () {
            return meth.method.apply({ source: source, origin: origin, data: data }, data.args);
        }).then(function (result) {

            return {
                result: result,
                id: data.id,
                name: data.name
            };
        });
    });
});

function isSerialized(item, type) {
    return (typeof item === 'undefined' ? 'undefined' : _typeof(item)) === 'object' && item !== null && item.__type__ === type;
}

function serializeMethod(destination, domain, method, name) {

    var id = Object(__WEBPACK_IMPORTED_MODULE_4__util__["k" /* uniqueID */])();

    var methods = __WEBPACK_IMPORTED_MODULE_7__global__["a" /* global */].methods.get(destination);

    if (!methods) {
        methods = {};
        __WEBPACK_IMPORTED_MODULE_7__global__["a" /* global */].methods.set(destination, methods);
    }

    methods[id] = { domain: domain, method: method };

    return {
        __type__: __WEBPACK_IMPORTED_MODULE_3__conf__["b" /* CONSTANTS */].SERIALIZATION_TYPES.METHOD,
        __id__: id,
        __name__: name
    };
}

function serializeError(err) {
    return {
        __type__: __WEBPACK_IMPORTED_MODULE_3__conf__["b" /* CONSTANTS */].SERIALIZATION_TYPES.ERROR,
        __message__: Object(__WEBPACK_IMPORTED_MODULE_4__util__["j" /* stringifyError */])(err)
    };
}

function serializePromise(destination, domain, promise, name) {
    return {
        __type__: __WEBPACK_IMPORTED_MODULE_3__conf__["b" /* CONSTANTS */].SERIALIZATION_TYPES.PROMISE,
        __then__: serializeMethod(destination, domain, function (resolve, reject) {
            return promise.then(resolve, reject);
        }, name + '.then')
    };
}

function serializeZalgoPromise(destination, domain, promise, name) {
    return {
        __type__: __WEBPACK_IMPORTED_MODULE_3__conf__["b" /* CONSTANTS */].SERIALIZATION_TYPES.ZALGO_PROMISE,
        __then__: serializeMethod(destination, domain, function (resolve, reject) {
            return promise.then(resolve, reject);
        }, name + '.then')
    };
}

function serializeRegex(regex) {
    return {
        __type__: __WEBPACK_IMPORTED_MODULE_3__conf__["b" /* CONSTANTS */].SERIALIZATION_TYPES.REGEX,
        __source__: regex.source
    };
}

function serializeMethods(destination, domain, obj) {

    return Object(__WEBPACK_IMPORTED_MODULE_4__util__["h" /* replaceObject */])({ obj: obj }, function (item, key) {
        if (typeof item === 'function') {
            return serializeMethod(destination, domain, item, key.toString());
        }

        if (item instanceof Error) {
            return serializeError(item);
        }

        if (window.Promise && item instanceof window.Promise) {
            return serializePromise(destination, domain, item, key.toString());
        }

        if (__WEBPACK_IMPORTED_MODULE_2_zalgo_promise_src__["a" /* ZalgoPromise */].isPromise(item)) {
            // $FlowFixMe
            return serializeZalgoPromise(destination, domain, item, key.toString());
        }

        if (Object(__WEBPACK_IMPORTED_MODULE_4__util__["c" /* isRegex */])(item)) {
            // $FlowFixMe
            return serializeRegex(item);
        }
    }).obj;
}

function deserializeMethod(source, origin, obj) {

    function wrapper() {
        var args = Array.prototype.slice.call(arguments);
        __WEBPACK_IMPORTED_MODULE_6__log__["a" /* log */].debug('Call foreign method', obj.__name__, args);
        return Object(__WEBPACK_IMPORTED_MODULE_5__interface__["send"])(source, __WEBPACK_IMPORTED_MODULE_3__conf__["b" /* CONSTANTS */].POST_MESSAGE_NAMES.METHOD, {
            id: obj.__id__,
            name: obj.__name__,
            args: args

        }, { domain: origin, timeout: Infinity }).then(function (_ref2) {
            var data = _ref2.data;


            __WEBPACK_IMPORTED_MODULE_6__log__["a" /* log */].debug('Got foreign method result', obj.__name__, data.result);
            return data.result;
        }, function (err) {
            __WEBPACK_IMPORTED_MODULE_6__log__["a" /* log */].debug('Got foreign method error', Object(__WEBPACK_IMPORTED_MODULE_4__util__["j" /* stringifyError */])(err));
            throw err;
        });
    }

    wrapper.__name__ = obj.__name__;
    wrapper.__xdomain__ = true;

    wrapper.source = source;
    wrapper.origin = origin;

    return wrapper;
}

function deserializeError(source, origin, obj) {
    return new Error(obj.__message__);
}

function deserializeZalgoPromise(source, origin, prom) {
    return new __WEBPACK_IMPORTED_MODULE_2_zalgo_promise_src__["a" /* ZalgoPromise */](function (resolve, reject) {
        return deserializeMethod(source, origin, prom.__then__)(resolve, reject);
    });
}

function deserializePromise(source, origin, prom) {
    if (!window.Promise) {
        return deserializeZalgoPromise(source, origin, prom);
    }

    return new window.Promise(function (resolve, reject) {
        return deserializeMethod(source, origin, prom.__then__)(resolve, reject);
    });
}

function deserializeRegex(source, origin, item) {
    return new RegExp(item.__source__);
}

function deserializeMethods(source, origin, obj) {

    return Object(__WEBPACK_IMPORTED_MODULE_4__util__["h" /* replaceObject */])({ obj: obj }, function (item, key) {
        if ((typeof item === 'undefined' ? 'undefined' : _typeof(item)) !== 'object' || item === null) {
            return;
        }

        if (isSerialized(item, __WEBPACK_IMPORTED_MODULE_3__conf__["b" /* CONSTANTS */].SERIALIZATION_TYPES.METHOD)) {
            return deserializeMethod(source, origin, item);
        }

        if (isSerialized(item, __WEBPACK_IMPORTED_MODULE_3__conf__["b" /* CONSTANTS */].SERIALIZATION_TYPES.ERROR)) {
            return deserializeError(source, origin, item);
        }

        if (isSerialized(item, __WEBPACK_IMPORTED_MODULE_3__conf__["b" /* CONSTANTS */].SERIALIZATION_TYPES.PROMISE)) {
            return deserializePromise(source, origin, item);
        }

        if (isSerialized(item, __WEBPACK_IMPORTED_MODULE_3__conf__["b" /* CONSTANTS */].SERIALIZATION_TYPES.ZALGO_PROMISE)) {
            return deserializeZalgoPromise(source, origin, item);
        }

        if (isSerialized(item, __WEBPACK_IMPORTED_MODULE_3__conf__["b" /* CONSTANTS */].SERIALIZATION_TYPES.REGEX)) {
            return deserializeRegex(source, origin, item);
        }
    }).obj;
}

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = initOnReady;
/* harmony export (immutable) */ __webpack_exports__["b"] = onWindowReady;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_cross_domain_safe_weakmap_src__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_cross_domain_utils_src__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_zalgo_promise_src__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__conf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__interface__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__log__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__global__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util__ = __webpack_require__(16);










__WEBPACK_IMPORTED_MODULE_6__global__["a" /* global */].readyPromises = __WEBPACK_IMPORTED_MODULE_6__global__["a" /* global */].readyPromises || new __WEBPACK_IMPORTED_MODULE_0_cross_domain_safe_weakmap_src__["a" /* WeakMap */]();

function initOnReady() {

    Object(__WEBPACK_IMPORTED_MODULE_4__interface__["on"])(__WEBPACK_IMPORTED_MODULE_3__conf__["b" /* CONSTANTS */].POST_MESSAGE_NAMES.READY, { domain: __WEBPACK_IMPORTED_MODULE_3__conf__["b" /* CONSTANTS */].WILDCARD }, function (event) {

        var win = event.source;
        var promise = __WEBPACK_IMPORTED_MODULE_6__global__["a" /* global */].readyPromises.get(win);

        if (promise) {
            promise.resolve(event);
        } else {
            promise = new __WEBPACK_IMPORTED_MODULE_2_zalgo_promise_src__["a" /* ZalgoPromise */]().resolve(event);
            __WEBPACK_IMPORTED_MODULE_6__global__["a" /* global */].readyPromises.set(win, promise);
        }
    });

    var parent = Object(__WEBPACK_IMPORTED_MODULE_1_cross_domain_utils_src__["d" /* getAncestor */])();

    if (parent) {
        Object(__WEBPACK_IMPORTED_MODULE_4__interface__["send"])(parent, __WEBPACK_IMPORTED_MODULE_3__conf__["b" /* CONSTANTS */].POST_MESSAGE_NAMES.READY, {}, { domain: __WEBPACK_IMPORTED_MODULE_3__conf__["b" /* CONSTANTS */].WILDCARD, timeout: Infinity })['catch'](function (err) {
            __WEBPACK_IMPORTED_MODULE_5__log__["a" /* log */].debug(Object(__WEBPACK_IMPORTED_MODULE_7__util__["j" /* stringifyError */])(err));
        });
    }
}

function onWindowReady(win) {
    var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5000;
    var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'Window';


    var promise = __WEBPACK_IMPORTED_MODULE_6__global__["a" /* global */].readyPromises.get(win);

    if (promise) {
        return promise;
    }

    promise = new __WEBPACK_IMPORTED_MODULE_2_zalgo_promise_src__["a" /* ZalgoPromise */]();
    __WEBPACK_IMPORTED_MODULE_6__global__["a" /* global */].readyPromises.set(win, promise);
    setTimeout(function () {
        return promise.reject(new Error(name + ' did not load after ' + timeout + 'ms'));
    }, timeout);

    return promise;
}

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export receiveMessage */
/* harmony export (immutable) */ __webpack_exports__["b"] = messageListener;
/* harmony export (immutable) */ __webpack_exports__["a"] = listenForMessages;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_cross_domain_utils_src__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__conf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__types__ = __webpack_require__(49);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };









__WEBPACK_IMPORTED_MODULE_3__global__["a" /* global */].receivedMessages = __WEBPACK_IMPORTED_MODULE_3__global__["a" /* global */].receivedMessages || [];

function parseMessage(message) {

    var parsedMessage = void 0;

    try {
        parsedMessage = Object(__WEBPACK_IMPORTED_MODULE_2__lib__["f" /* jsonParse */])(message);
    } catch (err) {
        return;
    }

    if (!parsedMessage) {
        return;
    }

    if ((typeof parsedMessage === 'undefined' ? 'undefined' : _typeof(parsedMessage)) !== 'object' || parsedMessage === null) {
        return;
    }

    parsedMessage = parsedMessage[__WEBPACK_IMPORTED_MODULE_1__conf__["b" /* CONSTANTS */].WINDOW_PROPS.POSTROBOT];

    if (!parsedMessage || (typeof parsedMessage === 'undefined' ? 'undefined' : _typeof(parsedMessage)) !== 'object' || parsedMessage === null) {
        return;
    }

    if (!parsedMessage.type || typeof parsedMessage.type !== 'string') {
        return;
    }

    if (!__WEBPACK_IMPORTED_MODULE_4__types__["a" /* RECEIVE_MESSAGE_TYPES */][parsedMessage.type]) {
        return;
    }

    return parsedMessage;
}

function receiveMessage(event) {

    if (!window || window.closed) {
        throw new Error('Message recieved in closed window');
    }

    try {
        if (!event.source) {
            return;
        }
    } catch (err) {
        return;
    }

    var source = event.source,
        origin = event.origin,
        data = event.data;


    var message = parseMessage(data);

    if (!message) {
        return;
    }

    if (!message.sourceDomain || typeof message.sourceDomain !== 'string') {
        throw new Error('Expected message to have sourceDomain');
    }

    if (message.sourceDomain.indexOf(__WEBPACK_IMPORTED_MODULE_1__conf__["b" /* CONSTANTS */].MOCK_PROTOCOL) === 0 || message.sourceDomain.indexOf(__WEBPACK_IMPORTED_MODULE_1__conf__["b" /* CONSTANTS */].FILE_PROTOCOL) === 0) {
        origin = message.sourceDomain;
    }

    if (__WEBPACK_IMPORTED_MODULE_3__global__["a" /* global */].receivedMessages.indexOf(message.id) === -1) {
        __WEBPACK_IMPORTED_MODULE_3__global__["a" /* global */].receivedMessages.push(message.id);
    } else {
        return;
    }

    var level = void 0;

    if (__WEBPACK_IMPORTED_MODULE_1__conf__["c" /* POST_MESSAGE_NAMES_LIST */].indexOf(message.name) !== -1 || message.type === __WEBPACK_IMPORTED_MODULE_1__conf__["b" /* CONSTANTS */].POST_MESSAGE_TYPE.ACK) {
        level = 'debug';
    } else if (message.ack === 'error') {
        level = 'error';
    } else {
        level = 'info';
    }

    __WEBPACK_IMPORTED_MODULE_2__lib__["i" /* log */].logLevel(level, ['\n\n\t', '#receive', message.type.replace(/^postrobot_message_/, ''), '::', message.name, '::', origin, '\n\n', message]);

    if (Object(__WEBPACK_IMPORTED_MODULE_0_cross_domain_utils_src__["t" /* isWindowClosed */])(source)) {
        __WEBPACK_IMPORTED_MODULE_2__lib__["i" /* log */].debug('Source window is closed - can not send ' + message.type + ' ' + message.name);
        return;
    }

    if (message.data) {
        message.data = Object(__WEBPACK_IMPORTED_MODULE_2__lib__["b" /* deserializeMethods */])(source, origin, message.data);
    }

    __WEBPACK_IMPORTED_MODULE_4__types__["a" /* RECEIVE_MESSAGE_TYPES */][message.type](source, origin, message);
}

function messageListener(event) {

    try {
        event.source; // eslint-disable-line
    } catch (err) {
        return;
    }

    // $FlowFixMe
    var messageEvent = {
        source: event.source || event.sourceElement,
        origin: event.origin || event.originalEvent && event.originalEvent.origin,
        data: event.data
    };

    if (false) {
        try {
            require('../../compat').emulateIERestrictions(messageEvent.source, window);
        } catch (err) {
            return;
        }
    }

    receiveMessage(messageEvent);
}

function listenForMessages() {
    Object(__WEBPACK_IMPORTED_MODULE_2__lib__["a" /* addEventListener */])(window, 'message', messageListener);
}

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RECEIVE_MESSAGE_TYPES; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_cross_domain_utils_src__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__conf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__send__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__listeners__ = __webpack_require__(30);
var _RECEIVE_MESSAGE_TYPE;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };










var RECEIVE_MESSAGE_TYPES = (_RECEIVE_MESSAGE_TYPE = {}, _RECEIVE_MESSAGE_TYPE[__WEBPACK_IMPORTED_MODULE_2__conf__["b" /* CONSTANTS */].POST_MESSAGE_TYPE.ACK] = function (source, origin, message) {

    if (Object(__WEBPACK_IMPORTED_MODULE_5__listeners__["f" /* isResponseListenerErrored */])(message.hash)) {
        return;
    }

    var options = Object(__WEBPACK_IMPORTED_MODULE_5__listeners__["e" /* getResponseListener */])(message.hash);

    if (!options) {
        throw new Error('No handler found for post message ack for message: ' + message.name + ' from ' + origin + ' in ' + window.location.protocol + '//' + window.location.host + window.location.pathname);
    }

    if (!Object(__WEBPACK_IMPORTED_MODULE_1_cross_domain_utils_src__["v" /* matchDomain */])(options.domain, origin)) {
        throw new Error('Ack origin ' + origin + ' does not match domain ' + options.domain.toString());
    }

    options.ack = true;
}, _RECEIVE_MESSAGE_TYPE[__WEBPACK_IMPORTED_MODULE_2__conf__["b" /* CONSTANTS */].POST_MESSAGE_TYPE.REQUEST] = function (source, origin, message) {

    var options = Object(__WEBPACK_IMPORTED_MODULE_5__listeners__["d" /* getRequestListener */])({ name: message.name, win: source, domain: origin });

    function respond(data) {

        if (message.fireAndForget || Object(__WEBPACK_IMPORTED_MODULE_1_cross_domain_utils_src__["t" /* isWindowClosed */])(source)) {
            return __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__["a" /* ZalgoPromise */].resolve();
        }

        return Object(__WEBPACK_IMPORTED_MODULE_4__send__["a" /* sendMessage */])(source, _extends({
            target: message.originalSource,
            hash: message.hash,
            name: message.name
        }, data), origin);
    }

    return __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__["a" /* ZalgoPromise */].all([respond({
        type: __WEBPACK_IMPORTED_MODULE_2__conf__["b" /* CONSTANTS */].POST_MESSAGE_TYPE.ACK
    }), __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](function () {

        if (!options) {
            throw new Error('No handler found for post message: ' + message.name + ' from ' + origin + ' in ' + window.location.protocol + '//' + window.location.host + window.location.pathname);
        }

        if (!Object(__WEBPACK_IMPORTED_MODULE_1_cross_domain_utils_src__["v" /* matchDomain */])(options.domain, origin)) {
            throw new Error('Request origin ' + origin + ' does not match domain ' + options.domain.toString());
        }

        var data = message.data;

        return options.handler({ source: source, origin: origin, data: data });
    }).then(function (data) {

        return respond({
            type: __WEBPACK_IMPORTED_MODULE_2__conf__["b" /* CONSTANTS */].POST_MESSAGE_TYPE.RESPONSE,
            ack: __WEBPACK_IMPORTED_MODULE_2__conf__["b" /* CONSTANTS */].POST_MESSAGE_ACK.SUCCESS,
            data: data
        });
    }, function (err) {

        var error = Object(__WEBPACK_IMPORTED_MODULE_3__lib__["o" /* stringifyError */])(err).replace(/^Error: /, '');

        return respond({
            type: __WEBPACK_IMPORTED_MODULE_2__conf__["b" /* CONSTANTS */].POST_MESSAGE_TYPE.RESPONSE,
            ack: __WEBPACK_IMPORTED_MODULE_2__conf__["b" /* CONSTANTS */].POST_MESSAGE_ACK.ERROR,
            error: error
        });
    })]).then(__WEBPACK_IMPORTED_MODULE_3__lib__["j" /* noop */])['catch'](function (err) {

        if (options && options.handleError) {
            return options.handleError(err);
        } else {
            __WEBPACK_IMPORTED_MODULE_3__lib__["i" /* log */].error(Object(__WEBPACK_IMPORTED_MODULE_3__lib__["o" /* stringifyError */])(err));
        }
    });
}, _RECEIVE_MESSAGE_TYPE[__WEBPACK_IMPORTED_MODULE_2__conf__["b" /* CONSTANTS */].POST_MESSAGE_TYPE.RESPONSE] = function (source, origin, message) {

    if (Object(__WEBPACK_IMPORTED_MODULE_5__listeners__["f" /* isResponseListenerErrored */])(message.hash)) {
        return;
    }

    var options = Object(__WEBPACK_IMPORTED_MODULE_5__listeners__["e" /* getResponseListener */])(message.hash);

    if (!options) {
        throw new Error('No handler found for post message response for message: ' + message.name + ' from ' + origin + ' in ' + window.location.protocol + '//' + window.location.host + window.location.pathname);
    }

    if (!Object(__WEBPACK_IMPORTED_MODULE_1_cross_domain_utils_src__["v" /* matchDomain */])(options.domain, origin)) {
        throw new Error('Response origin ' + origin + ' does not match domain ' + options.domain);
    }

    Object(__WEBPACK_IMPORTED_MODULE_5__listeners__["c" /* deleteResponseListener */])(message.hash);

    if (message.ack === __WEBPACK_IMPORTED_MODULE_2__conf__["b" /* CONSTANTS */].POST_MESSAGE_ACK.ERROR) {
        return options.respond(new Error(message.error), null);
    } else if (message.ack === __WEBPACK_IMPORTED_MODULE_2__conf__["b" /* CONSTANTS */].POST_MESSAGE_ACK.SUCCESS) {
        var data = message.data || message.response;

        return options.respond(null, { source: source, origin: origin, data: data });
    }
}, _RECEIVE_MESSAGE_TYPE);

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SEND_MESSAGE_STRATEGIES; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_cross_domain_utils_src__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__conf__ = __webpack_require__(4);




var SEND_MESSAGE_STRATEGIES = {};

SEND_MESSAGE_STRATEGIES[__WEBPACK_IMPORTED_MODULE_1__conf__["b" /* CONSTANTS */].SEND_STRATEGIES.POST_MESSAGE] = function (win, serializedMessage, domain) {

    if (false) {
        try {
            require('../../compat').emulateIERestrictions(window, win);
        } catch (err) {
            return;
        }
    }

    var domains = void 0;

    if (Array.isArray(domain)) {
        domains = domain;
    } else if (domain) {
        domains = [domain];
    } else {
        domains = [__WEBPACK_IMPORTED_MODULE_1__conf__["b" /* CONSTANTS */].WILDCARD];
    }

    domains = domains.map(function (dom) {

        if (dom.indexOf(__WEBPACK_IMPORTED_MODULE_1__conf__["b" /* CONSTANTS */].MOCK_PROTOCOL) === 0) {

            if (window.location.protocol === __WEBPACK_IMPORTED_MODULE_1__conf__["b" /* CONSTANTS */].FILE_PROTOCOL) {
                return __WEBPACK_IMPORTED_MODULE_1__conf__["b" /* CONSTANTS */].WILDCARD;
            }

            if (!Object(__WEBPACK_IMPORTED_MODULE_0_cross_domain_utils_src__["l" /* isActuallySameDomain */])(win)) {
                throw new Error('Attempting to send messsage to mock domain ' + dom + ', but window is actually cross-domain');
            }

            // $FlowFixMe
            return Object(__WEBPACK_IMPORTED_MODULE_0_cross_domain_utils_src__["b" /* getActualDomain */])(win);
        }

        if (dom.indexOf(__WEBPACK_IMPORTED_MODULE_1__conf__["b" /* CONSTANTS */].FILE_PROTOCOL) === 0) {
            return __WEBPACK_IMPORTED_MODULE_1__conf__["b" /* CONSTANTS */].WILDCARD;
        }

        return dom;
    });

    domains.forEach(function (dom) {
        return win.postMessage(serializedMessage, dom);
    });
};

if (false) {
    var _require = require('../../bridge'),
        sendBridgeMessage = _require.sendBridgeMessage,
        needsBridgeForBrowser = _require.needsBridgeForBrowser,
        isBridge = _require.isBridge;

    SEND_MESSAGE_STRATEGIES[CONSTANTS.SEND_STRATEGIES.BRIDGE] = function (win, serializedMessage, domain) {

        if (!needsBridgeForBrowser() && !isBridge()) {
            return;
        }

        if (isSameDomain(win)) {
            throw new Error('Post message through bridge disabled between same domain windows');
        }

        if (isSameTopWindow(window, win) !== false) {
            throw new Error('Can only use bridge to communicate between two different windows, not between frames');
        }

        return sendBridgeMessage(win, serializedMessage, domain);
    };

    SEND_MESSAGE_STRATEGIES[CONSTANTS.SEND_STRATEGIES.GLOBAL] = function (win, serializedMessage, domain) {

        if (!needsBridgeForBrowser()) {
            return;
        }

        if (!isSameDomain(win)) {
            throw new Error('Post message through global disabled between different domain windows');
        }

        if (isSameTopWindow(window, win) !== false) {
            throw new Error('Can only use global to communicate between two different windows, not between frames');
        }

        // $FlowFixMe
        var foreignGlobal = win[CONSTANTS.WINDOW_PROPS.POSTROBOT];

        if (!foreignGlobal) {
            throw new Error('Can not find postRobot global on foreign window');
        }

        return foreignGlobal.receiveMessage({
            source: window,
            origin: getDomain(),
            data: serializedMessage
        });
    };
}

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = cleanUpWindow;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__global__ = __webpack_require__(9);


function cleanUpWindow(win) {

    // global.tunnelWindows
    // global.bridges
    // global.popupWindowsByName
    // global.responseListeners
    // global.requestListeners

    var requestPromises = __WEBPACK_IMPORTED_MODULE_0__global__["a" /* global */].requestPromises.get(win);

    if (requestPromises) {
        for (var _iterator = requestPromises, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
            var _ref;

            if (_isArray) {
                if (_i >= _iterator.length) break;
                _ref = _iterator[_i++];
            } else {
                _i = _iterator.next();
                if (_i.done) break;
                _ref = _i.value;
            }

            var promise = _ref;

            promise.reject(new Error('No response from window - cleaned up'));
        }
    }

    if (__WEBPACK_IMPORTED_MODULE_0__global__["a" /* global */].popupWindowsByWin) {
        __WEBPACK_IMPORTED_MODULE_0__global__["a" /* global */].popupWindowsByWin['delete'](win);
    }

    if (__WEBPACK_IMPORTED_MODULE_0__global__["a" /* global */].remoteWindows) {
        __WEBPACK_IMPORTED_MODULE_0__global__["a" /* global */].remoteWindows['delete'](win);
    }

    __WEBPACK_IMPORTED_MODULE_0__global__["a" /* global */].requestPromises['delete'](win);
    __WEBPACK_IMPORTED_MODULE_0__global__["a" /* global */].methods['delete'](win);
    __WEBPACK_IMPORTED_MODULE_0__global__["a" /* global */].readyPromises['delete'](win);
}

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return parent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_cross_domain_utils_src__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__client__ = __webpack_require__(53);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__client__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_1__client__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_1__client__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_1__client__["d"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__server__ = __webpack_require__(54);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_2__server__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_2__server__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_2__server__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_2__server__["d"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(55);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__config__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__config__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__config__["c"]; });






var parent = Object(__WEBPACK_IMPORTED_MODULE_0_cross_domain_utils_src__["d" /* getAncestor */])();

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return _send; });
/* harmony export (immutable) */ __webpack_exports__["b"] = request;
/* harmony export (immutable) */ __webpack_exports__["d"] = sendToParent;
/* harmony export (immutable) */ __webpack_exports__["a"] = client;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_cross_domain_safe_weakmap_src__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__conf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__drivers__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__global__ = __webpack_require__(9);











__WEBPACK_IMPORTED_MODULE_6__global__["a" /* global */].requestPromises = __WEBPACK_IMPORTED_MODULE_6__global__["a" /* global */].requestPromises || new __WEBPACK_IMPORTED_MODULE_0_cross_domain_safe_weakmap_src__["a" /* WeakMap */]();

function request(options) {

    var prom = __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](function () {

        if (!options.name) {
            throw new Error('Expected options.name');
        }

        var name = options.name;
        var targetWindow = void 0;
        var domain = void 0;

        if (typeof options.window === 'string') {
            var el = document.getElementById(options.window);

            if (!el) {
                throw new Error('Expected options.window ' + Object.prototype.toString.call(options.window) + ' to be a valid element id');
            }

            if (el.tagName.toLowerCase() !== 'iframe') {
                throw new Error('Expected options.window ' + Object.prototype.toString.call(options.window) + ' to be an iframe');
            }

            if (!el.contentWindow) {
                throw new Error('Iframe must have contentWindow.  Make sure it has a src attribute and is in the DOM.');
            }

            // $FlowFixMe
            targetWindow = el.contentWindow;
        } else if (options.window instanceof HTMLIFrameElement) {

            if (options.window.tagName.toLowerCase() !== 'iframe') {
                throw new Error('Expected options.window ' + Object.prototype.toString.call(options.window) + ' to be an iframe');
            }

            if (options.window && !options.window.contentWindow) {
                throw new Error('Iframe must have contentWindow.  Make sure it has a src attribute and is in the DOM.');
            }

            if (options.window && options.window.contentWindow) {
                // $FlowFixMe
                targetWindow = options.window.contentWindow;
            }
        } else {
            targetWindow = options.window;
        }

        if (!targetWindow) {
            throw new Error('Expected options.window to be a window object, iframe, or iframe element id.');
        }

        var win = targetWindow;

        domain = options.domain || __WEBPACK_IMPORTED_MODULE_3__conf__["b" /* CONSTANTS */].WILDCARD;

        var hash = options.name + '_' + Object(__WEBPACK_IMPORTED_MODULE_5__lib__["p" /* uniqueID */])();

        if (Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__["t" /* isWindowClosed */])(win)) {
            throw new Error('Target window is closed');
        }

        var hasResult = false;

        var requestPromises = __WEBPACK_IMPORTED_MODULE_6__global__["a" /* global */].requestPromises.get(win);

        if (!requestPromises) {
            requestPromises = [];
            __WEBPACK_IMPORTED_MODULE_6__global__["a" /* global */].requestPromises.set(win, requestPromises);
        }

        var requestPromise = __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](function () {

            if (Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__["m" /* isAncestor */])(window, win)) {
                return __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__["a" /* ZalgoPromise */].resolve(Object(__WEBPACK_IMPORTED_MODULE_5__lib__["k" /* onWindowReady */])(win));
            }
        }).then(function () {

            return new __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__["a" /* ZalgoPromise */](function (resolve, reject) {

                var responseListener = void 0;

                if (!options.fireAndForget) {
                    responseListener = {
                        name: name,
                        window: win,
                        domain: domain,
                        respond: function respond(err, result) {
                            if (!err) {
                                hasResult = true;
                                requestPromises.splice(requestPromises.indexOf(requestPromise, 1));
                            }

                            if (err) {
                                reject(err);
                            } else {
                                resolve(result);
                            }
                        }
                    };

                    Object(__WEBPACK_IMPORTED_MODULE_4__drivers__["b" /* addResponseListener */])(hash, responseListener);
                }

                Object(__WEBPACK_IMPORTED_MODULE_4__drivers__["g" /* sendMessage */])(win, {
                    type: __WEBPACK_IMPORTED_MODULE_3__conf__["b" /* CONSTANTS */].POST_MESSAGE_TYPE.REQUEST,
                    hash: hash,
                    name: name,
                    data: options.data,
                    fireAndForget: options.fireAndForget
                }, domain)['catch'](reject);

                if (options.fireAndForget) {
                    return resolve();
                }

                var ackTimeout = __WEBPACK_IMPORTED_MODULE_3__conf__["a" /* CONFIG */].ACK_TIMEOUT;
                var resTimeout = options.timeout || __WEBPACK_IMPORTED_MODULE_3__conf__["a" /* CONFIG */].RES_TIMEOUT;

                var cycleTime = 100;

                var cycle = function cycle() {

                    if (hasResult) {
                        return;
                    }

                    if (Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__["t" /* isWindowClosed */])(win)) {

                        if (!responseListener.ack) {
                            return reject(new Error('Window closed for ' + name + ' before ack'));
                        }

                        return reject(new Error('Window closed for ' + name + ' before response'));
                    }

                    ackTimeout -= cycleTime;
                    resTimeout -= cycleTime;

                    var hasAck = responseListener.ack;

                    if (hasAck) {

                        if (resTimeout === Infinity) {
                            return;
                        }

                        cycleTime = Math.min(resTimeout, 2000);
                    } else if (ackTimeout <= 0) {
                        return reject(new Error('No ack for postMessage ' + name + ' in ' + __WEBPACK_IMPORTED_MODULE_3__conf__["a" /* CONFIG */].ACK_TIMEOUT + 'ms'));
                    } else if (resTimeout <= 0) {
                        return reject(new Error('No response for postMessage ' + name + ' in ' + (options.timeout || __WEBPACK_IMPORTED_MODULE_3__conf__["a" /* CONFIG */].RES_TIMEOUT) + 'ms'));
                    }

                    setTimeout(cycle, cycleTime);
                };

                setTimeout(cycle, cycleTime);
            });
        });

        requestPromise['catch'](function () {
            Object(__WEBPACK_IMPORTED_MODULE_4__drivers__["e" /* markResponseListenerErrored */])(hash);
            Object(__WEBPACK_IMPORTED_MODULE_4__drivers__["c" /* deleteResponseListener */])(hash);
        });

        requestPromises.push(requestPromise);

        return requestPromise;
    });

    return prom;
}

function _send(window, name, data, options) {

    options = options || {};
    options.window = window;
    options.name = name;
    options.data = data;

    return request(options);
}

function sendToParent(name, data, options) {

    var win = Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__["d" /* getAncestor */])();

    if (!win) {
        return new __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__["a" /* ZalgoPromise */](function (resolve, reject) {
            return reject(new Error('Window does not have a parent'));
        });
    }

    return _send(win, name, data, options);
}

function client() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};


    if (!options.window) {
        throw new Error('Expected options.window');
    }

    var win = options.window;

    return {
        send: function send(name, data) {
            return _send(win, name, data, options);
        }
    };
}

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return _on; });
/* harmony export (immutable) */ __webpack_exports__["a"] = listen;
/* harmony export (immutable) */ __webpack_exports__["d"] = once;
/* harmony export (immutable) */ __webpack_exports__["b"] = listener;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_cross_domain_utils_src__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__drivers__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__conf__ = __webpack_require__(4);


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };









function listen(options) {

    if (!options.name) {
        throw new Error('Expected options.name');
    }

    if (!options.handler) {
        throw new Error('Expected options.handler');
    }

    var name = options.name;
    var win = options.window;
    var domain = options.domain;

    var listenerOptions = {
        handler: options.handler,
        handleError: options.errorHandler || function (err) {
            throw err;
        },
        window: win,
        domain: domain || __WEBPACK_IMPORTED_MODULE_4__conf__["b" /* CONSTANTS */].WILDCARD,
        name: name
    };

    var requestListener = Object(__WEBPACK_IMPORTED_MODULE_3__drivers__["a" /* addRequestListener */])({ name: name, win: win, domain: domain }, listenerOptions);

    if (options.once) {
        var _handler = listenerOptions.handler;
        listenerOptions.handler = Object(__WEBPACK_IMPORTED_MODULE_2__lib__["l" /* once */])(function () {
            requestListener.cancel();
            return _handler.apply(this, arguments);
        });
    }

    if (listenerOptions.window && options.errorOnClose) {
        var interval = Object(__WEBPACK_IMPORTED_MODULE_2__lib__["m" /* safeInterval */])(function () {
            if (win && (typeof win === 'undefined' ? 'undefined' : _typeof(win)) === 'object' && Object(__WEBPACK_IMPORTED_MODULE_0_cross_domain_utils_src__["t" /* isWindowClosed */])(win)) {
                interval.cancel();
                listenerOptions.handleError(new Error('Post message target window is closed'));
            }
        }, 50);
    }

    return {
        cancel: function cancel() {
            requestListener.cancel();
        }
    };
}

function _on(name, options, handler) {

    if (typeof options === 'function') {
        handler = options;
        options = {};
    }

    options = options || {};

    options.name = name;
    options.handler = handler || options.handler;

    return listen(options);
}

function once(name) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var handler = arguments[2];


    if (typeof options === 'function') {
        handler = options;
        options = {};
    }

    options = options || {};
    handler = handler || options.handler;
    var errorHandler = options.errorHandler;

    var promise = new __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__["a" /* ZalgoPromise */](function (resolve, reject) {

        options = options || {};

        options.name = name;
        options.once = true;

        options.handler = function (event) {
            resolve(event);
            if (handler) {
                return handler(event);
            }
        };

        options.errorHandler = function (err) {
            reject(err);
            if (errorHandler) {
                return errorHandler(err);
            }
        };
    });

    var onceListener = listen(options);
    promise.cancel = onceListener.cancel;

    return promise;
}

function listener() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};


    return {
        on: function on(name, handler) {
            return _on(name, options, handler);
        }
    };
}

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = disable;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__conf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__drivers__ = __webpack_require__(11);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__conf__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__conf__["b"]; });





function disable() {
    delete window[__WEBPACK_IMPORTED_MODULE_0__conf__["b" /* CONSTANTS */].WINDOW_PROPS.POSTROBOT];
    window.removeEventListener('message', __WEBPACK_IMPORTED_MODULE_1__drivers__["f" /* messageListener */]);
}

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = appendChild;
/* unused harmony export querySelectorAll */
/* unused harmony export getElementSafe */
/* harmony export (immutable) */ __webpack_exports__["n"] = getElement;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return documentReady; });
/* unused harmony export isDocumentReady */
/* harmony export (immutable) */ __webpack_exports__["j"] = elementReady;
/* unused harmony export popup */
/* harmony export (immutable) */ __webpack_exports__["A"] = writeToWindow;
/* harmony export (immutable) */ __webpack_exports__["z"] = writeElementToWindow;
/* unused harmony export setStyle */
/* unused harmony export createElement */
/* harmony export (immutable) */ __webpack_exports__["e"] = awaitFrameLoad;
/* harmony export (immutable) */ __webpack_exports__["f"] = awaitFrameWindow;
/* harmony export (immutable) */ __webpack_exports__["p"] = iframe;
/* harmony export (immutable) */ __webpack_exports__["b"] = addEventListener;
/* unused harmony export scanForJavascript */
/* unused harmony export parseQuery */
/* unused harmony export getQueryParam */
/* unused harmony export formatQuery */
/* unused harmony export extendQuery */
/* harmony export (immutable) */ __webpack_exports__["l"] = extendUrl;
/* harmony export (immutable) */ __webpack_exports__["k"] = elementStoppedMoving;
/* unused harmony export getCurrentDimensions */
/* unused harmony export changeStyle */
/* harmony export (immutable) */ __webpack_exports__["u"] = setOverflow;
/* harmony export (immutable) */ __webpack_exports__["x"] = trackDimensions;
/* harmony export (immutable) */ __webpack_exports__["r"] = onDimensionsChange;
/* harmony export (immutable) */ __webpack_exports__["h"] = dimensionsMatchViewport;
/* unused harmony export bindEvents */
/* unused harmony export setVendorCSS */
/* unused harmony export animate */
/* unused harmony export makeElementVisible */
/* unused harmony export makeElementInvisible */
/* harmony export (immutable) */ __webpack_exports__["w"] = showElement;
/* harmony export (immutable) */ __webpack_exports__["o"] = hideElement;
/* harmony export (immutable) */ __webpack_exports__["g"] = destroyElement;
/* harmony export (immutable) */ __webpack_exports__["v"] = showAndAnimate;
/* harmony export (immutable) */ __webpack_exports__["c"] = animateAndHide;
/* harmony export (immutable) */ __webpack_exports__["a"] = addClass;
/* harmony export (immutable) */ __webpack_exports__["t"] = removeClass;
/* harmony export (immutable) */ __webpack_exports__["m"] = getCurrentScriptDir;
/* unused harmony export getElementName */
/* unused harmony export isElementClosed */
/* harmony export (immutable) */ __webpack_exports__["y"] = watchElementForClose;
/* unused harmony export getHttpType */
/* unused harmony export getHTML */
/* unused harmony export getCSS */
/* unused harmony export getScript */
/* harmony export (immutable) */ __webpack_exports__["s"] = prefetchPage;
/* unused harmony export fixScripts */
/* harmony export (immutable) */ __webpack_exports__["q"] = jsxDom;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_cross_domain_utils_src__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_cross_domain_safe_weakmap_src__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fn__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__error__ = __webpack_require__(13);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };









function appendChild(container, child) {
    container.appendChild(child);
}

function isElement(element) {

    if (element instanceof window.Element) {
        return true;
    }

    if (element !== null && (typeof element === 'undefined' ? 'undefined' : _typeof(element)) === 'object' && element.nodeType === 1 && _typeof(element.style) === 'object' && _typeof(element.ownerDocument) === 'object') {
        return true;
    }

    return false;
}

function querySelectorAll(el, selector) {
    return Array.prototype.slice.call(el.querySelectorAll(selector));
}

/*  Get Element
    -----------

    Gets an element based on

    - Element id
    - CSS Query selector
*/

function getElementSafe(id) {

    if (isElement(id)) {
        // $FlowFixMe
        return id;
    }

    if (typeof id === 'string') {
        var element = document.getElementById(id);

        if (element) {
            return element;
        }

        if (document.querySelector) {
            element = document.querySelector(id);
        }

        if (element) {
            return element;
        }
    }
}

function getElement(id) {

    var element = getElementSafe(id);

    if (element) {
        return element;
    }

    throw new Error('Can not find element: ' + Object(__WEBPACK_IMPORTED_MODULE_4__util__["k" /* stringify */])(id));
}

var documentReady = new __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__["a" /* ZalgoPromise */](function (resolve) {

    if (window.document.readyState === 'complete') {
        return resolve(window.document);
    }

    var interval = setInterval(function () {
        if (window.document.readyState === 'complete') {
            clearInterval(interval);
            return resolve(window.document);
        }
    }, 10);
});

function isDocumentReady() {
    return window.document.readyState === 'complete';
}

function elementReady(id) {
    return new __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__["a" /* ZalgoPromise */](function (resolve, reject) {

        var name = Object(__WEBPACK_IMPORTED_MODULE_4__util__["k" /* stringify */])(id);
        var el = getElementSafe(id);

        if (el) {
            return resolve(el);
        }

        if (isDocumentReady()) {
            return reject(new Error('Document is ready and element ' + name + ' does not exist'));
        }

        var interval = setInterval(function () {

            el = getElementSafe(id);

            if (el) {
                clearInterval(interval);
                return resolve(el);
            }

            if (isDocumentReady()) {
                clearInterval(interval);
                return reject(new Error('Document is ready and element ' + name + ' does not exist'));
            }
        }, 10);
    });
}

/*  Popup
    -----

    Open a popup window with the specified option map
*/

function popup(url, options) {

    var params = Object.keys(options).map(function (key) {
        if (options[key]) {
            return key + '=' + Object(__WEBPACK_IMPORTED_MODULE_4__util__["k" /* stringify */])(options[key]);
        }
    }).filter(Boolean).join(',');

    var win = void 0;

    try {
        win = window.open(url, options.name, params, true);
    } catch (err) {
        throw new __WEBPACK_IMPORTED_MODULE_5__error__["b" /* PopupOpenError */]('Can not open popup window - ' + (err.stack || err.message));
    }

    if (Object(__WEBPACK_IMPORTED_MODULE_0_cross_domain_utils_src__["t" /* isWindowClosed */])(win)) {
        var err = new __WEBPACK_IMPORTED_MODULE_5__error__["b" /* PopupOpenError */]('Can not open popup window - blocked');
        throw err;
    }

    return win;
}

function writeToWindow(win, html) {
    try {
        win.document.open();
        win.document.write(html);
        win.document.close();
    } catch (err) {
        try {
            win.location = 'javascript: document.open(); document.write(' + JSON.stringify(html) + '); document.close();';
        } catch (err2) {
            // pass
        }
    }
}

function writeElementToWindow(win, el) {

    var tag = el.tagName.toLowerCase();

    if (tag !== 'html') {
        throw new Error('Expected element to be html, got ' + tag);
    }

    var documentElement = win.document.documentElement;

    while (documentElement.children && documentElement.children.length) {
        documentElement.removeChild(documentElement.children[0]);
    }

    while (el.children.length) {
        documentElement.appendChild(el.children[0]);
    }
}

function setStyle(el, styleText) {
    var doc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : window.document;

    if (el.styleSheet) {
        // $FlowFixMe
        el.styleSheet.cssText = styleText;
    } else {
        el.appendChild(doc.createTextNode(styleText));
    }
}

/*  Create Element
    --------------

    Create an element with style, html, classes, attributes etc. and append it to the specified container
*/

function createElement() {
    var tag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'div';
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var container = arguments[2];


    tag = tag.toLowerCase();
    var element = document.createElement(tag);

    if (options.style) {
        Object(__WEBPACK_IMPORTED_MODULE_4__util__["f" /* extend */])(element.style, options.style);
    }

    if (options['class']) {
        element.className = options['class'].join(' ');
    }

    if (options.attributes) {
        for (var _iterator = Object.keys(options.attributes), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
            var _ref;

            if (_isArray) {
                if (_i >= _iterator.length) break;
                _ref = _iterator[_i++];
            } else {
                _i = _iterator.next();
                if (_i.done) break;
                _ref = _i.value;
            }

            var key = _ref;

            element.setAttribute(key, options.attributes[key]);
        }
    }

    if (options.styleSheet) {
        setStyle(element, options.styleSheet);
    }

    if (container) {
        appendChild(container, element);
    }

    if (options.html) {
        if (tag === 'iframe') {
            if (!container || !element.contentWindow) {
                throw new Error('Iframe html can not be written unless container provided and iframe in DOM');
            }

            // $FlowFixMe
            writeToWindow(element.contentWindow, options.html);
        } else {
            element.innerHTML = options.html;
        }
    }

    return element;
}

var awaitFrameLoadPromises = new __WEBPACK_IMPORTED_MODULE_2_cross_domain_safe_weakmap_src__["a" /* WeakMap */]();

function awaitFrameLoad(frame) {

    if (awaitFrameLoadPromises.has(frame)) {
        var _promise = awaitFrameLoadPromises.get(frame);
        if (_promise) {
            return _promise;
        }
    }

    var promise = new __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__["a" /* ZalgoPromise */](function (resolve, reject) {
        frame.addEventListener('load', function () {
            Object(__WEBPACK_IMPORTED_MODULE_0_cross_domain_utils_src__["u" /* linkFrameWindow */])(frame);
            resolve(frame);
        });

        frame.addEventListener('error', function (err) {
            if (frame.contentWindow) {
                resolve(frame);
            } else {
                reject(err);
            }
        });
    });

    awaitFrameLoadPromises.set(frame, promise);

    return promise;
}

function awaitFrameWindow(frame) {

    if (frame.contentWindow) {
        return __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__["a" /* ZalgoPromise */].resolve(frame.contentWindow);
    }

    return awaitFrameLoad(frame).then(function (loadedFrame) {

        if (!loadedFrame.contentWindow) {
            throw new Error('Could not find window in iframe');
        }

        return loadedFrame.contentWindow;
    });
}

/*  Iframe
    ------

    Open an iframe with the specified container, url, and option property map
*/

function iframe() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var container = arguments[1];


    var el = getElement(container);

    var attributes = options.attributes || {};
    var style = options.style || {};

    var frame = createElement('iframe', {
        attributes: _extends({
            frameBorder: '0',
            allowTransparency: 'true'
        }, attributes),
        style: _extends({
            backgroundColor: 'transparent'
        }, style),
        html: options.html,
        'class': options['class']
    });

    // $FlowFixMe
    awaitFrameLoad(frame);

    el.appendChild(frame);

    if (options.url || window.navigator.userAgent.match(/MSIE|Edge/i)) {
        frame.setAttribute('src', options.url || 'about:blank');
    }

    // $FlowFixMe
    return frame;
}

/*  Add Event Listener
    ------------------

    Add DOM Event listener with cancel
*/

function addEventListener(obj, event, handler) {
    obj.addEventListener(event, handler);
    return {
        cancel: function cancel() {
            obj.removeEventListener(event, handler);
        }
    };
}

/*  Scan For Javascript
    -------------------

    Check if the string contains anything which could conceivably be run as javascript if the string is set to innerHTML
*/

function scanForJavascript(str) {

    if (!str) {
        return str;
    }

    if (str.match(/<script|on\w+\s*=|javascript:|expression\s*\(|eval\(|new\s*Function/)) {
        throw new Error('HTML contains potential javascript: ' + str);
    }

    return str;
}

var parseQuery = Object(__WEBPACK_IMPORTED_MODULE_3__fn__["c" /* memoize */])(function (queryString) {

    var params = {};

    if (!queryString) {
        return params;
    }

    if (queryString.indexOf('=') === -1) {
        throw new Error('Can not parse query string params: ' + queryString);
    }

    for (var _iterator2 = queryString.split('&'), _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
        var _ref2;

        if (_isArray2) {
            if (_i2 >= _iterator2.length) break;
            _ref2 = _iterator2[_i2++];
        } else {
            _i2 = _iterator2.next();
            if (_i2.done) break;
            _ref2 = _i2.value;
        }

        var pair = _ref2;

        pair = pair.split('=');

        if (pair[0] && pair[1]) {
            params[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
        }
    }

    return params;
});

function getQueryParam(name) {
    return parseQuery(window.location.search.slice(1))[name];
}

function formatQuery() {
    var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};


    return Object.keys(obj).filter(function (key) {
        return typeof obj[key] === 'string';
    }).map(function (key) {
        return Object(__WEBPACK_IMPORTED_MODULE_4__util__["n" /* urlEncode */])(key) + '=' + Object(__WEBPACK_IMPORTED_MODULE_4__util__["n" /* urlEncode */])(obj[key]);
    }).join('&');
}

function extendQuery(originalQuery) {
    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};


    if (!props || !Object.keys(props).length) {
        return originalQuery;
    }

    return formatQuery(_extends({}, parseQuery(originalQuery), props));
}

function extendUrl(url) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};


    var query = options.query || {};
    var hash = options.hash || {};

    var originalUrl = void 0;
    var originalQuery = void 0;
    var originalHash = void 0;

    var _url$split = url.split('#');

    originalUrl = _url$split[0];
    originalHash = _url$split[1];

    var _originalUrl$split = originalUrl.split('?');

    originalUrl = _originalUrl$split[0];
    originalQuery = _originalUrl$split[1];


    var queryString = extendQuery(originalQuery, query);
    var hashString = extendQuery(originalHash, hash);

    if (queryString) {
        originalUrl = originalUrl + '?' + queryString;
    }

    if (hashString) {
        originalUrl = originalUrl + '#' + hashString;
    }

    return originalUrl;
}

function elementStoppedMoving(element) {
    var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5000;

    return new __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__["a" /* ZalgoPromise */](function (resolve, reject) {
        var el = getElement(element);

        var start = el.getBoundingClientRect();

        var interval = void 0;
        var timer = void 0;

        interval = setInterval(function () {
            var end = el.getBoundingClientRect();

            if (start.top === end.top && start.bottom === end.bottom && start.left === end.left && start.right === end.right && start.width === end.width && start.height === end.height) {
                clearTimeout(timer);
                clearInterval(interval);
                return resolve();
            }

            start = end;
        }, 50);

        timer = setTimeout(function () {
            clearInterval(interval);
            reject(new Error('Timed out waiting for element to stop animating after ' + timeout + 'ms'));
        }, timeout);
    });
}

function getCurrentDimensions(el) {
    return {
        width: el.offsetWidth,
        height: el.offsetHeight
    };
}

function changeStyle(el, styles) {
    return new __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__["a" /* ZalgoPromise */](function (resolve) {

        for (var _iterator3 = Object.keys(styles), _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
            var _ref3;

            if (_isArray3) {
                if (_i3 >= _iterator3.length) break;
                _ref3 = _iterator3[_i3++];
            } else {
                _i3 = _iterator3.next();
                if (_i3.done) break;
                _ref3 = _i3.value;
            }

            var key = _ref3;

            // $FlowFixMe
            el.style[key] = styles[key];
        }

        setTimeout(resolve, 1);
    });
}

function setOverflow(el) {
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'auto';
    var _el$style = el.style,
        overflow = _el$style.overflow,
        overflowX = _el$style.overflowX,
        overflowY = _el$style.overflowY;


    el.style.overflow = el.style.overflowX = el.style.overflowY = value;

    return {
        reset: function reset() {
            el.style.overflow = overflow;
            el.style.overflowX = overflowX;
            el.style.overflowY = overflowY;
        }
    };
}

function dimensionsDiff(one, two, _ref4) {
    var _ref4$width = _ref4.width,
        width = _ref4$width === undefined ? true : _ref4$width,
        _ref4$height = _ref4.height,
        height = _ref4$height === undefined ? true : _ref4$height,
        _ref4$threshold = _ref4.threshold,
        threshold = _ref4$threshold === undefined ? 0 : _ref4$threshold;


    if (width && Math.abs(one.width - two.width) > threshold) {
        return true;
    }

    if (height && Math.abs(one.height - two.height) > threshold) {
        return true;
    }

    return false;
}

function trackDimensions(el, _ref5) {
    var _ref5$width = _ref5.width,
        width = _ref5$width === undefined ? true : _ref5$width,
        _ref5$height = _ref5.height,
        height = _ref5$height === undefined ? true : _ref5$height,
        _ref5$threshold = _ref5.threshold,
        threshold = _ref5$threshold === undefined ? 0 : _ref5$threshold;


    var currentDimensions = getCurrentDimensions(el);

    return {
        check: function check() {
            var newDimensions = getCurrentDimensions(el);

            return {
                changed: dimensionsDiff(currentDimensions, newDimensions, { width: width, height: height, threshold: threshold }),
                dimensions: newDimensions
            };
        },
        reset: function reset() {
            currentDimensions = getCurrentDimensions(el);
        }
    };
}

function onDimensionsChange(el, _ref6) {
    var _ref6$width = _ref6.width,
        width = _ref6$width === undefined ? true : _ref6$width,
        _ref6$height = _ref6.height,
        height = _ref6$height === undefined ? true : _ref6$height,
        _ref6$delay = _ref6.delay,
        delay = _ref6$delay === undefined ? 50 : _ref6$delay,
        _ref6$threshold = _ref6.threshold,
        threshold = _ref6$threshold === undefined ? 0 : _ref6$threshold;


    return new __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__["a" /* ZalgoPromise */](function (resolve) {

        var tracker = trackDimensions(el, { width: width, height: height, threshold: threshold });

        var interval = void 0;

        var resolver = Object(__WEBPACK_IMPORTED_MODULE_3__fn__["a" /* debounce */])(function (dimensions) {
            clearInterval(interval);
            return resolve(dimensions);
        }, delay * 4);

        interval = setInterval(function () {
            var _tracker$check = tracker.check(),
                changed = _tracker$check.changed,
                dimensions = _tracker$check.dimensions;

            if (changed) {
                tracker.reset();
                return resolver(dimensions);
            }
        }, delay);

        function onWindowResize() {
            var _tracker$check2 = tracker.check(),
                changed = _tracker$check2.changed,
                dimensions = _tracker$check2.dimensions;

            if (changed) {
                tracker.reset();
                window.removeEventListener('resize', onWindowResize);
                resolver(dimensions);
            }
        }

        window.addEventListener('resize', onWindowResize);
    });
}

function dimensionsMatchViewport(el, _ref7) {
    var width = _ref7.width,
        height = _ref7.height;


    var dimensions = getCurrentDimensions(el);

    if (width && dimensions.width !== window.innerWidth) {
        return false;
    }

    if (height && dimensions.height !== window.innerHeight) {
        return false;
    }

    return true;
}

function bindEvents(element, eventNames, handler) {

    handler = Object(__WEBPACK_IMPORTED_MODULE_3__fn__["e" /* once */])(handler);

    for (var _iterator4 = eventNames, _isArray4 = Array.isArray(_iterator4), _i4 = 0, _iterator4 = _isArray4 ? _iterator4 : _iterator4[Symbol.iterator]();;) {
        var _ref8;

        if (_isArray4) {
            if (_i4 >= _iterator4.length) break;
            _ref8 = _iterator4[_i4++];
        } else {
            _i4 = _iterator4.next();
            if (_i4.done) break;
            _ref8 = _i4.value;
        }

        var eventName = _ref8;

        element.addEventListener(eventName, handler);
    }

    return {
        cancel: Object(__WEBPACK_IMPORTED_MODULE_3__fn__["e" /* once */])(function () {
            for (var _iterator5 = eventNames, _isArray5 = Array.isArray(_iterator5), _i5 = 0, _iterator5 = _isArray5 ? _iterator5 : _iterator5[Symbol.iterator]();;) {
                var _ref9;

                if (_isArray5) {
                    if (_i5 >= _iterator5.length) break;
                    _ref9 = _iterator5[_i5++];
                } else {
                    _i5 = _iterator5.next();
                    if (_i5.done) break;
                    _ref9 = _i5.value;
                }

                var eventName = _ref9;

                element.removeEventListener(eventName, handler);
            }
        })
    };
}

var VENDOR_PREFIXES = ['webkit', 'moz', 'ms', 'o'];

function setVendorCSS(element, name, value) {

    // $FlowFixMe
    element.style[name] = value;

    var capitalizedName = Object(__WEBPACK_IMPORTED_MODULE_4__util__["a" /* capitalizeFirstLetter */])(name);

    for (var _iterator6 = VENDOR_PREFIXES, _isArray6 = Array.isArray(_iterator6), _i6 = 0, _iterator6 = _isArray6 ? _iterator6 : _iterator6[Symbol.iterator]();;) {
        var _ref10;

        if (_isArray6) {
            if (_i6 >= _iterator6.length) break;
            _ref10 = _iterator6[_i6++];
        } else {
            _i6 = _iterator6.next();
            if (_i6.done) break;
            _ref10 = _i6.value;
        }

        var prefix = _ref10;

        // $FlowFixMe
        element.style['' + prefix + capitalizedName] = value;
    }
}

var CSSRule = window.CSSRule;

var KEYFRAMES_RULE = CSSRule.KEYFRAMES_RULE || CSSRule.WEBKIT_KEYFRAMES_RULE || CSSRule.MOZ_KEYFRAMES_RULE || CSSRule.O_KEYFRAMES_RULE || CSSRule.MS_KEYFRAMES_RULE;

function isValidAnimation(element, name) {

    var stylesheets = element.ownerDocument.styleSheets;

    try {
        for (var i = 0; i < stylesheets.length; i++) {

            // $FlowFixMe
            var cssRules = stylesheets[i].cssRules;

            if (!cssRules) {
                continue;
            }

            for (var j = 0; j < cssRules.length; j++) {

                var cssRule = cssRules[j];

                if (!cssRule) {
                    continue;
                }

                if (cssRule.type === KEYFRAMES_RULE && cssRule.name === name) {
                    return true;
                }
            }
        }
    } catch (err) {

        return false;
    }

    return false;
}

var ANIMATION_START_EVENTS = ['animationstart', 'webkitAnimationStart', 'oAnimationStart', 'MSAnimationStart'];
var ANIMATION_END_EVENTS = ['animationend', 'webkitAnimationEnd', 'oAnimationEnd', 'MSAnimationEnd'];

function animate(element, name, clean) {
    var timeout = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1000;

    return new __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__["a" /* ZalgoPromise */](function (resolve, reject) {

        var el = getElement(element);

        if (!el || !isValidAnimation(el, name)) {
            return resolve();
        }

        var hasStarted = false;

        var startTimeout = void 0;
        var endTimeout = void 0;
        var startEvent = void 0;
        var endEvent = void 0;

        function cleanUp() {
            setVendorCSS(el, 'animationName', '');
            clearTimeout(startTimeout);
            clearTimeout(endTimeout);
            startEvent.cancel();
            endEvent.cancel();
        }

        startEvent = bindEvents(el, ANIMATION_START_EVENTS, function (event) {

            if (event.target !== el || event.animationName !== name) {
                return;
            }

            clearTimeout(startTimeout);

            event.stopPropagation();

            startEvent.cancel();
            hasStarted = true;

            endTimeout = setTimeout(function () {
                cleanUp();
                resolve();
            }, timeout);
        });

        endEvent = bindEvents(el, ANIMATION_END_EVENTS, function (event) {

            if (event.target !== el || event.animationName !== name) {
                return;
            }

            cleanUp();

            if (typeof event.animationName === 'string' && event.animationName !== name) {
                return reject('Expected animation name to be ' + name + ', found ' + event.animationName);
            }

            return resolve();
        });

        setVendorCSS(el, 'animationName', name);

        startTimeout = setTimeout(function () {
            if (!hasStarted) {
                cleanUp();
                return resolve();
            }
        }, 200);

        if (clean) {
            clean(cleanUp);
        }
    });
}

var STYLE = {

    DISPLAY: {
        NONE: 'none',
        BLOCK: 'block'
    },

    VISIBILITY: {
        VISIBLE: 'visible',
        HIDDEN: 'hidden'
    },

    IMPORTANT: 'important'
};

function makeElementVisible(element) {
    element.style.setProperty('visibility', '');
}

function makeElementInvisible(element) {
    element.style.setProperty('visibility', STYLE.VISIBILITY.HIDDEN, STYLE.IMPORTANT);
}

function showElement(element) {
    element.style.setProperty('display', '');
}

function hideElement(element) {
    element.style.setProperty('display', STYLE.DISPLAY.NONE, STYLE.IMPORTANT);
}

function destroyElement(element) {
    if (element.parentNode) {
        element.parentNode.removeChild(element);
    }
}

function showAndAnimate(element, name, clean) {
    var animation = animate(element, name, clean);
    showElement(element);
    return animation;
}

function animateAndHide(element, name, clean) {
    return animate(element, name, clean).then(function () {
        hideElement(element);
    });
}

function addClass(element, name) {
    if (element.classList) {
        element.classList.add(name);
    } else if (element.className.split(/\s+/).indexOf(name) === -1) {
        element.className += ' ' + name;
    }
}

function removeClass(element, name) {
    if (element.classList) {
        element.classList.remove(name);
    } else if (element.className.split(/\s+/).indexOf(name) !== -1) {
        element.className = element.className.replace(name, '');
    }
}

function getCurrentScriptDir() {
    console.warn('Do not use xcomponent.getCurrentScriptDir() in production -- browser support is limited');

    if (document.currentScript) {
        return document.currentScript.src.split('/').slice(0, -1).join('/');
    }

    return '.';
}

function getElementName(element) {

    if (typeof element === 'string') {
        return element;
    }

    if (!element || !element.tagName) {
        return '<unknown>';
    }

    var name = element.tagName.toLowerCase();

    if (element.id) {
        name += '#' + element.id;
    } else if (element.className) {
        name += '.' + element.className.split(' ').join('.');
    }

    return name;
}

function isElementClosed(el) {
    if (!el || !el.parentNode) {
        return true;
    }
    return false;
}

function watchElementForClose(element, handler) {
    handler = Object(__WEBPACK_IMPORTED_MODULE_3__fn__["e" /* once */])(handler);

    var interval = void 0;

    if (isElementClosed(element)) {
        handler();
    } else {
        interval = Object(__WEBPACK_IMPORTED_MODULE_4__util__["j" /* safeInterval */])(function () {
            if (isElementClosed(element)) {
                interval.cancel();
                handler();
            }
        }, 50);
    }

    return {
        cancel: function cancel() {
            if (interval) {
                interval.cancel();
            }
        }
    };
}

function getHttpType(contentType, url) {
    return new __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__["a" /* ZalgoPromise */](function (resolve, reject) {

        var req = new window.XMLHttpRequest();

        req.open('GET', url);
        req.setRequestHeader('Accept', contentType);
        req.send(null);

        req.onload = function () {
            resolve(req.responseText);
        };

        req.onerror = function () {
            return reject(new Error('prefetch failed'));
        };
    });
}

function getHTML(url) {
    return getHttpType('text/html', url);
}

function getCSS(url) {
    return getHttpType('text/css', url);
}

function getScript(url) {
    return getHttpType('*/*', url);
}

function prefetchPage(url) {
    return getHTML(url);
}

var JSX_EVENTS = {
    onClick: 'click'
};

function fixScripts(el) {
    var doc = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.document;

    for (var _iterator7 = querySelectorAll(el, 'script'), _isArray7 = Array.isArray(_iterator7), _i7 = 0, _iterator7 = _isArray7 ? _iterator7 : _iterator7[Symbol.iterator]();;) {
        var _ref11;

        if (_isArray7) {
            if (_i7 >= _iterator7.length) break;
            _ref11 = _iterator7[_i7++];
        } else {
            _i7 = _iterator7.next();
            if (_i7.done) break;
            _ref11 = _i7.value;
        }

        var script = _ref11;

        var newScript = doc.createElement('script');
        newScript.text = script.textContent;
        script.parentNode.replaceChild(newScript, script);
    }
}

function jsxDom(name, props, content) {

    name = name.toLowerCase();

    var doc = this && this.createElement ? this : window.document;

    var el = doc.createElement(name);

    for (var prop in props) {
        if (prop in JSX_EVENTS) {
            el.addEventListener(JSX_EVENTS[prop], props[prop]);
        } else if (prop === 'innerHTML') {
            el.innerHTML = props[prop];
            fixScripts(el, doc);
        } else {
            el.setAttribute(prop, props[prop]);
        }
    }

    if (name === 'style') {

        if (typeof content !== 'string') {
            throw new Error('Expected ' + name + ' tag content to be string, got ' + (typeof content === 'undefined' ? 'undefined' : _typeof(content)));
        }

        if (arguments.length > 3) {
            throw new Error('Expected only text content for ' + name + ' tag');
        }

        setStyle(el, content, doc);
    } else if (name === 'iframe') {

        if (arguments.length > 3) {
            throw new Error('Expected only single child node for iframe');
        }

        el.addEventListener('load', function () {
            var win = el.contentWindow;

            if (!win) {
                throw new Error('Expected frame to have contentWindow');
            }

            if (typeof content === 'string') {
                writeToWindow(win, content);
            } else {
                writeElementToWindow(win, content);
            }
        });
    } else if (name === 'script') {

        if (typeof content !== 'string') {
            throw new Error('Expected ' + name + ' tag content to be string, got ' + (typeof content === 'undefined' ? 'undefined' : _typeof(content)));
        }

        if (arguments.length > 3) {
            throw new Error('Expected only text content for ' + name + ' tag');
        }

        el.text = content;
    } else {
        for (var i = 2; i < arguments.length; i++) {
            if (typeof arguments[i] === 'string') {
                el.textContent = arguments[i];
            } else {
                appendChild(el, arguments[i]);
            }
        }
    }

    return el;
}

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = denodeify;
/* harmony export (immutable) */ __webpack_exports__["c"] = promisify;
/* unused harmony export delay */
/* harmony export (immutable) */ __webpack_exports__["a"] = cycle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__ = __webpack_require__(1);


/*  DeNodeify
    ---------

    Turns a method from a function which accepts a callback, into a function which returns a promise.
*/

function denodeify(method) {

    return function () {

        var self = this;
        var args = Array.prototype.slice.call(arguments);

        if (args.length >= method.length) {
            return __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__["a" /* ZalgoPromise */].resolve(method.apply(self, args));
        }

        return new __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__["a" /* ZalgoPromise */](function (resolve, reject) {
            args.push(function (err, result) {

                if (err && !(err instanceof Error)) {
                    throw new Error('Passed non-Error object in callback: [ ' + err + ' ] -- callbacks should either be called with callback(new Error(...)) or callback(null, result).');
                }

                return err ? reject(err) : resolve(result);
            });
            method.apply(self, args);
        });
    };
}

function promisify(method) {
    return function () {
        var _this = this,
            _arguments = arguments;

        return __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](function () {
            return method.apply(_this, _arguments);
        });
    };
}

function delay() {
    var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

    return new __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__["a" /* ZalgoPromise */](function (resolve) {
        setTimeout(resolve, time);
    });
}

function cycle(method) {
    return __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](method).then(function () {
        return cycle(method);
    });
}

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isPerc;
/* harmony export (immutable) */ __webpack_exports__["b"] = isPx;
/* unused harmony export toNum */
/* unused harmony export toPx */
/* harmony export (immutable) */ __webpack_exports__["c"] = toCSS;
/* unused harmony export percOf */
/* unused harmony export normalizeDimension */
function isPerc(str) {
    return typeof str === 'string' && /^[0-9]+%$/.test(str);
}

function isPx(str) {
    return typeof str === 'string' && /^[0-9]+px$/.test(str);
}

function toNum(val) {

    if (typeof val === 'number') {
        return val;
    }

    var match = val.match(/^([0-9]+)(px|%)$/);

    if (!match) {
        throw new Error('Could not match css value from ' + val);
    }

    return parseInt(match[1], 10);
}

function toPx(val) {
    return toNum(val) + 'px';
}

function toCSS(val) {

    if (typeof val === 'number') {
        return toPx(val);
    }

    return isPerc(val) ? val : toPx(val);
}

function percOf(num, perc) {
    return parseInt(num * toNum(perc) / 100, 10);
}

function normalizeDimension(dim, max) {
    if (typeof dim === 'number') {
        return dim;
    } else if (isPerc(dim)) {
        return percOf(max, dim);
    } else if (isPx(dim)) {
        return toNum(dim);
    } else {
        throw new Error('Can not normalize dimension: ' + dim);
    }
}

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = memoized;
/* unused harmony export promise */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__ = __webpack_require__(1);


function memoized(target, name, descriptor) {
    var method = descriptor.value;

    descriptor.value = function memoizedFunction() {

        this.__memoized__ = this.__memoized__ || {};

        if (!this.__memoized__.hasOwnProperty(name)) {
            this.__memoized__[name] = method.apply(this, arguments);
        }

        return this.__memoized__[name];
    };

    descriptor.value.displayName = name + ':memoized';
}

function promise(target, name, descriptor) {
    var method = descriptor.value;

    descriptor.value = function promisifiedFunction() {
        return __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](method, this, arguments);
    };

    descriptor.value.displayName = name + ':promisified';
}

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = setLogLevel;
/* harmony export (immutable) */ __webpack_exports__["b"] = info;
/* harmony export (immutable) */ __webpack_exports__["d"] = warn;
/* harmony export (immutable) */ __webpack_exports__["a"] = error;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_post_robot_src__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_beaver_logger_client__ = __webpack_require__(24);



function setLogLevel(logLevel) {
    if (__WEBPACK_IMPORTED_MODULE_1_beaver_logger_client__["e" /* logLevels */].indexOf(logLevel) === -1) {
        throw new Error('Invalid logLevel: ' + logLevel);
    }
    __WEBPACK_IMPORTED_MODULE_1_beaver_logger_client__["a" /* config */].logLevel = logLevel;
    __WEBPACK_IMPORTED_MODULE_0_post_robot_src__["CONFIG"].LOG_LEVEL = logLevel;
    window.LOG_LEVEL = logLevel;
}

function info(name, event) {
    var payload = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    __WEBPACK_IMPORTED_MODULE_1_beaver_logger_client__["d" /* info */]('xc_' + name + '_' + event, payload);
}

/*  Log Warning
    -----------

    Log a warning
*/

function warn(name, event) {
    var payload = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    __WEBPACK_IMPORTED_MODULE_1_beaver_logger_client__["f" /* warn */]('xc_' + name + '_' + event, payload);
}

/*  Log Error
    ---------

    Log an error
*/

function error(name, event) {
    var payload = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    __WEBPACK_IMPORTED_MODULE_1_beaver_logger_client__["b" /* error */]('xc_' + name + '_' + event, payload);
}

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = init;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__performance__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__logger__ = __webpack_require__(18);






var initiated = false;

function init(conf) {
    Object(__WEBPACK_IMPORTED_MODULE_1__util__["b" /* extend */])(__WEBPACK_IMPORTED_MODULE_0__config__["a" /* config */], conf || {});

    if (initiated) {
        return;
    }

    initiated = true;

    if (__WEBPACK_IMPORTED_MODULE_0__config__["a" /* config */].logPerformance) {
        Object(__WEBPACK_IMPORTED_MODULE_2__performance__["b" /* initPerformance */])();
    }

    if (__WEBPACK_IMPORTED_MODULE_0__config__["a" /* config */].heartbeat) {
        Object(__WEBPACK_IMPORTED_MODULE_2__performance__["a" /* initHeartBeat */])();
    }

    if (__WEBPACK_IMPORTED_MODULE_0__config__["a" /* config */].logUnload) {
        window.addEventListener('beforeunload', function () {
            Object(__WEBPACK_IMPORTED_MODULE_3__logger__["g" /* info */])('window_beforeunload');
            Object(__WEBPACK_IMPORTED_MODULE_3__logger__["f" /* immediateFlush */])({ fireAndForget: true });
        });

        window.addEventListener('unload', function () {
            Object(__WEBPACK_IMPORTED_MODULE_3__logger__["g" /* info */])('window_unload');
            Object(__WEBPACK_IMPORTED_MODULE_3__logger__["f" /* immediateFlush */])({ fireAndForget: true });
        });
    }

    if (__WEBPACK_IMPORTED_MODULE_0__config__["a" /* config */].flushInterval) {
        setInterval(__WEBPACK_IMPORTED_MODULE_3__logger__["d" /* flush */], __WEBPACK_IMPORTED_MODULE_0__config__["a" /* config */].flushInterval);
    }

    if (window.beaverLogQueue) {
        window.beaverLogQueue.forEach(function (payload) {
            Object(__WEBPACK_IMPORTED_MODULE_3__logger__["h" /* log */])(payload.level, payload.event, payload);
        });
        delete window.beaverLogQueue;
    }
}

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = startTransition;
/* harmony export (immutable) */ __webpack_exports__["a"] = endTransition;
/* harmony export (immutable) */ __webpack_exports__["c"] = transition;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__performance__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__logger__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__builders__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__(14);







var windowID = Object(__WEBPACK_IMPORTED_MODULE_3__util__["f" /* uniqueID */])();
var pageID = Object(__WEBPACK_IMPORTED_MODULE_3__util__["f" /* uniqueID */])();

var currentState = __WEBPACK_IMPORTED_MODULE_4__config__["a" /* config */].initial_state_name;
var startTime = void 0;

function startTransition() {
    startTime = Object(__WEBPACK_IMPORTED_MODULE_0__performance__["c" /* now */])();
}

function endTransition(toState) {
    startTime = startTime || Object(__WEBPACK_IMPORTED_MODULE_0__performance__["d" /* reqStartElapsed */])();

    var currentTime = Object(__WEBPACK_IMPORTED_MODULE_0__performance__["c" /* now */])();
    var elapsedTime = void 0;

    if (startTime !== undefined) {
        elapsedTime = parseInt(currentTime - startTime, 0);
    }

    var transitionName = 'transition_' + currentState + '_to_' + toState;

    Object(__WEBPACK_IMPORTED_MODULE_1__logger__["g" /* info */])(transitionName, {
        duration: elapsedTime
    });

    Object(__WEBPACK_IMPORTED_MODULE_1__logger__["l" /* track */])({
        transition: transitionName,
        transition_time: elapsedTime
    });

    Object(__WEBPACK_IMPORTED_MODULE_1__logger__["f" /* immediateFlush */])();

    startTime = currentTime;
    currentState = toState;
    pageID = Object(__WEBPACK_IMPORTED_MODULE_3__util__["f" /* uniqueID */])();
}

function transition(toState) {
    startTransition();
    endTransition(toState);
}

Object(__WEBPACK_IMPORTED_MODULE_2__builders__["c" /* addPayloadBuilder */])(function () {
    return {
        windowID: windowID,
        pageID: pageID
    };
});

Object(__WEBPACK_IMPORTED_MODULE_2__builders__["b" /* addMetaBuilder */])(function () {
    return {
        state: 'ui_' + currentState
    };
});

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = globalFor;
/* unused harmony export localGlobal */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return global; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_cross_domain_utils_src__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(5);



function globalFor(win) {

    if (!Object(__WEBPACK_IMPORTED_MODULE_0_cross_domain_utils_src__["p" /* isSameDomain */])(win)) {
        return;
    }

    if (!win[__WEBPACK_IMPORTED_MODULE_1__constants__["__XCOMPONENT__"]]) {
        win[__WEBPACK_IMPORTED_MODULE_1__constants__["__XCOMPONENT__"]] = {};
    }

    return win[__WEBPACK_IMPORTED_MODULE_1__constants__["__XCOMPONENT__"]];
}

function localGlobal() {
    var global = globalFor(window);

    if (!global) {
        throw new Error('Could not get local global');
    }

    return global;
}

var global = localGlobal();

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/*
 * hi-base32 v0.1.1
 * https://github.com/emn178/hi-base32
 *
 * Copyright 2015, emn178@gmail.com
 *
 * Licensed under the MIT license:
 * http://www.opensource.org/licenses/MIT
 */
;(function (root, undefined) {
  'use strict';

  var NODE_JS = typeof module != 'undefined';
  if (NODE_JS) {
    root = global;
  }

  var BASE32_ENCODE_CHAR = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ234567'.split('');
  var BASE32_DECODE_CHAR = {
    'A': 0, 'B': 1, 'C': 2, 'D': 3, 'E': 4, 'F': 5, 'G': 6, 'H': 7, 'I': 8,
    'J': 9, 'K': 10, 'L': 11, 'M': 12, 'N': 13, 'O': 14, 'P': 15, 'Q': 16,
    'R': 17, 'S': 18, 'T': 19, 'U': 20, 'V': 21, 'W': 22, 'X': 23, 'Y': 24,
    'Z': 25, '2': 26, '3': 27, '4': 28, '5': 29, '6': 30, '7': 31
  };

  var blocks = [0, 0, 0, 0, 0, 0, 0, 0];

  var toUtf8String = function toUtf8String(bytes) {
    var str = '',
        length = bytes.length,
        i = 0,
        followingChars = 0,
        b,
        c;
    while (i < length) {
      b = bytes[i++];
      if (b <= 0x7F) {
        str += String.fromCharCode(b);
        continue;
      } else if (b > 0xBF && b <= 0xDF) {
        c = b & 0x1F;
        followingChars = 1;
      } else if (b <= 0xEF) {
        c = b & 0x0F;
        followingChars = 2;
      } else if (b <= 0xF7) {
        c = b & 0x07;
        followingChars = 3;
      } else {
        throw 'not a UTF-8 string';
      }

      for (var j = 0; j < followingChars; ++j) {
        b = bytes[i++];
        if (b < 0x80 || b > 0xBF) {
          throw 'not a UTF-8 string';
        }
        c <<= 6;
        c += b & 0x3F;
      }
      if (c >= 0xD800 && c <= 0xDFFF) {
        throw 'not a UTF-8 string';
      }
      if (c > 0x10FFFF) {
        throw 'not a UTF-8 string';
      }

      if (c <= 0xFFFF) {
        str += String.fromCharCode(c);
      } else {
        c -= 0x10000;
        str += String.fromCharCode((c >> 10) + 0xD800);
        str += String.fromCharCode((c & 0x3FF) + 0xDC00);
      }
    }
    return str;
  };

  var decodeAsBytes = function decodeAsBytes(base32Str) {
    base32Str = base32Str.replace(/=/g, '');
    var v1,
        v2,
        v3,
        v4,
        v5,
        v6,
        v7,
        v8,
        bytes = [],
        index = 0,
        length = base32Str.length;

    // 4 char to 3 bytes
    for (var i = 0, count = length >> 3 << 3; i < count;) {
      v1 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v2 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v3 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v4 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v5 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v6 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v7 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v8 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      bytes[index++] = (v1 << 3 | v2 >>> 2) & 255;
      bytes[index++] = (v2 << 6 | v3 << 1 | v4 >>> 4) & 255;
      bytes[index++] = (v4 << 4 | v5 >>> 1) & 255;
      bytes[index++] = (v5 << 7 | v6 << 2 | v7 >>> 3) & 255;
      bytes[index++] = (v7 << 5 | v8) & 255;
    }

    // remain bytes
    var remain = length - count;
    if (remain == 2) {
      v1 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v2 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      bytes[index++] = (v1 << 3 | v2 >>> 2) & 255;
    } else if (remain == 4) {
      v1 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v2 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v3 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v4 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      bytes[index++] = (v1 << 3 | v2 >>> 2) & 255;
      bytes[index++] = (v2 << 6 | v3 << 1 | v4 >>> 4) & 255;
    } else if (remain == 5) {
      v1 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v2 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v3 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v4 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v5 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      bytes[index++] = (v1 << 3 | v2 >>> 2) & 255;
      bytes[index++] = (v2 << 6 | v3 << 1 | v4 >>> 4) & 255;
      bytes[index++] = (v4 << 4 | v5 >>> 1) & 255;
    } else if (remain == 7) {
      v1 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v2 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v3 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v4 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v5 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v6 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v7 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      bytes[index++] = (v1 << 3 | v2 >>> 2) & 255;
      bytes[index++] = (v2 << 6 | v3 << 1 | v4 >>> 4) & 255;
      bytes[index++] = (v4 << 4 | v5 >>> 1) & 255;
      bytes[index++] = (v5 << 7 | v6 << 2 | v7 >>> 3) & 255;
    }
    return bytes;
  };

  var encodeAscii = function encodeAscii(str) {
    var v1,
        v2,
        v3,
        v4,
        v5,
        base32Str = '',
        length = str.length;
    for (var i = 0, count = parseInt(length / 5) * 5; i < count;) {
      v1 = str.charCodeAt(i++);
      v2 = str.charCodeAt(i++);
      v3 = str.charCodeAt(i++);
      v4 = str.charCodeAt(i++);
      v5 = str.charCodeAt(i++);
      base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[(v2 << 4 | v3 >>> 4) & 31] + BASE32_ENCODE_CHAR[(v3 << 1 | v4 >>> 7) & 31] + BASE32_ENCODE_CHAR[v4 >>> 2 & 31] + BASE32_ENCODE_CHAR[(v4 << 3 | v5 >>> 5) & 31] + BASE32_ENCODE_CHAR[v5 & 31];
    }

    // remain char
    var remain = length - count;
    if (remain == 1) {
      v1 = str.charCodeAt(i);
      base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[v1 << 2 & 31] + '======';
    } else if (remain == 2) {
      v1 = str.charCodeAt(i++);
      v2 = str.charCodeAt(i);
      base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[v2 << 4 & 31] + '====';
    } else if (remain == 3) {
      v1 = str.charCodeAt(i++);
      v2 = str.charCodeAt(i++);
      v3 = str.charCodeAt(i);
      base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[(v2 << 4 | v3 >>> 4) & 31] + BASE32_ENCODE_CHAR[v3 << 1 & 31] + '===';
    } else if (remain == 4) {
      v1 = str.charCodeAt(i++);
      v2 = str.charCodeAt(i++);
      v3 = str.charCodeAt(i++);
      v4 = str.charCodeAt(i);
      base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[(v2 << 4 | v3 >>> 4) & 31] + BASE32_ENCODE_CHAR[(v3 << 1 | v4 >>> 7) & 31] + BASE32_ENCODE_CHAR[v4 >>> 2 & 31] + BASE32_ENCODE_CHAR[v4 << 3 & 31] + '=';
    }
    return base32Str;
  };

  var encodeUtf8 = function encodeUtf8(str) {
    var v1,
        v2,
        v3,
        v4,
        v5,
        code,
        end = false,
        base32Str = '',
        index = 0,
        i,
        start = 0,
        bytes = 0,
        length = str.length;
    do {
      blocks[0] = blocks[5];
      blocks[1] = blocks[6];
      blocks[2] = blocks[7];
      for (i = start; index < length && i < 5; ++index) {
        code = str.charCodeAt(index);
        if (code < 0x80) {
          blocks[i++] = code;
        } else if (code < 0x800) {
          blocks[i++] = 0xc0 | code >> 6;
          blocks[i++] = 0x80 | code & 0x3f;
        } else if (code < 0xd800 || code >= 0xe000) {
          blocks[i++] = 0xe0 | code >> 12;
          blocks[i++] = 0x80 | code >> 6 & 0x3f;
          blocks[i++] = 0x80 | code & 0x3f;
        } else {
          code = 0x10000 + ((code & 0x3ff) << 10 | str.charCodeAt(++index) & 0x3ff);
          blocks[i++] = 0xf0 | code >> 18;
          blocks[i++] = 0x80 | code >> 12 & 0x3f;
          blocks[i++] = 0x80 | code >> 6 & 0x3f;
          blocks[i++] = 0x80 | code & 0x3f;
        }
      }
      bytes += i - start;
      start = i - 5;
      if (index == length) {
        ++index;
      }
      if (index > length && i < 6) {
        end = true;
      }
      v1 = blocks[0];
      if (i > 4) {
        v2 = blocks[1];
        v3 = blocks[2];
        v4 = blocks[3];
        v5 = blocks[4];
        base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[(v2 << 4 | v3 >>> 4) & 31] + BASE32_ENCODE_CHAR[(v3 << 1 | v4 >>> 7) & 31] + BASE32_ENCODE_CHAR[v4 >>> 2 & 31] + BASE32_ENCODE_CHAR[(v4 << 3 | v5 >>> 5) & 31] + BASE32_ENCODE_CHAR[v5 & 31];
      } else if (i == 1) {
        base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[v1 << 2 & 31] + '======';
      } else if (i == 2) {
        v2 = blocks[1];
        base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[v2 << 4 & 31] + '====';
      } else if (i == 3) {
        v2 = blocks[1];
        v3 = blocks[2];
        base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[(v2 << 4 | v3 >>> 4) & 31] + BASE32_ENCODE_CHAR[v3 << 1 & 31] + '===';
      } else if (i == 4) {
        v2 = blocks[1];
        v3 = blocks[2];
        v4 = blocks[3];
        base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[(v2 << 4 | v3 >>> 4) & 31] + BASE32_ENCODE_CHAR[(v3 << 1 | v4 >>> 7) & 31] + BASE32_ENCODE_CHAR[v4 >>> 2 & 31] + BASE32_ENCODE_CHAR[v4 << 3 & 31] + '=';
      }
    } while (!end);
    return base32Str;
  };

  var encodeBytes = function encodeBytes(bytes) {
    var v1,
        v2,
        v3,
        v4,
        v5,
        base32Str = '',
        length = bytes.length;
    for (var i = 0, count = parseInt(length / 5) * 5; i < count;) {
      v1 = bytes[i++];
      v2 = bytes[i++];
      v3 = bytes[i++];
      v4 = bytes[i++];
      v5 = bytes[i++];
      base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[(v2 << 4 | v3 >>> 4) & 31] + BASE32_ENCODE_CHAR[(v3 << 1 | v4 >>> 7) & 31] + BASE32_ENCODE_CHAR[v4 >>> 2 & 31] + BASE32_ENCODE_CHAR[(v4 << 3 | v5 >>> 5) & 31] + BASE32_ENCODE_CHAR[v5 & 31];
    }

    // remain char
    var remain = length - count;
    if (remain == 1) {
      v1 = bytes[i];
      base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[v1 << 2 & 31] + '======';
    } else if (remain == 2) {
      v1 = bytes[i++];
      v2 = bytes[i];
      base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[v2 << 4 & 31] + '====';
    } else if (remain == 3) {
      v1 = bytes[i++];
      v2 = bytes[i++];
      v3 = bytes[i];
      base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[(v2 << 4 | v3 >>> 4) & 31] + BASE32_ENCODE_CHAR[v3 << 1 & 31] + '===';
    } else if (remain == 4) {
      v1 = bytes[i++];
      v2 = bytes[i++];
      v3 = bytes[i++];
      v4 = bytes[i];
      base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[(v2 << 4 | v3 >>> 4) & 31] + BASE32_ENCODE_CHAR[(v3 << 1 | v4 >>> 7) & 31] + BASE32_ENCODE_CHAR[v4 >>> 2 & 31] + BASE32_ENCODE_CHAR[v4 << 3 & 31] + '=';
    }
    return base32Str;
  };

  var encode = function encode(input, asciiOnly) {
    var notString = typeof input != 'string';
    if (notString && input.constructor == ArrayBuffer) {
      input = new Uint8Array(input);
    }
    if (notString) {
      return encodeBytes(input);
    } else if (asciiOnly) {
      return encodeAscii(input);
    } else {
      return encodeUtf8(input);
    }
  };

  var decode = function decode(base32Str, asciiOnly) {
    if (!asciiOnly) {
      return toUtf8String(decodeAsBytes(base32Str));
    }
    var v1,
        v2,
        v3,
        v4,
        v5,
        v6,
        v7,
        v8,
        str = '',
        length = base32Str.indexOf('=');
    if (length == -1) {
      length = base32Str.length;
    }

    // 8 char to 5 bytes
    for (var i = 0, count = length >> 3 << 3; i < count;) {
      v1 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v2 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v3 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v4 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v5 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v6 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v7 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v8 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      str += String.fromCharCode((v1 << 3 | v2 >>> 2) & 255) + String.fromCharCode((v2 << 6 | v3 << 1 | v4 >>> 4) & 255) + String.fromCharCode((v4 << 4 | v5 >>> 1) & 255) + String.fromCharCode((v5 << 7 | v6 << 2 | v7 >>> 3) & 255) + String.fromCharCode((v7 << 5 | v8) & 255);
    }

    // remain bytes
    var remain = length - count;
    if (remain == 2) {
      v1 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v2 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      str += String.fromCharCode((v1 << 3 | v2 >>> 2) & 255);
    } else if (remain == 4) {
      v1 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v2 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v3 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v4 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      str += String.fromCharCode((v1 << 3 | v2 >>> 2) & 255) + String.fromCharCode((v2 << 6 | v3 << 1 | v4 >>> 4) & 255);
    } else if (remain == 5) {
      v1 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v2 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v3 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v4 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v5 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      str += String.fromCharCode((v1 << 3 | v2 >>> 2) & 255) + String.fromCharCode((v2 << 6 | v3 << 1 | v4 >>> 4) & 255) + String.fromCharCode((v4 << 4 | v5 >>> 1) & 255);
    } else if (remain == 7) {
      v1 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v2 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v3 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v4 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v5 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v6 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v7 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      str += String.fromCharCode((v1 << 3 | v2 >>> 2) & 255) + String.fromCharCode((v2 << 6 | v3 << 1 | v4 >>> 4) & 255) + String.fromCharCode((v4 << 4 | v5 >>> 1) & 255) + String.fromCharCode((v5 << 7 | v6 << 2 | v7 >>> 3) & 255);
    }
    return str;
  };

  decode.asBytes = decodeAsBytes;
  var exports = {
    encode: encode,
    decode: decode
  };
  if (root.HI_BASE32_TEST) {
    exports.toUtf8String = toUtf8String;
  }

  if (!root.HI_BASE32_TEST && NODE_JS) {
    module.exports = exports;
  } else if (root) {
    root.base32 = exports;
  }
})(this);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(65)))

/***/ }),
/* 65 */
/***/ (function(module, exports) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var g;

// This works in non-strict mode
g = function () {
	return this;
}();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1, eval)("this");
} catch (e) {
	// This works if the window reference is available
	if ((typeof window === "undefined" ? "undefined" : _typeof(window)) === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export normalizeChildProp */
/* harmony export (immutable) */ __webpack_exports__["a"] = normalizeChildProps;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_cross_domain_utils_src__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__component__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__component_props__ = __webpack_require__(12);





function normalizeChildProp(component, props, key, value) {

    var prop = component.getProp(key);

    if (!prop) {

        if (component.looseProps) {
            return value;
        }

        throw new Error('Unrecognized prop: ' + key);
    }

    if (typeof prop.childDecorate === 'function') {
        value = prop.childDecorate(value);
    }

    return value;
}

function normalizeChildProps(component, props, origin) {
    var required = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;


    var result = {};

    for (var _iterator = Object.keys(props), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
        var _ref;

        if (_isArray) {
            if (_i >= _iterator.length) break;
            _ref = _iterator[_i++];
        } else {
            _i = _iterator.next();
            if (_i.done) break;
            _ref = _i.value;
        }

        var _key = _ref;


        var prop = component.getProp(_key);
        var value = props[_key];

        if (prop && prop.sameDomain && origin !== Object(__WEBPACK_IMPORTED_MODULE_0_cross_domain_utils_src__["f" /* getDomain */])(window)) {
            continue;
        }

        result[_key] = normalizeChildProp(component, props, _key, value);

        if (prop && prop.alias && !result[prop.alias]) {
            result[prop.alias] = value;
        }
    }

    if (required) {
        for (var _iterator2 = component.getPropNames(), _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
            var _ref2;

            if (_isArray2) {
                if (_i2 >= _iterator2.length) break;
                _ref2 = _iterator2[_i2++];
            } else {
                _i2 = _iterator2.next();
                if (_i2.done) break;
                _ref2 = _i2.value;
            }

            var key = _ref2;

            if (!props.hasOwnProperty(key)) {
                result[key] = normalizeChildProp(component, props, key, props[key]);
            }
        }
    }

    // $FlowFixMe
    return result;
}

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export validateProp */
/* harmony export (immutable) */ __webpack_exports__["a"] = validateProps;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__component__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__component_props__ = __webpack_require__(12);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };




function validateProp(prop, key, value, props) {
    var required = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;


    var hasProp = value !== null && value !== undefined && value !== '';

    if (!hasProp) {
        if (required && prop.required !== false && !prop.hasOwnProperty('def')) {
            throw new Error('Prop is required: ' + key);
        }

        return;
    }

    if (value && typeof value.then === 'function' && prop.promise) {
        return;
    }

    if (prop.type === 'function') {

        if (!(value instanceof Function)) {
            throw new Error('Prop is not of type function: ' + key);
        }
    } else if (prop.type === 'string') {

        if (typeof value !== 'string') {
            throw new Error('Prop is not of type string: ' + key);
        }
    } else if (prop.type === 'object') {

        // Since we're sending everything by post-message, everything must be json serializable

        try {
            JSON.stringify(value);
        } catch (err) {
            throw new Error('Unable to serialize prop: ' + key);
        }
    } else if (prop.type === 'number') {

        if (isNaN(parseInt(value, 10))) {
            throw new Error('Prop is not a number: ' + key);
        }
    }

    if (typeof prop.validate === 'function' && value) {
        prop.validate(value, props);
    }
}

/*  Validate Props
    --------------

    Validate user-defined props. Users can pass props down from the parent into the child component, but first we
    double check the values are what we expect, based on the props spec defined in the original component.
*/

function validateProps(component, props) {
    var required = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;


    props = props || {};

    if (props.env && _typeof(component.url) === 'object' && !component.url[props.env]) {
        throw new Error('Invalid env: ' + props.env);
    }

    // Set aliases

    for (var _iterator = component.getPropNames(), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
        var _ref;

        if (_isArray) {
            if (_i >= _iterator.length) break;
            _ref = _iterator[_i++];
        } else {
            _i = _iterator.next();
            if (_i.done) break;
            _ref = _i.value;
        }

        var key = _ref;


        // $FlowFixMe
        var prop = component.getProp(key);

        if (prop.alias && props.hasOwnProperty(prop.alias)) {

            var value = props[prop.alias];
            delete props[prop.alias];

            if (!props[key]) {
                props[key] = value;
            }
        }
    }

    // First make sure all of the props we were sent are actually valid prop names

    /*
     if (!component.looseProps) {
        for (let key of Object.keys(props)) {
            if (component.getPropNames().indexOf(key) === -1) {
                throw component.error(`Invalid prop: ${key}`);
            }
        }
    }
     */

    // Then loop over the props we expect, and make sure they're all present and valid

    for (var _iterator2 = Object.keys(props), _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
        var _ref2;

        if (_isArray2) {
            if (_i2 >= _iterator2.length) break;
            _ref2 = _iterator2[_i2++];
        } else {
            _i2 = _iterator2.next();
            if (_i2.done) break;
            _ref2 = _i2.value;
        }

        var _key = _ref2;


        // $FlowFixMe
        var _prop = component.getProp(_key);
        var _value = props[_key];

        if (_prop) {
            validateProp(_prop, _key, _value, props, required);
        }
    }

    for (var _iterator3 = component.getPropNames(), _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
        var _ref3;

        if (_isArray3) {
            if (_i3 >= _iterator3.length) break;
            _ref3 = _iterator3[_i3++];
        } else {
            _i3 = _iterator3.next();
            if (_i3.done) break;
            _ref3 = _i3.value;
        }

        var _key2 = _ref3;


        // $FlowFixMe
        var _prop2 = component.getProp(_key2);
        var _value2 = props[_key2];

        if (_prop2 && !props.hasOwnProperty(_key2)) {
            validateProp(_prop2, _key2, _value2, props, required);
        }
    }
}

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DelegateComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_cross_domain_utils_src__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__parent__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__parent_drivers__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__component__ = __webpack_require__(2);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var DelegateComponent = function (_BaseComponent) {
    _inherits(DelegateComponent, _BaseComponent);

    function DelegateComponent(component, source, options) {
        _classCallCheck(this, DelegateComponent);

        var _this = _possibleConstructorReturn(this, _BaseComponent.call(this));

        _this.component = component;
        _this.clean.set('source', source);

        _this.context = options.context;

        _this.props = {
            uid: options.props.uid,
            dimensions: options.props.dimensions,
            onClose: options.props.onClose,
            onDisplay: options.props.onDisplay
        };

        for (var _iterator = component.getPropNames(), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
            var _ref;

            if (_isArray) {
                if (_i >= _iterator.length) break;
                _ref = _iterator[_i++];
            } else {
                _i = _iterator.next();
                if (_i.done) break;
                _ref = _i.value;
            }

            var propName = _ref;

            // $FlowFixMe
            var prop = _this.component.getProp(propName);

            if (prop.allowDelegate) {
                _this.props[propName] = options.props[propName];
            }
        }

        _this.focus = function () {
            if (_this.driver.openOnFocus) {
                try {
                    var win = window.open('', _this.childWindowName);
                    win.focus();
                } catch (err) {
                    // pass
                }
            }
            return options.overrides.focus.call(_this);
        };

        _this.userClose = options.overrides.userClose;
        _this.getDomain = options.overrides.getDomain;
        _this.error = options.overrides.error;
        _this.on = options.overrides.on;

        var delegateOverrides = __WEBPACK_IMPORTED_MODULE_4__parent_drivers__["a" /* RENDER_DRIVERS */][options.context].delegateOverrides;

        for (var _iterator2 = Object.keys(delegateOverrides), _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
            var _ref2;

            if (_isArray2) {
                if (_i2 >= _iterator2.length) break;
                _ref2 = _iterator2[_i2++];
            } else {
                _i2 = _iterator2.next();
                if (_i2.done) break;
                _ref2 = _i2.value;
            }

            var key = _ref2;

            // $FlowFixMe
            _this[key] = __WEBPACK_IMPORTED_MODULE_3__parent__["a" /* ParentComponent */].prototype[key];
        }

        _this.childWindowName = options.childWindowName;

        __WEBPACK_IMPORTED_MODULE_3__parent__["a" /* ParentComponent */].prototype.registerActiveComponent.call(_this);

        _this.watchForClose();
        return _this;
    }

    DelegateComponent.prototype.watchForClose = function watchForClose() {
        var _this2 = this;

        var closeWindowListener = Object(__WEBPACK_IMPORTED_MODULE_0_cross_domain_utils_src__["w" /* onCloseWindow */])(this.source, function () {
            return _this2.destroy();
        }, 3000);
        this.clean.register('destroyCloseWindowListener', closeWindowListener.cancel);
    };

    DelegateComponent.prototype.getOverrides = function getOverrides(context) {

        var delegateOverrides = __WEBPACK_IMPORTED_MODULE_4__parent_drivers__["a" /* RENDER_DRIVERS */][context].delegateOverrides;

        var overrides = {};

        var self = this;

        var _loop = function _loop() {
            if (_isArray3) {
                if (_i3 >= _iterator3.length) return 'break';
                _ref3 = _iterator3[_i3++];
            } else {
                _i3 = _iterator3.next();
                if (_i3.done) return 'break';
                _ref3 = _i3.value;
            }

            var key = _ref3;

            overrides[key] = function () {
                // $FlowFixMe
                return __WEBPACK_IMPORTED_MODULE_3__parent__["a" /* ParentComponent */].prototype[key].apply(self, arguments);
            };
        };

        for (var _iterator3 = Object.keys(delegateOverrides), _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
            var _ref3;

            var _ret = _loop();

            if (_ret === 'break') break;
        }

        return overrides;
    };

    DelegateComponent.prototype.destroy = function destroy() {
        return this.clean.all();
    };

    _createClass(DelegateComponent, [{
        key: 'driver',
        get: function get() {

            if (!this.context) {
                throw new Error('Context not set');
            }

            return __WEBPACK_IMPORTED_MODULE_4__parent_drivers__["a" /* RENDER_DRIVERS */][this.context];
        }
    }]);

    return DelegateComponent;
}(__WEBPACK_IMPORTED_MODULE_2__base__["a" /* BaseComponent */]);

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = validate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index__ = __webpack_require__(2);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };






function validatePropDefinitions(options) {

    if (options.props && !(_typeof(options.props) === 'object')) {
        throw new Error('Expected options.props to be an object');
    }

    if (options.props) {
        for (var _iterator = Object.keys(options.props), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
            var _ref;

            if (_isArray) {
                if (_i >= _iterator.length) break;
                _ref = _iterator[_i++];
            } else {
                _i = _iterator.next();
                if (_i.done) break;
                _ref = _i.value;
            }

            var key = _ref;


            // $FlowFixMe
            var prop = options.props[key];

            if (!prop || !((typeof prop === 'undefined' ? 'undefined' : _typeof(prop)) === 'object')) {
                throw new Error('Expected options.props.' + key + ' to be an object');
            }

            if (!prop.type) {
                throw new Error('Expected prop.type');
            }

            if (__WEBPACK_IMPORTED_MODULE_0__constants__["PROP_TYPES_LIST"].indexOf(prop.type) === -1) {
                throw new Error('Expected prop.type to be one of ' + __WEBPACK_IMPORTED_MODULE_0__constants__["PROP_TYPES_LIST"].join(', '));
            }

            if (prop.required && prop.def) {
                throw new Error('Required prop can not have a default value');
            }
        }
    }
}

function validate(options) {
    // eslint-ignore-line

    if (!options) {
        throw new Error('Expecred options to be passed');
    }

    if (!options.tag || !options.tag.match(/^[a-z0-9-]+$/)) {
        throw new Error('Invalid options.tag: ' + options.tag);
    }

    validatePropDefinitions(options);

    if (options.dimensions) {
        if (options.dimensions && !Object(__WEBPACK_IMPORTED_MODULE_1__lib__["E" /* isPx */])(options.dimensions.width) && !Object(__WEBPACK_IMPORTED_MODULE_1__lib__["D" /* isPerc */])(options.dimensions.width)) {
            throw new Error('Expected options.dimensions.width to be a px or % string value');
        }

        if (options.dimensions && !Object(__WEBPACK_IMPORTED_MODULE_1__lib__["E" /* isPx */])(options.dimensions.height) && !Object(__WEBPACK_IMPORTED_MODULE_1__lib__["D" /* isPerc */])(options.dimensions.height)) {
            throw new Error('Expected options.dimensions.height to be a px or % string value');
        }
    }

    if (options.contexts) {

        if (options.contexts.popup && !false) {
            throw new Error('Popups not supported in this build -- please use the full xcomponent.js build');
        }

        var anyEnabled = false;

        for (var _iterator2 = Object.keys(options.contexts), _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
            var _ref2;

            if (_isArray2) {
                if (_i2 >= _iterator2.length) break;
                _ref2 = _iterator2[_i2++];
            } else {
                _i2 = _iterator2.next();
                if (_i2.done) break;
                _ref2 = _i2.value;
            }

            var context = _ref2;


            if (__WEBPACK_IMPORTED_MODULE_0__constants__["CONTEXT_TYPES_LIST"].indexOf(context) === -1) {
                throw new Error('Unsupported context type: ' + context);
            }

            if (options.contexts && options.contexts[context] || options.contexts && options.contexts[context] === undefined) {
                anyEnabled = true;
            }
        }

        if (!anyEnabled) {
            throw new Error('No context type is enabled');
        }
    }

    if (options.defaultContext) {
        if (__WEBPACK_IMPORTED_MODULE_0__constants__["CONTEXT_TYPES_LIST"].indexOf(options.defaultContext) === -1) {
            throw new Error('Unsupported context type: ' + (options.defaultContext || 'unknown'));
        }

        if (options.contexts && options.defaultContext && !options.contexts[options.defaultContext]) {
            throw new Error('Disallowed default context type: ' + (options.defaultContext || 'unknown'));
        }
    }

    if (!options.url && !options.buildUrl) {
        throw new Error('Expected options.url to be passed');
    }

    if (options.url && options.buildUrl) {
        throw new Error('Can not pass options.url and options.buildUrl');
    }

    if (options.defaultEnv) {
        if (typeof options.defaultEnv !== 'string') {
            throw new Error('Expected options.defaultEnv to be a string');
        }

        if (!options.buildUrl && _typeof(options.url) !== 'object') {
            throw new Error('Expected options.url to be an object mapping env->url');
        }

        if (options.url && _typeof(options.url) === 'object' && !options.url[options.defaultEnv]) {
            throw new Error('No url found for default env: ' + options.defaultEnv);
        }
    }

    if (options.url && _typeof(options.url) === 'object') {

        if (!options.defaultEnv) {
            throw new Error('Must pass options.defaultEnv with env->url mapping');
        }

        for (var _iterator3 = Object.keys(options.url), _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
            var _ref3;

            if (_isArray3) {
                if (_i3 >= _iterator3.length) break;
                _ref3 = _iterator3[_i3++];
            } else {
                _i3 = _iterator3.next();
                if (_i3.done) break;
                _ref3 = _i3.value;
            }

            var env = _ref3;

            if (!options.url[env]) {
                throw new Error('No url specified for env: ' + env);
            }
        }
    }

    if (options.prerenderTemplate && typeof options.prerenderTemplate !== 'function') {
        throw new Error('Expected options.prerenderTemplate to be a function');
    }

    if (options.containerTemplate && typeof options.containerTemplate !== 'function') {
        throw new Error('Expected options.containerTemplate to be a function');
    }
}

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__container__ = __webpack_require__(71);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__container__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__component__ = __webpack_require__(72);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__component__["a"]; });



/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = defaultContainerTemplate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__parent__ = __webpack_require__(10);

/* @jsx jsxDom */



function defaultContainerTemplate(_ref) {
    var id = _ref.id,
        tag = _ref.tag,
        context = _ref.context,
        CLASS = _ref.CLASS,
        outlet = _ref.outlet,
        jsxDom = _ref.jsxDom,
        _ref$dimensions = _ref.dimensions,
        width = _ref$dimensions.width,
        height = _ref$dimensions.height;


    return jsxDom(
        'div',
        { id: id, 'class': CLASS.XCOMPONENT + ' ' + CLASS.XCOMPONENT + '-tag-' + tag + ' ' + CLASS.XCOMPONENT + '-context-' + context },
        jsxDom(
            'style',
            null,
            '\n                    #' + id + ', #' + id + ' > .' + CLASS.OUTLET + ' {\n                        width: ' + width + ';\n                        height: ' + height + ';\n                    }\n\n                    #' + id + ' > .' + CLASS.OUTLET + ' {\n                        display: inline-block;\n                        position: relative;\n                    }\n\n                    #' + id + ' > .' + CLASS.OUTLET + ' > iframe {\n                        height: 100%;\n                        width: 100%;\n                        position: absolute;\n                        top: 0;\n                        left: 0;\n                        transition: opacity .2s ease-in-out;\n                    }\n\n                    #' + id + ' > .' + CLASS.OUTLET + ' > iframe.' + CLASS.VISIBLE + ' {\n                        opacity: 1;\n                    }\n\n                    #' + id + ' > .' + CLASS.OUTLET + ' > iframe.' + CLASS.INVISIBLE + ' {\n                        opacity: 0;\n                    }\n                '
        ),
        outlet
    );
}

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = defaultPrerenderTemplate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__parent__ = __webpack_require__(10);

/* @jsx jsxDom */



function defaultPrerenderTemplate(_ref) {
    var jsxDom = _ref.jsxDom;

    return jsxDom(
        "html",
        null,
        jsxDom(
            "head",
            null,
            jsxDom(
                "style",
                null,
                "\n                        html, body {\n                            width: 100%;\n                            height: 100%;\n                            overflow: hidden;\n                            top: 0;\n                            left: 0;\n                            margin: 0;\n                            text-align: center;\n                        }\n\n                        .spinner {\n                            position: absolute;\n                            max-height: 60vmin;\n                            max-width: 60vmin;\n                            height: 40px;\n                            width: 40px;\n                            top: 50%;\n                            left: 50%;\n                            transform: translateX(-50%) translateY(-50%);\n                            z-index: 10;\n                        }\n\n                        .spinner .loader {\n                            height: 100%;\n                            width: 100%;\n                            box-sizing: border-box;\n                            border: 3px solid rgba(0, 0, 0, .2);\n                            border-top-color: rgba(33, 128, 192, 0.8);\n                            border-radius: 100%;\n                            animation: rotation .7s infinite linear;\n\n                        }\n\n                        @keyframes rotation {\n                            from {\n                                transform: rotate(0deg)\n                            }\n                            to {\n                                transform: rotate(359deg)\n                            }\n                        }\n                    "
            )
        ),
        jsxDom(
            "body",
            null,
            jsxDom(
                "div",
                { "class": "spinner" },
                jsxDom("div", { id: "loader", "class": "loader" })
            )
        )
    );
}

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__script__ = __webpack_require__(74);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "htmlComponent", function() { return __WEBPACK_IMPORTED_MODULE_0__script__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__react__ = __webpack_require__(75);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "react", function() { return __WEBPACK_IMPORTED_MODULE_1__react__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue__ = __webpack_require__(76);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "vue", function() { return __WEBPACK_IMPORTED_MODULE_2__vue__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__angular__ = __webpack_require__(77);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "angular", function() { return __WEBPACK_IMPORTED_MODULE_3__angular__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ember__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ember___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ember__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_4__ember__) if(["htmlComponent","react","vue","angular","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_4__ember__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__glimmer__ = __webpack_require__(79);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "glimmer", function() { return __WEBPACK_IMPORTED_MODULE_5__glimmer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__angular2__ = __webpack_require__(80);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "angular2", function() { return __WEBPACK_IMPORTED_MODULE_6__angular2__["a"]; });








/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return htmlComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__component_component__ = __webpack_require__(2);


var htmlComponent = {
    global: function global() {
        return window.document;
    },
    register: function register(component, document) {

        function render(element) {

            if (!element || !element.tagName || element.tagName.toLowerCase() !== 'script') {
                return;
            }

            if (!element.attributes.type || element.attributes.type.value !== 'application/x-component' || !element.parentNode) {
                return;
            }

            var tag = element.getAttribute('data-component');

            if (!tag || tag !== component.tag) {
                return;
            }

            component.log('instantiate_script_component');

            var props = element.innerText ? eval('(' + element.innerText + ')') // eslint-disable-line no-eval
            : {};

            var container = document.createElement('div');

            if (!element.parentNode) {
                throw new Error('Element has no parent');
            }

            element.parentNode.replaceChild(container, element);

            // $FlowFixMe
            component.render(props, container);
        }

        function scan() {
            var scriptTags = Array.prototype.slice.call(document.getElementsByTagName('script'));

            for (var _iterator = scriptTags, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
                var _ref;

                if (_isArray) {
                    if (_i >= _iterator.length) break;
                    _ref = _iterator[_i++];
                } else {
                    _i = _iterator.next();
                    if (_i.done) break;
                    _ref = _i.value;
                }

                var element = _ref;

                render(element);
            }
        }

        scan();
        document.addEventListener('DOMContentLoaded', scan);
        window.addEventListener('load', scan);

        document.addEventListener('DOMNodeInserted', function (event) {
            // $FlowFixMe
            render(event.target);
        });
    }
};

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return react; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__component_component__ = __webpack_require__(2);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var react = {
    global: function global() {
        if (window.React && window.ReactDOM) {
            return {
                React: window.React,
                ReactDOM: window.ReactDOM
            };
        }
    },
    register: function register(component, _ref) {
        var React = _ref.React,
            ReactDOM = _ref.ReactDOM;


        if (React.createClass) {

            // $FlowFixMe
            component.react = React.createClass({
                displayName: 'react',
                render: function render() {
                    return React.createElement('div', null);
                },
                componentDidMount: function componentDidMount() {
                    component.log('instantiate_react_component');

                    var el = ReactDOM.findDOMNode(this);

                    var parent = component.init(Object(__WEBPACK_IMPORTED_MODULE_0__lib__["t" /* extend */])({}, this.props), null, el);

                    this.setState({ parent: parent });

                    parent.render(el);
                },
                componentDidUpdate: function componentDidUpdate() {

                    if (this.state && this.state.parent) {
                        this.state.parent.updateProps(Object(__WEBPACK_IMPORTED_MODULE_0__lib__["t" /* extend */])({}, this.props));
                    }
                }
            });
        } else {
            // $FlowFixMe
            component.react = function (_React$Component) {
                _inherits(_class, _React$Component);

                function _class() {
                    _classCallCheck(this, _class);

                    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
                }

                _class.prototype.render = function render() {
                    return React.createElement('div', null);
                };

                _class.prototype.componentDidMount = function componentDidMount() {
                    component.log('instantiate_react_component');

                    var el = ReactDOM.findDOMNode(this);

                    var parent = component.init(Object(__WEBPACK_IMPORTED_MODULE_0__lib__["t" /* extend */])({}, this.props), null, el);

                    this.setState({ parent: parent });

                    parent.render(el);
                };

                _class.prototype.componentDidUpdate = function componentDidUpdate() {

                    if (this.state && this.state.parent) {
                        this.state.parent.updateProps(Object(__WEBPACK_IMPORTED_MODULE_0__lib__["t" /* extend */])({}, this.props));
                    }
                };

                return _class;
            }(React.Component);
        }

        return component.react;
    }
};

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return vue; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__component_component__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib__ = __webpack_require__(3);



var vue = {
    global: function global() {},
    register: function register(component) {

        return {
            template: '<div></div>',

            inheritAttrs: false,

            mounted: function mounted() {
                var el = this.$el;

                // $FlowFixMe
                this.parent = component.init(Object(__WEBPACK_IMPORTED_MODULE_1__lib__["t" /* extend */])({}, this.$attrs), null, el);

                this.parent.render(el);
            },
            beforeUpdate: function beforeUpdate() {

                if (this.parent && this.$attrs) {
                    this.parent.updateProps(Object(__WEBPACK_IMPORTED_MODULE_1__lib__["t" /* extend */])({}, this.$attrs));
                }
            }
        };
    }
};

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return angular; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__component_component__ = __webpack_require__(2);



var angular = {
    global: function global() {
        return window.angular;
    },
    register: function register(component, ng) {

        var module = ng.module(component.tag, []).directive(Object(__WEBPACK_IMPORTED_MODULE_0__lib__["i" /* dasherizeToCamel */])(component.tag), function () {

            var scope = {};

            for (var _iterator = component.getPropNames(), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
                var _ref;

                if (_isArray) {
                    if (_i >= _iterator.length) break;
                    _ref = _iterator[_i++];
                } else {
                    _i = _iterator.next();
                    if (_i.done) break;
                    _ref = _i.value;
                }

                var key = _ref;

                scope[key] = '=';
            }

            if (component.looseProps) {
                scope.props = '=';
            }

            return {
                scope: scope,

                restrict: 'E',

                controller: ['$scope', '$element', function ($scope, $element) {

                    if (component.looseProps && !$scope.props) {
                        throw new Error('For angular bindings to work, prop definitions must be passed to xcomponent.create');
                    }

                    component.log('instantiate_angular_component');

                    function safeApply(fn) {
                        if ($scope.$root.$$phase !== '$apply' && $scope.$root.$$phase !== '$digest') {
                            try {
                                $scope.$apply();
                            } catch (err) {
                                console.warn('Error trying to scope.apply on prop function call:', err);
                            }
                        }
                    }

                    var getProps = function getProps() {

                        var scopeProps = void 0;

                        if ($scope.props) {
                            scopeProps = $scope.props;
                        } else {
                            scopeProps = {};
                            for (var _iterator2 = Object.keys(scope), _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
                                var _ref2;

                                if (_isArray2) {
                                    if (_i2 >= _iterator2.length) break;
                                    _ref2 = _iterator2[_i2++];
                                } else {
                                    _i2 = _iterator2.next();
                                    if (_i2.done) break;
                                    _ref2 = _i2.value;
                                }

                                var key = _ref2;

                                scopeProps[key] = $scope[key];
                            }
                        }

                        scopeProps = Object(__WEBPACK_IMPORTED_MODULE_0__lib__["O" /* replaceObject */])(scopeProps, function (value, key, fullKey) {
                            if (typeof value === 'function') {
                                return function () {
                                    var result = value.apply(this, arguments);
                                    safeApply();
                                    return result;
                                };
                            }
                        });

                        return scopeProps;
                    };

                    var parent = component.init(getProps(), null, $element[0]);
                    parent.render($element[0]);

                    $scope.$watch(function () {
                        parent.updateProps(getProps());
                    });
                }]
            };
        });

        return module;
    }
};

/***/ }),
/* 78 */
/***/ (function(module, exports) {



/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return glimmer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__component_component__ = __webpack_require__(2);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var glimmer = {
    global: function global() {},
    register: function register(component, GlimmerComponent) {
        return function (_GlimmerComponent) {
            _inherits(_class, _GlimmerComponent);

            function _class() {
                _classCallCheck(this, _class);

                return _possibleConstructorReturn(this, _GlimmerComponent.apply(this, arguments));
            }

            _class.prototype.didInsertElement = function didInsertElement() {
                component.render(_extends({}, this.args), this.element);
            };

            return _class;
        }(GlimmerComponent);
    }
};

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return angular2; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__component_component__ = __webpack_require__(2);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




/* eslint-disable new-cap, object-shorthand */

var angular2 = {
    global: function global() {},
    register: function register(xcomponent, _ref) {
        var AngularComponent = _ref.Component,
            NgModule = _ref.NgModule,
            ElementRef = _ref.ElementRef,
            NgZone = _ref.NgZone;


        xcomponent.log('initializing angular2 component');

        var getProps = function getProps(component) {
            return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["O" /* replaceObject */])(_extends({}, component.internalProps, component.props), function (value, key, fullKey) {
                if (typeof value === 'function') {
                    return function () {
                        var _this = this,
                            _arguments = arguments;

                        return component.zone.run(function () {
                            return value.apply(_this, _arguments);
                        });
                    };
                }
            });
        };

        var ComponentInstance = AngularComponent({
            selector: xcomponent.tag,
            template: '<div></div>',
            inputs: ['props']
        }).Class({
            constructor: [ElementRef, NgZone, function (elementRef, zone) {
                this.elementRef = elementRef;
                this.zone = zone;
            }],
            ngOnInit: function ngOnInit() {
                var targetElement = this.elementRef.nativeElement;
                var parent = xcomponent.init(getProps(this), null, targetElement);
                parent.render(targetElement);
                this.parent = parent;
            },
            ngOnChanges: function ngOnChanges() {
                if (this.parent) {
                    this.parent.updateProps(getProps(this));
                }
            }
        });

        var ModuleInstance = NgModule({
            declarations: [ComponentInstance],
            exports: [ComponentInstance]
        }).Class({
            constructor: function constructor() {}
        });

        return ModuleInstance;
    }
};

/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// xcomponent.frame.min.js